<template>
  <div class="main-container">
    <div class="container-wrapper converter-workspace">
      <div class="calcolatrice">
        <div
          class="contenitore-prospetti"
          :class="['contenitore', isShifted ? 'shift-left' : '']"
        >
          <!-- Titolo principale -->
          <div class="header">
            <span class="converter-title-icon" aria-hidden="true">
              <img
                src="/Pagina Convertitore/Icona Prospetti Paghe trasparente.png"
                alt=""
              />
            </span>
            <h3 class="titleConvProspetti">
              Convertitore
              <br />
              <span class="titleprospetti">PROSPETTI PAGHE</span>
            </h3>
            <div class="current-plan-container">
              <div :class="['current-plan', currentPlan.toLowerCase()]">
                {{ currentPlan }}
              </div>
            </div>
            <div
              v-if="
                (input_PC === 'DATEV' && datevNewExtractorEnabled) ||
                (input_PC === 'TEAMSYSTEM' && teamsystemNewExtractorEnabled)
              "
              class="ai-converter-badge"
              title="Nuovo estrattore attivo per il software rilevato"
            >
              <i class="fa-solid fa-wand-magic-sparkles"></i>
              <span>IA attiva</span>
            </div>
          </div>
          <div class="headerButtons headersButtonsprospetti">
            <router-link to="/home" class="tool-button">
              <i
                title="Torna alla Home"
                class="fa-solid fa-house back backconv"
              ></i>
            </router-link>
            <router-link to="/home/store" class="tool-button">
              <i
                title="Acquista Coin"
                class="fa-solid fa-cart-shopping storeicon icons-conv"
              >
              </i>
            </router-link>
            <i
              title="Reset del convertitore"
              class="fa-solid fa-arrows-rotate refresh icons-conv"
              @click="refreshConversione"
            >
            </i>
          </div>
          <!-- Contenitore degli input -->
          <div class="input-container">
            <div class="converter-file-actions">
              <label for="fileInput" class="input-label input-label--file"
                >Seleziona file da convertire:</label
              >
              <button
                v-if="filePDF_URL"
                @click="openPDFPreview"
                class="btn btn-secondary anteprimapdf"
              >
                <i class="fa-solid fa-file-pdf" aria-hidden="true"></i>
                Visualizza PDF
              </button>
              <button
                v-if="ExcelRows.length && fileType === 'excel'"
                @click="showExcelModal = true"
                class="anteprimaexcel anteprimaexcel--excel"
              >
                <i class="fa-solid fa-file-excel" aria-hidden="true"></i>
                Visualizza Excel
              </button>
              <button
                v-if="ExcelRows.length && fileType === 'csv'"
                @click="showExcelModal = true"
                class="anteprimaexcel anteprimaexcel--csv"
              >
                <i class="fa-solid fa-file-csv" aria-hidden="true"></i>
                Visualizza CSV
              </button>
            </div>
            <input
              id="fileInput"
              class="file-input"
              type="file"
              ref="fileInput"
              @change="handleFileChange"
              :disabled="fase1 || fase2 || fase3 || calculating || calculating2"
            />
            <small class="converter-formats"
              >Formati supportati: PDF, CSV</small
            >
            <span class="softwaredetected" v-show="input_PC">
              <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
              <span class="softwaredetected-label"
                >Software contabile rilevato</span
              >
              <strong class="input_PC">{{ input_PC }}</strong>
            </span>
            <label for="outputSystem" class="input-label input-label--software">
              Software contabile di conversione:
            </label>
            <select
              v-model="output_PC"
              id="outputSystem"
              class="select-input"
              :disabled="fase2 || fase3 || calculating || calculating2"
            >
              <option disabled selected value="">Seleziona software</option>
              <option value="TEAMSYSTEM">TEAMSYSTEM</option>
              <option value="DATEV">DATEV</option>
              <option value="ZUCCHETTI">ZUCCHETTI</option>
              <option value="SEAC">SEAC</option>
              <option value="SISTEMI">SISTEMI</option>
              <!-- <option value="SISTEMI">SISTEMI</option> -->
            </select>

            <!-- Checkbox per CSV importazione diretta -->
            <!-- Checkbox CSV - Elegante e non invasivo -->
            <div
              v-if="output_PC === 'DATEV' || output_PC === 'TEAMSYSTEM'"
              class="container-checkbox"
              :title="
                ha(user, 'import_csv_diretto')
                  ? 'Genera il file CSV pronto per l\'importazione diretta nel tuo gestionale'
                  : 'Disponibile da piano Plus'
              "
            >
              <input
                type="checkbox"
                class="checkboxversionestesa"
                v-model="flag_csv_import"
                :disabled="
                  fase3 ||
                  calculating ||
                  calculating2 ||
                  !ha(user, 'import_csv_diretto')
                "
                id="csv-import-checkbox"
              />
              <label for="csv-import-checkbox" class="csv-label">
                File .csv per importazione diretta
                <span v-if="!ha(user, 'import_csv_diretto')" class="lock-icon">
                  <i class="fa-solid fa-lock"></i>
                </span>
              </label>
            </div>

            <!-- Checkbox per Versione analitica -->
            <div class="container-checkbox">
              <input
                type="checkbox"
                class="checkboxversionestesa"
                v-model="isExtendedVersion"
                :disabled="fase3 || calculating || calculating2"
                id="extended-version-checkbox"
              />
              <label for="extended-version-checkbox" class="csv-label"
                >Versione analitica</label
              >
              <span class="info-icon">
                <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                <span class="tooltip">
                  La Versione Analitica del prospetto paghe sarà aggiunta ai
                  file convertiti
                </span>
              </span>
            </div>

            <button
              @click="fase_1"
              :disabled="calculating || fase1 || fase2 || fase3"
              class="action-button action-button-prospetti"
            >
              <span v-if="calculating">
                <div class="spinner"></div>
                Elaborazione...
              </span>
              <span v-else
                ><i class="fa-solid fa-play"></i> Avvia conversione</span
              >
            </button>
            <div
              v-if="errorMessage"
              class="converter-error-alert"
              role="alert"
              aria-live="polite"
            >
              <i
                class="fa-solid fa-triangle-exclamation converter-error-alert__icon"
                aria-hidden="true"
              ></i>
              <div class="converter-error-alert__content">
                <strong>{{ errorAlertTitle }}</strong>
                <span>{{ errorMessage }}</span>
              </div>
            </div>
          </div>
          <ProcessingWaitNotice
            v-if="showDelayedMessage"
            :extended="delayedMessageUpdated"
          />
        </div>
      </div>
      <ConverterWelcomePanel
        v-if="!showResult"
        tone="prospetti"
        :description="'Importa i prospetti paghe da PDF o CSV e trasformali in dati\npronti per il tuo software contabile.'"
      />
      <div
        v-show="showResult"
        :class="[
          'result-container',
          showResult ? 'show' : '',
          {
            'result-container--locked': tableInteractionLocked,
            'result-container--datev-pending':
              tableEditingBlockedByDatevSections,
            'result-container--datev-config-open': datevConfigPanelOpen,
            'result-container--quality':
              fase2 && phase2View === 'quality' && !datevConfigPanelOpen,
          },
        ]"
        :aria-busy="tableInteractionLocked ? 'true' : 'false'"
        @beforeinput.capture="preventLockedTableInteraction"
        @click.capture="preventLockedTableInteraction"
        @change.capture="preventLockedTableInteraction"
        @input.capture="preventLockedTableInteraction"
        @keydown.capture="preventLockedTableInteraction"
        @focusin.capture="preventLockedTableInteraction"
      >
        <!--------------------- FASE 1 ---------------------->
        <div v-if="fase1" class="fase1">
          <h3 class="clienti-individuati title-conv">
            PROSPETTI PAGHE INDIVIDUATI
          </h3>
          <p class="numerofaseAttuale">Fase 1 di 3</p>
          <AdminMsFiscalCodeGenerator
            :clients="
              input_PC === 'SEAC' ? vettoreClienti_SEAC : vettoreClienti
            "
            @apply-code="applyAdminMsFiscalCode"
          />
          <!-- Pulsante per espandere/ridurre la tabella -->
          <div class="response-message">
            <div
              class="divclient-table"
              :class="{ expanded: isClientTableExpanded }"
            >
              <table
                class="client-table"
                :class="{ 'client-table-datev': output_PC === 'DATEV' }"
              >
                <thead>
                  <i
                    @click="toggleClientTableExpansion"
                    :class="
                      isClientTableExpanded
                        ? 'fa-solid fa-compress expand-button-clienti'
                        : 'fa-solid fa-expand expand-button-clienti'
                    "
                    title="Espandi / Comprimi Tabella"
                  ></i>
                  <tr>
                    <th v-if="settings.flag_mostra_codice_ditta">
                      Codice ditta
                    </th>
                    <th>Denominazione cliente</th>
                    <th>Data</th>
                    <th>Codice fiscale</th>
                    <th v-if="input_PC === 'SEAC'">
                      Contabilità Ordinaria
                      <button
                        title="Seleziona l'intera colonna"
                        class="btn-select"
                        @click="selezionaColonna(1)"
                      >
                        ✔
                      </button>
                    </th>
                    <th v-if="input_PC === 'SEAC'">
                      Contabilità Semplificata
                      <button
                        disabled
                        title="Seleziona l'intera colonna"
                        class="btn-select"
                        @click="selezionaColonna(2)"
                      >
                        ✔
                      </button>
                    </th>
                    <th v-if="output_PC === 'DATEV'">
                      Piano dei Conti Aziende
                      <button
                        title="Seleziona l'intera colonna"
                        class="btn-select"
                        @click="selezionaColonna(3)"
                      >
                        ✔
                      </button>
                    </th>
                    <th v-if="output_PC === 'DATEV'">
                      Piano dei Conti Lib. Prof.
                      <button
                        title="Seleziona l'intera colonna"
                        class="btn-select"
                        @click="selezionaColonna(4)"
                      >
                        ✔
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(cliente, index) in input_PC === 'SEAC'
                      ? vettoreClienti_SEAC
                      : vettoreClienti"
                    :key="index"
                  >
                    <!-- Codice ditta – input se vuoto, altrimenti testo -->
                    <td v-if="settings.flag_mostra_codice_ditta">
                      <input
                        v-model="cliente[0]"
                        placeholder="Inserisci codice ditta"
                        title="Inserisci Codice ditta"
                        class="input-editable"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        maxlength="8"
                        @input="
                          cliente[0] = $event.target.value.replace(
                            /[^0-9]/g,
                            ''
                          )
                        "
                        :class="{
                          'filled-input':
                            cliente[0] && cliente[0].trim() !== '',
                        }"
                      />
                    </td>

                    <!-- Denominazione (solo nome) -->
                    <td>
                      {{ getNome(cliente[1]) }}
                    </td>

                    <!-- Data estratta -->
                    <td>
                      {{ getData(cliente[1]) }}
                    </td>

                    <!-- Codice fiscale – input se vuoto -->
                    <td>
                      <input
                        v-model.trim="cliente[4]"
                        placeholder="Inserisci Codice fiscale"
                        title="Inserisci Codice fiscale"
                        class="input-editable"
                        maxlength="16"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        :class="{
                          'filled-input':
                            cliente[4] && cliente[4].trim() !== '',
                          'invalid-input':
                            cliente[4] && !isValidCodiceFiscale(cliente[4]),
                        }"
                        @input="formattaCFPI($event, cliente)"
                      />
                    </td>
                    <td v-if="input_PC === 'SEAC'">
                      <input
                        type="radio"
                        :name="'scelta-seac-' + index"
                        :value="1"
                        v-model="vettoreClienti_SEAC[index][2]"
                      />
                    </td>
                    <td v-if="input_PC === 'SEAC'">
                      <input
                        disabled
                        type="radio"
                        :name="'scelta-seac-' + index"
                        :value="2"
                        v-model="vettoreClienti_SEAC[index][2]"
                      />
                    </td>
                    <td v-if="output_PC === 'DATEV'">
                      <input
                        type="radio"
                        :name="'scelta-datev-' + index"
                        :value="1"
                        v-model="vettoreClienti[index][2]"
                      />
                    </td>
                    <td v-if="output_PC === 'DATEV'">
                      <input
                        type="radio"
                        :name="'scelta-datev-' + index"
                        :value="2"
                        v-model="vettoreClienti[index][2]"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="conversion-summary-box document-summary-box"
              :class="{
                'normal-margin':
                  creditiDisponibili &lt; numeroClienti * creditiPerProspettoPaghe,
                'extra-margin':
                  creditiDisponibili >= numeroClienti * creditiPerProspettoPaghe,
              }"
            >
              <div class="summary-row">
                <span class="label">Prospetti paghe individuati:</span>
                <span class="value">{{ numeroClienti }}</span>
              </div>
              <div class="summary-row">
                <span class="label">Clienti individuati:</span>
                <span class="value">{{ prospettiDistinctClientsCount }}</span>
              </div>
              <div class="summary-row">
                <span class="label">Coin disponibili:</span>
                <span class="value">{{ creditiDisponibili }}</span>
              </div>
              <div class="summary-row">
                <span class="label"
                  >Costo di conversione:
                  <span class="info-icon-coin">
                    <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                    <span class="tooltip-coin">
                      I Coin saranno addebitati al Download del file
                    </span>
                  </span></span
                >
                <span class="value"
                  ><span class="costoincoin">{{
                    numeroClienti * creditiPerProspettoPaghe
                  }}</span
                  ><i class="fa-solid fa-coins"></i
                ></span>
              </div>
              <div
                v-if="
                  creditiDisponibili < numeroClienti * creditiPerProspettoPaghe
                "
                class="crediti-insufficienti-msg"
              >
                <i class="fa-solid fa-circle-exclamation warning-icon"></i>
                Non hai Coin a sufficienza
              </div>

              <div
                v-if="
                  creditiDisponibili < numeroClienti * creditiPerProspettoPaghe
                "
                class="acquista-coin-box"
                @click="showCoinPurchase = !showCoinPurchase"
              >
                <i class="fa-solid fa-cart-shopping"></i>
                <span>Acquista Coin</span>
              </div>
            </div>
            <!-- Modal overlay -->
            <div
              v-if="showCoinPurchase"
              class="modal-overlay"
              @click.self="showCoinPurchase = false"
            >
              <div class="modal-content">
                <button class="modal-close" @click="showCoinPurchase = false">
                  &times;
                </button>
                <CoinPurchase
                  :options="conversionOptions"
                  :useInternalModal="false"
                  :loading="isProcessing"
                  :messagePurchase="messagePurchase"
                  @coins-updated="fetchConversionCount"
                />
              </div>
            </div>
            <!--  <div class="gotostore">
            <p>Acquista altre conversioni</p>
            <i class="fa-solid fa-cart-shopping shopicon"></i>
          </div> -->
            <div class="phase-action-row">
              <button
                class="btnfase2"
                @click="fase_2"
                :disabled="
                  calculating2 ||
                  creditiDisponibili * creditiPerProspettoPaghe < numeroClienti
                "
                :title="
                  creditiDisponibili < numeroClienti
                    ? 'Non hai abbastanza Coin disponibili'
                    : ''
                "
              >
                <span v-if="calculating2">
                  <div class="spinner"></div>
                  Elaborazione...
                </span>
                <span v-else>Prosegui conversione</span>
              </button>
              <button
                v-if="hasConversionDiagnostics"
                class="diagnostics-reopen-button"
                :class="diagnosticsReopenSeverity"
                type="button"
                :title="diagnosticsReopenTitle"
                :aria-label="diagnosticsReopenTitle"
                @click="openStoredConversionDiagnostics"
              >
                <i :class="diagnosticsReopenIcon"></i>
                <span
                  v-if="diagnosticsReopenCount"
                  class="diagnostics-reopen-count"
                >
                  {{ diagnosticsReopenCount }}
                </span>
              </button>
            </div>
          </div>
        </div>
        <!--------------------- FASE 2 ---------------------->
        <div v-if="fase2" class="fase2">
          <div class="fase2-topbar">
            <p class="numerofaseAttuale">Fase 2 di 3</p>
            <h3
              class="cod-conto-individuati title-conv"
              :class="{
                'extraction-settings-title': datevConfigPanelOpen,
              }"
            >
              {{
                datevConfigPanelOpen
                  ? "IMPOSTAZIONI DI ESTRAZIONE"
                  : phase2View === "quality"
                  ? "CONTROLLO QUALIT\u00c0 DOCUMENTO"
                  : "CODICI CONTO INDIVIDUATI"
              }}
            </h3>
            <button
              v-if="datevSectionInfos.length > 0"
              type="button"
              class="datev-config-toggle"
              :class="{
                active: datevConfigPanelOpen,
                dirty: hasPendingDatevConfigChanges,
              }"
              :title="
                datevConfigPanelOpen
                  ? 'Chiudi impostazioni di estrazione'
                  : 'Impostazioni di estrazione'
              "
              :aria-label="
                datevConfigPanelOpen
                  ? 'Chiudi impostazioni di estrazione'
                  : 'Apri impostazioni di estrazione'
              "
              :aria-expanded="datevConfigPanelOpen ? 'true' : 'false'"
              aria-controls="datev-config-panel"
              @click="handleDatevConfigToggle"
            >
              <i
                :class="
                  datevConfigPanelOpen
                    ? 'fa-solid fa-xmark'
                    : 'fa-solid fa-gear'
                "
                aria-hidden="true"
              ></i>
              <span>
                {{
                  datevConfigPanelOpen
                    ? "Chiudi impostazioni"
                    : "Impostazioni di estrazione"
                }}
              </span>
              <span
                v-if="showDatevConfigPendingBadge"
                class="datev-config-pending-badge"
                aria-hidden="true"
              >
                !
              </span>
            </button>
          </div>
          <!-- Messaggio di risposta -->
          <div class="response-message">
            <section
              v-if="datevSectionInfos.length > 0 && datevConfigPanelOpen"
              id="datev-config-panel"
              ref="datevConfigPanel"
              class="datev-config-panel"
              @keydown.esc.stop="closeDatevClientMenu"
            >
              <div
                v-if="datevSectionsApplying"
                class="datev-result-loading datev-result-loading--panel"
                role="status"
                aria-live="polite"
              >
                <div class="datev-result-loading-panel">
                  <span
                    class="datev-result-loading-spinner"
                    aria-hidden="true"
                  ></span>
                  <div>
                    <p class="datev-result-loading-title">
                      Ricalcolo sezioni e codici conto
                    </p>
                    <p class="datev-result-loading-message">
                      Estrazione con sezioni aggiornate in corso...
                    </p>
                  </div>
                </div>
              </div>
              <nav
                class="datev-config-tabs"
                aria-label="Sezioni delle impostazioni di estrazione"
              >
                <button
                  type="button"
                  class="datev-config-tab datev-summary-tab"
                  :class="{ active: selectedDatevClientKey === 'summary' }"
                  @click="selectDatevConfigView('summary')"
                >
                  <i class="fa-solid fa-list-check"></i>
                  <span>Riepilogo estrazione</span>
                </button>
                <button
                  type="button"
                  class="datev-config-tab datev-global-tab"
                  :class="{ active: selectedDatevClientKey === 'global' }"
                  @click="selectDatevConfigView('global')"
                >
                  <i class="fa-solid fa-globe"></i>
                  <span>Configurazione globale</span>
                </button>
                <div
                  class="datev-client-tab-control"
                  :class="{
                    active: Boolean(selectedDatevClientGroup),
                    open: datevClientMenuOpen,
                  }"
                >
                  <button
                    type="button"
                    class="datev-config-tab datev-client-tab"
                    :class="{ active: Boolean(selectedDatevClientGroup) }"
                    :disabled="datevSectionsByClient.length === 0"
                    aria-haspopup="listbox"
                    :aria-expanded="datevClientMenuOpen ? 'true' : 'false'"
                    @click.stop="toggleDatevClientMenu"
                  >
                    <i class="fa-solid fa-users"></i>
                    <span class="datev-client-tab-label">
                      <strong>Clienti</strong>
                      <small v-if="selectedDatevClientGroup">
                        {{ selectedDatevClientGroup.denominazione_cliente }}
                      </small>
                    </span>
                    <i
                      :class="
                        datevClientMenuOpen
                          ? 'fa-solid fa-chevron-up'
                          : 'fa-solid fa-chevron-down'
                      "
                      aria-hidden="true"
                    ></i>
                  </button>

                  <div
                    v-if="datevClientMenuOpen"
                    class="datev-client-menu"
                    role="listbox"
                    aria-label="Seleziona cliente"
                  >
                    <label
                      v-if="datevSectionsByClient.length > 7"
                      class="datev-client-menu-search"
                    >
                      <i class="fa-solid fa-magnifying-glass"></i>
                      <input
                        v-model.trim="datevClientSearchQuery"
                        type="search"
                        placeholder="Cerca cliente..."
                        aria-label="Cerca cliente"
                      />
                    </label>
                    <div class="datev-client-menu-list">
                      <button
                        v-for="clientGroup in filteredDatevClientMenuOptions"
                        :key="`menu-${clientGroup.key}`"
                        type="button"
                        role="option"
                        :aria-selected="
                          selectedDatevClientKey === clientGroup.key
                            ? 'true'
                            : 'false'
                        "
                        :class="{
                          active: selectedDatevClientKey === clientGroup.key,
                          customized: isDatevClientCustomized(clientGroup.key),
                        }"
                        @click="selectDatevClientView(clientGroup.key)"
                      >
                        <span class="datev-client-menu-copy">
                          <strong>{{
                            clientGroup.denominazione_cliente
                          }}</strong>
                          <small>
                            Codice ditta {{ clientGroup.codice_ditta }} ·
                            {{ clientGroup.prospetti_count }}
                            {{
                              clientGroup.prospetti_count === 1
                                ? "prospetto"
                                : "prospetti"
                            }}
                          </small>
                        </span>
                        <span class="datev-client-menu-status">
                          <small
                            v-if="isDatevClientCustomized(clientGroup.key)"
                            class="datev-client-custom-count"
                          >
                            Personalizzato
                          </small>
                          <small
                            v-if="clientGroup.excluded_problem_count"
                            class="datev-client-problem-count"
                          >
                            {{ clientGroup.excluded_problem_count }} da
                            verificare
                          </small>
                        </span>
                      </button>
                      <p
                        v-if="filteredDatevClientMenuOptions.length === 0"
                        class="datev-client-menu-empty"
                      >
                        Nessun cliente trovato.
                      </p>
                    </div>
                  </div>
                </div>
              </nav>
              <div class="datev-config-content">
                <div v-if="!isDatevSummaryView" class="datev-config-header">
                  <div class="datev-config-title">
                    <h4>{{ selectedDatevPanelTitle }}</h4>
                    <div
                      v-if="selectedDatevPanelSubtitle"
                      class="datev-config-subtitle"
                    >
                      <span class="datev-config-subtitle-text">
                        {{ selectedDatevPanelSubtitle }}
                      </span>
                      <span
                        v-if="isDatevGlobalView"
                        class="info-tooltip datev-config-info"
                        tabindex="0"
                      >
                        <i class="fa-solid fa-circle-info"></i>
                        <span class="tooltip datev-config-info-tooltip">
                          Puoi decidere di rielaborare il file includendo o
                          escludendo le sezioni individuate nel documento
                        </span>
                      </span>
                    </div>
                    <div
                      v-if="
                        selectedDatevClientGroup &&
                        isDatevClientCustomized(selectedDatevClientGroup.key)
                      "
                      class="datev-client-customization-note"
                    >
                      <span>Configurazione cliente personalizzata</span>
                      <button
                        v-if="canManageSectionPreferences"
                        type="button"
                        @click="
                          resetDatevClientPreferenceToGlobal(
                            selectedDatevClientGroup
                          )
                        "
                      >
                        Usa globale
                      </button>
                    </div>
                  </div>
                  <div class="datev-config-actions">
                    <div
                      v-if="datevCurrentViewHasPreferenceChanges"
                      class="datev-preference-save-panel"
                    >
                      <label
                        class="datev-preference-toggle"
                        :class="{
                          'datev-preference-toggle-disabled':
                            !canManageSectionPreferences,
                        }"
                        :title="datevPersistPermissionTooltip"
                      >
                        <input
                          type="checkbox"
                          v-model="datevCurrentPersistPreference"
                          :disabled="!canManageSectionPreferences"
                        />
                        <span>Salva per conversioni future</span>
                      </label>
                    </div>
                  </div>
                </div>
                <section
                  v-if="isDatevSummaryView"
                  class="datev-summary-introduction"
                  aria-labelledby="datev-summary-introduction-title"
                >
                  <div class="datev-summary-introduction-icon">
                    <i class="fa-solid fa-wand-magic-sparkles"></i>
                  </div>
                  <div class="datev-summary-introduction-copy">
                    <span class="datev-summary-eyebrow">Come funziona</span>
                    <h5 id="datev-summary-introduction-title">
                      Controlla quali sezioni DATEV verranno estratte
                    </h5>
                    <p>
                      DATEV suddivide ogni Prospetto Paghe in sezioni contabili.
                      MyStudio le riconosce e determina quali includere
                      nell'estrazione. Puoi verificare il risultato, applicare
                      una regola comune oppure personalizzare un singolo
                      cliente.
                    </p>
                    <div class="datev-summary-guidance">
                      <span>
                        <i class="fa-solid fa-list-check"></i>
                        Il riepilogo è consultivo
                      </span>
                      <span>
                        <i class="fa-solid fa-globe"></i>
                        La configurazione globale vale per tutti
                      </span>
                      <span>
                        <i class="fa-solid fa-user-gear"></i>
                        Le scelte cliente prevalgono sulla globale
                      </span>
                    </div>
                    <p class="datev-summary-reprocess-note">
                      Le modifiche diventano effettive dopo
                      <strong>Rielabora</strong>. Se scegli di salvarle per le
                      conversioni future, verranno usate nelle elaborazioni
                      successive.
                    </p>
                  </div>
                </section>

                <section
                  v-if="isDatevSummaryView"
                  class="datev-summary-overview"
                  aria-labelledby="datev-summary-overview-title"
                >
                  <div class="datev-summary-overview-heading">
                    <div>
                      <span class="datev-summary-eyebrow">
                        Risultato corrente
                      </span>
                      <h5 id="datev-summary-overview-title">
                        Riepilogo dell'estrazione
                      </h5>
                    </div>
                    <small>Dettaglio in sola lettura</small>
                  </div>
                  <div class="datev-summary-metrics">
                    <article>
                      <i class="fa-solid fa-users"></i>
                      <span>Clienti riconosciuti</span>
                      <strong>{{ datevClientsCount }}</strong>
                    </article>
                    <article>
                      <i class="fa-solid fa-file-invoice"></i>
                      <span>Prospetti Paghe</span>
                      <strong>{{ datevPayslipCount }}</strong>
                    </article>
                    <article>
                      <i class="fa-solid fa-square-check"></i>
                      <span>Sezioni incluse</span>
                      <strong>
                        {{ datevIncludedSectionsCount }} /
                        {{ datevTotalClientSectionsCount }}
                      </strong>
                    </article>
                    <article
                      :class="{
                        warning: datevExcludedProblemSectionsCount > 0,
                      }"
                    >
                      <i class="fa-solid fa-triangle-exclamation"></i>
                      <span>Da verificare</span>
                      <strong>{{ datevExcludedProblemSectionsCount }}</strong>
                    </article>
                  </div>
                  <div class="datev-summary-detail-heading">
                    <strong>Dettaglio per cliente</strong>
                    <span>Sezioni riconosciute e incluse nell'estrazione</span>
                  </div>
                </section>
                <div
                  v-if="datevProblemSectionsCount"
                  class="datev-config-alert"
                >
                  <i class="fa-solid fa-circle-info"></i>
                  <span>{{ datevSectionReviewMessage }}</span>
                </div>
                <div v-if="isDatevGlobalView" class="datev-client-group">
                  <div class="datev-sections-list">
                    <label
                      v-for="section in datevGlobalSections"
                      :key="`global-${section.section_name}`"
                      class="datev-section-row"
                      :class="{
                        excluded: !section.include,
                        partial: section.partial,
                        problem: section.problem,
                        changed: isDatevGlobalSectionChanged(
                          section.section_name
                        ),
                        'changed-included':
                          isDatevGlobalSectionChanged(section.section_name) &&
                          section.include,
                        'changed-excluded':
                          isDatevGlobalSectionChanged(section.section_name) &&
                          !section.include,
                      }"
                    >
                      <input
                        type="checkbox"
                        :checked="section.include"
                        :indeterminate.prop="section.partial"
                        @change="
                          setDatevGlobalSectionInclude(
                            section.section_name,
                            $event.target.checked
                          )
                        "
                      />
                      <span class="datev-section-name">
                        {{ section.section_name || "Sezione senza nome" }}
                      </span>
                      <span
                        v-if="section.problem"
                        class="datev-section-problem-badge"
                      >
                        Problema rilevato
                      </span>
                    </label>
                  </div>
                </div>
                <div
                  v-else
                  v-for="clientGroup in filteredDatevSectionsByClient"
                  :key="clientGroup.key"
                  class="datev-client-group"
                >
                  <div v-if="isDatevSummaryView" class="datev-client-heading">
                    <strong>{{
                      formatDatevClientGroupTitle(clientGroup)
                    }}</strong>
                    <span
                      >{{ clientGroup.included_count }} sezioni incluse</span
                    >
                  </div>
                  <div class="datev-sections-list">
                    <label
                      v-for="section in clientGroup.sections"
                      :key="section.client_section_key"
                      class="datev-section-row"
                      :class="{
                        excluded: !section.include,
                        partial: section.partial,
                        problem: section.problem,
                        accepted: section.accepted_problem,
                        readonly: isDatevSummaryView,
                        changed: isDatevClientSectionChanged(
                          clientGroup,
                          section
                        ),
                        'permanent-diff': isDatevClientSectionPermanentDiff(
                          clientGroup,
                          section
                        ),
                        'permanent-diff-included':
                          isDatevClientSectionPermanentDiff(
                            clientGroup,
                            section
                          ) && section.include,
                        'permanent-diff-excluded':
                          isDatevClientSectionPermanentDiff(
                            clientGroup,
                            section
                          ) && !section.include,
                        'changed-included':
                          isDatevClientSectionChanged(clientGroup, section) &&
                          section.include,
                        'changed-excluded':
                          isDatevClientSectionChanged(clientGroup, section) &&
                          !section.include,
                      }"
                      :title="
                        isDatevClientSectionPermanentDiff(clientGroup, section)
                          ? 'Scelta personalizzata differente dalla principale'
                          : section.detail
                      "
                    >
                      <input
                        type="checkbox"
                        :checked="section.include"
                        :indeterminate.prop="section.partial"
                        :disabled="isDatevSummaryView"
                        @change="
                          !isDatevSummaryView &&
                            setDatevClientSectionInclude(
                              clientGroup.denominazione_cliente,
                              section.section_name,
                              $event.target.checked
                            )
                        "
                      />
                      <span class="datev-section-name">
                        {{ section.section_name || "Sezione senza nome" }}
                      </span>
                      <span
                        v-if="section.problem"
                        class="datev-section-problem-badge"
                      >
                        {{
                          section.accepted_problem
                            ? "Inclusa con avviso"
                            : "Problema rilevato"
                        }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="datev-config-footer">
                <button
                  class="datev-sections-reset"
                  type="button"
                  :disabled="
                    !hasPendingDatevConfigChanges || datevSectionsApplying
                  "
                  title="Annulla le modifiche non rielaborate"
                  @click="resetDatevPendingSectionChanges"
                >
                  <i class="fa-solid fa-rotate-left"></i>
                  Annulla modifiche
                </button>
                <button
                  class="datev-sections-apply"
                  type="button"
                  :disabled="!canApplyDatevSectionChanges"
                  :title="
                    hasPendingDatevConfigChanges
                      ? ''
                      : 'Modifica almeno una sezione per rielaborare'
                  "
                  @click="openDatevReprocessConfirm"
                >
                  <span v-if="datevSectionsApplying">
                    <div class="spinner"></div>
                    Ricalcolo...
                  </span>
                  <span v-else>
                    <i class="fa-solid fa-rotate"></i>
                    Rielabora
                  </span>
                </button>
              </div>
            </section>
            <ConversionDiagnosticsModal
              v-else-if="phase2View === 'quality' && hasQualityDiagnostics"
              :visible="true"
              :summary="conversionDiagnosticsModal.summary"
              :processed-clients="diagnosticsProcessedClients"
              :can-go-back="conversionDiagnosticsModal.notificationIndex > 0"
              :can-review-sections="false"
              :inline="true"
              final-action-label="Vai ai codici conto individuati"
              @close="advanceConversionQuality"
              @back="goBackConversionQuality"
            >
              <template v-if="datevSectionInfos.length > 0" #context-actions>
                <div class="quality-datev-settings-callout">
                  <div class="quality-datev-settings-copy">
                    <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                    <p>
                      Per modificare le sezioni da elaborare e ricalcolare i
                      codici conto, usa le Impostazioni di estrazione in alto a
                      destra.
                    </p>
                  </div>
                </div>
              </template>
            </ConversionDiagnosticsModal>
            <div
              v-if="!datevConfigPanelOpen && phase2View === 'codes'"
              class="fase2-results-body conversion-table-surface"
              :class="{
                'dashboard-table-expanded': currentPdcDashboardExpanded,
                'pdc-client-table-mode': pdcClientTableMode === 'client',
              }"
            >
              <div
                v-if="showPdcTableDashboard"
                class="codconto-table-dashboard"
              >
                <div class="codconto-dashboard-tools">
                  <button
                    type="button"
                    class="codconto-dashboard-button codconto-dashboard-icon-button"
                    :disabled="!currentPdcDashboardHasRows"
                    title="Espandi / comprimi tabella"
                    @click="toggleCurrentPdcTableExpansion"
                  >
                    <i
                      :class="
                        currentPdcDashboardExpanded
                          ? 'fa-solid fa-compress'
                          : 'fa-solid fa-expand'
                      "
                    ></i>
                  </button>
                  <button
                    type="button"
                    class="codconto-dashboard-button"
                    :class="{ active: currentPdcDashboardIsEditing }"
                    :disabled="!canUseCurrentPdcDashboardEdit"
                    :title="currentPdcDashboardEditTitle"
                    @click="toggleCurrentPdcTableEditMode"
                  >
                    <i class="fa-regular fa-pen-to-square"></i>
                    <span>{{ currentPdcDashboardEditLabel }}</span>
                    <i
                      v-if="!ha(user, 'modifica_descrizione_nomi_conto')"
                      class="fa-solid fa-lock lock-icon"
                    ></i>
                  </button>
                  <button
                    type="button"
                    class="codconto-dashboard-button codconto-dashboard-save"
                    :disabled="!currentPdcDashboardHasChanges"
                    title="Salva modifiche"
                    @click="saveCurrentPdcDashboardTable"
                  >
                    <i class="fa-solid fa-floppy-disk"></i>
                    <span>Salva</span>
                  </button>
                  <button
                    type="button"
                    class="codconto-dashboard-button codconto-dashboard-icon-button"
                    :disabled="!currentPdcDashboardCanUndo"
                    title="Annulla ultima modifica"
                    @click="undoCurrentPdcDashboardTable"
                  >
                    <i class="fa-solid fa-rotate-left"></i>
                  </button>
                  <button
                    type="button"
                    class="codconto-dashboard-button codconto-dashboard-reset"
                    :disabled="!currentPdcDashboardHasChanges"
                    title="Annulla tutte le modifiche"
                    @click="resetCurrentPdcDashboardTable"
                  >
                    Annulla
                  </button>
                </div>
                <div class="codconto-dashboard-filters">
                  <div
                    v-show="hasCurrentPdcSavedView"
                    class="pdc-code-view-controls"
                  >
                    <button
                      class="btnPDCvisible"
                      :class="{ active: pdcCodeViewDropdownOpen }"
                      @click.stop="togglePdcCodeViewDropdown"
                    >
                      <i :class="currentPdcCodeViewIcon" class="iconbtnPDC"></i>
                      <span>{{ currentPdcCodeViewLabel }}</span>
                      <i
                        :class="
                          pdcCodeViewDropdownOpen
                            ? 'fa-solid fa-chevron-up'
                            : 'fa-solid fa-chevron-down'
                        "
                        class="toggle-icon"
                      ></i>
                    </button>
                    <div
                      v-if="pdcCodeViewDropdownOpen && hasCurrentPdcSavedView"
                      class="pdc-code-view-menu"
                    >
                      <button
                        type="button"
                        :class="{ active: !vettorePDCVisible }"
                        @click="selectPdcCodeView(false)"
                      >
                        <i class="fa-solid fa-list"></i>
                        <span>Nuovi codici</span>
                      </button>
                      <button
                        type="button"
                        :class="{ active: vettorePDCVisible }"
                        @click="selectPdcCodeView(true)"
                      >
                        <i class="fa-solid fa-book"></i>
                        <span>Gia salvati</span>
                      </button>
                    </div>
                  </div>
                  <div class="pdc-client-view-controls">
                    <button
                      class="pdc-client-view-trigger"
                      type="button"
                      :disabled="!hasPdcClientGroups"
                      :title="
                        hasPdcClientGroups
                          ? 'Seleziona vista clienti'
                          : 'La vista per cliente non e disponibile per questa elaborazione'
                      "
                      @click.stop="togglePdcClientViewDropdown"
                    >
                      <i class="fa-solid fa-users"></i>
                      <span>{{ currentPdcClientSelectionLabel }}</span>
                      <i
                        :class="
                          pdcClientDropdownOpen
                            ? 'fa-solid fa-chevron-up'
                            : 'fa-solid fa-chevron-down'
                        "
                      ></i>
                    </button>
                    <div
                      v-if="pdcClientDropdownOpen && hasPdcClientGroups"
                      class="pdc-client-view-menu"
                    >
                      <div class="pdc-client-view-menu-title">Clienti</div>
                      <button
                        type="button"
                        :class="{ active: pdcClientTableMode === 'all' }"
                        @click="selectAllPdcClientRows"
                      >
                        Tutti
                      </button>
                      <button
                        v-for="client in pdcClientTableOptions"
                        :key="client.key"
                        type="button"
                        :class="{
                          active:
                            pdcClientTableMode === 'client' &&
                            selectedPdcClientKey === client.key,
                        }"
                        @click="selectPdcClientRows(client.key)"
                      >
                        {{ client.label }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="pdcClientTableMode === 'client'"
                class="pdc-client-context-note"
              >
                <i class="fa-solid fa-circle-info"></i>
                <div>
                  <strong>Personalizzazione cliente</strong>
                  <span>
                    Modifica solo i conti che devono essere diversi da
                    <b>Tutti</b>. Gli altri continueranno a seguire la vista
                    <b>Tutti</b>.
                  </span>
                </div>
              </div>
              <div
                v-if="
                  vettoreCodConto.length > 0 || vettoreCodContoPDC.length > 0
                "
                class="pdc-client-view-controls legacy-pdc-floating-control"
              >
                <button
                  class="pdc-client-view-trigger"
                  type="button"
                  :disabled="!hasPdcClientGroups"
                  :title="
                    hasPdcClientGroups
                      ? 'Seleziona vista clienti'
                      : 'La vista per cliente non e disponibile per questa elaborazione'
                  "
                  @click.stop="togglePdcClientViewDropdown"
                >
                  <i class="fa-solid fa-users"></i>
                  <span>{{ currentPdcClientSelectionLabel }}</span>
                  <i
                    :class="
                      pdcClientDropdownOpen
                        ? 'fa-solid fa-chevron-up'
                        : 'fa-solid fa-chevron-down'
                    "
                  ></i>
                </button>
                <div
                  v-if="pdcClientDropdownOpen && hasPdcClientGroups"
                  class="pdc-client-view-menu"
                >
                  <div class="pdc-client-view-menu-title">Clienti</div>
                  <button
                    type="button"
                    :class="{ active: pdcClientTableMode === 'all' }"
                    @click="selectAllPdcClientRows"
                  >
                    Tutti
                  </button>
                  <button
                    v-for="client in pdcClientTableOptions"
                    :key="client.key"
                    type="button"
                    :class="{
                      active:
                        pdcClientTableMode === 'client' &&
                        selectedPdcClientKey === client.key,
                    }"
                    @click="selectPdcClientRows(client.key)"
                  >
                    {{ client.label }}
                  </button>
                </div>
              </div>
              <button
                v-show="hasCurrentPdcSavedView"
                class="btnPDCvisible legacy-pdc-floating-control"
                :class="{ active: pdcCodeViewDropdownOpen }"
                @click.stop="togglePdcCodeViewDropdown"
              >
                <i :class="currentPdcCodeViewIcon" class="iconbtnPDC"></i>
                <span>{{ currentPdcCodeViewLabel }}</span>
                <i
                  :class="
                    pdcCodeViewDropdownOpen
                      ? 'fa-solid fa-chevron-up'
                      : 'fa-solid fa-chevron-down'
                  "
                  class="toggle-icon"
                ></i>
              </button>
              <div
                v-if="pdcCodeViewDropdownOpen && hasCurrentPdcSavedView"
                class="pdc-code-view-menu legacy-pdc-floating-control"
              >
                <button
                  type="button"
                  :class="{ active: !vettorePDCVisible }"
                  @click="selectPdcCodeView(false)"
                >
                  <i class="fa-solid fa-list"></i>
                  <span>Nuovi codici</span>
                </button>
                <button
                  type="button"
                  :class="{ active: vettorePDCVisible }"
                  @click="selectPdcCodeView(true)"
                >
                  <i class="fa-solid fa-book"></i>
                  <span>Già salvati</span>
                </button>
              </div>
              <div
                class="divPDCtable"
                :class="{ 'table-hidden': !vettorePDCVisible }"
              >
                <div
                  v-show="
                    currentCodContoPdcRows.length > 0 && vettorePDCVisible
                  "
                  class="cod_conto_table_divPDC"
                  :class="{ expanded: isTablePDCExpanded }"
                >
                  <table
                    class="codcontotablePDC"
                    :class="
                      output_PC === 'DATEV'
                        ? 'codcontotabledatev'
                        : 'codcontotable'
                    "
                  >
                    <thead>
                      <i
                        @click="toggleTablePDCExpansion"
                        :class="
                          isTablePDCExpanded
                            ? 'fa-solid fa-compress expand-button'
                            : 'fa-solid fa-expand expand-button'
                        "
                        title="Espandi / Comprimi Tabella"
                      ></i>
                      <tr>
                        <th
                          class="headerIndici saved-library-header"
                          title="Già nel tuo Piano dei Conti"
                          aria-label="Già nel tuo Piano dei Conti"
                        >
                          <i
                            class="fa-solid fa-book saved-library-header-icon"
                            aria-hidden="true"
                          ></i>
                        </th>
                        <!-- Numero riga -->
                        <th
                          v-for="(header, index) in filteredHeadersPDC"
                          :key="index"
                          :class="{
                            'datev-column':
                              header === 'Aziende' ||
                              header === 'Liberi Professionisti',
                          }"
                        >
                          <div class="headerscodconto">{{ header }}</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in currentCodContoPdcRows"
                        :key="rowIndex"
                      >
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                        <td
                          v-for="(col, colIndex) in validColumnsPDC"
                          :key="colIndex"
                          :class="[
                            {
                              'datev-column':
                                filteredHeadersPDC[colIndex] ===
                                  'Cod. Conto - Datev Aziende' ||
                                filteredHeadersPDC[colIndex] ===
                                  'Cod. Conto - Datev Lib. Prof.',
                              'italic-text':
                                isNessuno(
                                  currentCodContoPdcRows[rowIndex][col]
                                ) ||
                                hasNessunaCorrelazione(
                                  currentCodContoPdcRows[rowIndex][col]
                                ),
                              'pdc-client-custom-cell':
                                isPdcClientPdcCellSavedDifferentFromGlobal(
                                  rowIndex,
                                  col
                                ),
                            },
                            tableCellEditClasses(
                              currentCodContoPdcTableKey,
                              rowIndex,
                              col,
                              isProspettiCellInvalid(
                                rowIndex,
                                colIndex,
                                currentCodContoPdcRows
                              )
                            ),
                          ]"
                          :title="
                            isPdcClientPdcCellDifferentFromGlobal(rowIndex, col)
                              ? 'Valore personalizzato rispetto alla tabella Tutti'
                              : ''
                          "
                        >
                          <template v-if="isEditableColumnPDC(col)">
                            <div
                              :class="[
                                'prospetti-cell-input',
                                {
                                  'prospetti-cell-input--description':
                                    isCustomProspettiDescription(
                                      rowIndex,
                                      col,
                                      currentCodContoPdcRows
                                    ) ||
                                    isPdcClientPdcCellDifferentFromGlobal(
                                      rowIndex,
                                      col
                                    ),
                                  'prospetti-cell-input--pdc-custom':
                                    isPdcClientPdcCellSavedDifferentFromGlobal(
                                      rowIndex,
                                      col
                                    ),
                                },
                              ]"
                            >
                              <input
                                v-model="currentCodContoPdcRows[rowIndex][col]"
                                type="text"
                                class="editable-input"
                                :class="{
                                  'italic-text':
                                    isNessuno(
                                      currentCodContoPdcRows[rowIndex][col]
                                    ) ||
                                    hasNessunaCorrelazione(
                                      currentCodContoPdcRows[rowIndex][col]
                                    ),
                                }"
                                @input="
                                  handleProspettiCellInput(
                                    currentCodContoPdcTableKey,
                                    rowIndex,
                                    colIndex,
                                    col,
                                    currentCodContoPdcRows
                                  )
                                "
                                @keydown.ctrl.z.exact.prevent="
                                  undoProspettiTable(
                                    currentCodContoPdcTableKey,
                                    currentCodContoPdcRows
                                  )
                                "
                                @keydown.exact="
                                  blockLetters(
                                    $event,
                                    rowIndex,
                                    col,
                                    colIndex,
                                    currentCodContoPdcRows
                                  )
                                "
                                @paste="blockPaste($event, colIndex)"
                                @focus="$event.target.select()"
                              />
                              <span
                                v-if="
                                  isCustomProspettiDescription(
                                    rowIndex,
                                    col,
                                    currentCodContoPdcRows
                                  ) &&
                                  !isPdcClientPdcCellDifferentFromGlobal(
                                    rowIndex,
                                    col
                                  )
                                "
                                class="description-alias-marker"
                                tabindex="0"
                                @mouseenter="
                                  showProspettiDescriptionTooltip(
                                    $event,
                                    rowIndex,
                                    currentCodContoPdcRows
                                  )
                                "
                                @mouseleave="hideProspettiDescriptionTooltip"
                                @focus="
                                  showProspettiDescriptionTooltip(
                                    $event,
                                    rowIndex,
                                    currentCodContoPdcRows
                                  )
                                "
                                @blur="hideProspettiDescriptionTooltip"
                              >
                                <i class="fa-solid fa-user-pen"></i>
                              </span>
                              <span
                                v-if="
                                  isPdcClientPdcCellDifferentFromGlobal(
                                    rowIndex,
                                    col
                                  )
                                "
                                :class="[
                                  'pdc-client-custom-marker',
                                  {
                                    'pdc-client-custom-marker--pending':
                                      !isPdcClientPdcCellSavedDifferentFromGlobal(
                                        rowIndex,
                                        col
                                      ),
                                  },
                                ]"
                                :title="
                                  isPdcClientPdcCellSavedDifferentFromGlobal(
                                    rowIndex,
                                    col
                                  )
                                    ? 'Valore personalizzato salvato rispetto alla tabella Tutti'
                                    : 'Modifica non ancora salvata'
                                "
                              >
                                <i class="fa-solid fa-user-pen"></i>
                              </span>
                            </div>
                          </template>
                          <template v-else>
                            <span
                              :class="[
                                'prospetti-cell-display',
                                {
                                  'prospetti-cell-display--description':
                                    isCustomProspettiDescription(
                                      rowIndex,
                                      col,
                                      currentCodContoPdcRows
                                    ) ||
                                    isPdcClientPdcCellDifferentFromGlobal(
                                      rowIndex,
                                      col
                                    ),
                                  'prospetti-cell-display--pdc-custom':
                                    isPdcClientPdcCellSavedDifferentFromGlobal(
                                      rowIndex,
                                      col
                                    ),
                                },
                              ]"
                            >
                              <span
                                :class="[
                                  'prospetti-cell-text',
                                  tableCellDisplayClasses(
                                    currentCodContoPdcTableKey,
                                    rowIndex,
                                    col,
                                    isProspettiCellInvalid(
                                      rowIndex,
                                      colIndex,
                                      currentCodContoPdcRows
                                    )
                                  ),
                                ]"
                              >
                                {{
                                  formatProspettiCellValue(
                                    currentCodContoPdcRows[rowIndex][col]
                                  )
                                }}
                              </span>
                              <span
                                v-if="
                                  isCustomProspettiDescription(
                                    rowIndex,
                                    col,
                                    currentCodContoPdcRows
                                  ) &&
                                  !isPdcClientPdcCellDifferentFromGlobal(
                                    rowIndex,
                                    col
                                  )
                                "
                                class="description-alias-marker"
                                tabindex="0"
                                @mouseenter="
                                  showProspettiDescriptionTooltip(
                                    $event,
                                    rowIndex,
                                    currentCodContoPdcRows
                                  )
                                "
                                @mouseleave="hideProspettiDescriptionTooltip"
                                @focus="
                                  showProspettiDescriptionTooltip(
                                    $event,
                                    rowIndex,
                                    currentCodContoPdcRows
                                  )
                                "
                                @blur="hideProspettiDescriptionTooltip"
                              >
                                <i class="fa-solid fa-user-pen"></i>
                              </span>
                              <span
                                v-if="
                                  isPdcClientPdcCellDifferentFromGlobal(
                                    rowIndex,
                                    col
                                  )
                                "
                                :class="[
                                  'pdc-client-custom-marker',
                                  {
                                    'pdc-client-custom-marker--pending':
                                      !isPdcClientPdcCellSavedDifferentFromGlobal(
                                        rowIndex,
                                        col
                                      ),
                                  },
                                ]"
                                :title="
                                  isPdcClientPdcCellSavedDifferentFromGlobal(
                                    rowIndex,
                                    col
                                  )
                                    ? 'Valore personalizzato salvato rispetto alla tabella Tutti'
                                    : 'Modifica non ancora salvata'
                                "
                              >
                                <i class="fa-solid fa-user-pen"></i>
                              </span>
                            </span>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  v-if="
                    currentCodContoPdcRows.length === 0 && vettorePDCVisible
                  "
                  class="success-container"
                >
                  <svg
                    class="checkcodicicontoIcon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p class="checkcodiciconto">
                    Nessun Codice Conto gia salvato per questa vista.
                  </p>
                </div>
                <button
                  v-if="currentCodContoPdcRows.length > 0 && vettorePDCVisible"
                  key="edit-btn-pdc"
                  class="edit-buttonPDC"
                  :class="{
                    'active-editbuttonPDC':
                      isEditModePDC &&
                      hasTableChanges(currentCodContoPdcTableKey),
                    'editing-editbuttonPDC':
                      isEditModePDC &&
                      !hasTableChanges(currentCodContoPdcTableKey),
                  }"
                  @click="
                    isEditModePDC
                      ? saveProspettiTable(
                          currentCodContoPdcTableKey,
                          currentCodContoPdcRows
                        )
                      : toggleEditModePDC()
                  "
                  :disabled="
                    !ha(user, 'modifica_descrizione_nomi_conto') ||
                    (tableEditingBlockedByDatevSections && !isEditModePDC)
                  "
                  :title="
                    !ha(user, 'modifica_descrizione_nomi_conto')
                      ? 'Modifica Codici Conto già salvati - Disponibile da piano Plus'
                      : 'Modifica Codici Conto già salvati'
                  "
                >
                  <i
                    :class="
                      isEditModePDC
                        ? 'fa-solid fa-floppy-disk edit-button-icon'
                        : 'fa-regular fa-pen-to-square edit-button-icon'
                    "
                  ></i>
                  <span class="edit-button-text">{{
                    isEditModePDC ? "Salva modifiche" : "Modifica"
                  }}</span>
                  <i
                    v-if="!ha(user, 'modifica_descrizione_nomi_conto')"
                    class="fa-solid fa-lock lock-icon"
                  ></i>
                </button>
                <div
                  v-if="
                    currentCodContoPdcRows.length > 0 &&
                    vettorePDCVisible &&
                    hasTableChanges(currentCodContoPdcTableKey)
                  "
                  class="edit-session-actions"
                >
                  <button
                    class="edit-session-utility"
                    type="button"
                    title="Annulla ultima modifica"
                    :disabled="!hasTableUndo(currentCodContoPdcTableKey)"
                    @click="
                      undoProspettiTable(
                        currentCodContoPdcTableKey,
                        currentCodContoPdcRows
                      )
                    "
                  >
                    <i class="fa-solid fa-rotate-left"></i>
                  </button>
                  <button
                    class="edit-session-utility reset-all"
                    type="button"
                    title="Annulla tutte le modifiche"
                    :disabled="!hasTableChanges(currentCodContoPdcTableKey)"
                    @click="
                      resetProspettiTable(
                        currentCodContoPdcTableKey,
                        isPdcClientTableView ? null : 'vettoreCodContoPDC',
                        isPdcClientTableView ? currentCodContoPdcRows : null
                      )
                    "
                  >
                    Annulla
                  </button>
                </div>
              </div>
              <!-- <transition name="fade"> -->
              <div class="div-codici-conto" v-if="!vettorePDCVisible">
                <div
                  v-if="currentCodContoRows.length > 0 && !vettorePDCVisible"
                  class="cod_conto_table_div"
                  :class="{ expanded: isCodContoTableExpanded }"
                >
                  <table
                    :class="
                      output_PC === 'DATEV'
                        ? 'codcontotabledatev'
                        : 'codcontotable'
                    "
                  >
                    <thead>
                      <i
                        @click="toggleCodContoTableExpansion"
                        :class="
                          isCodContoTableExpanded
                            ? 'fa-solid fa-compress expand-button'
                            : 'fa-solid fa-expand expand-button'
                        "
                        title="Espandi / Comprimi Tabella"
                      ></i>
                      <tr>
                        <th class="headerIndici"></th>
                        <!-- Numero riga -->
                        <th
                          v-for="(header, index) in filteredHeaders"
                          :key="index"
                          :class="{
                            'datev-column':
                              header === 'Aziende' ||
                              header === 'Liberi Professionisti',
                          }"
                        >
                          <div class="headerscodconto header-with-icon">
                            {{ header }}

                            <!-- Icona lucchetto / info solo sulle colonne "Descrizione Codice Conto" -->
                            <span
                              v-if="header.includes('Descrizione Cod. Conto')"
                              class="header-icon-wrapper info-tooltip"
                              tabindex="0"
                            >
                              <i
                                v-if="
                                  !ha(user, 'modifica_descrizione_nomi_conto')
                                "
                                class="fa-solid fa-lock lock-icon-header"
                              ></i>
                              <i
                                v-else
                                class="fa-solid fa-circle-info info-icon-header"
                              ></i>
                              <span class="tooltip header-info-tooltip">
                                {{ nomeContoTooltip }}
                              </span>
                            </span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- Itera sulle righe dell'array originale -->
                      <tr
                        v-for="(row, rowIndex) in currentCodContoRows"
                        :key="rowIndex"
                      >
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                        <!-- Numerazione -->
                        <!-- Per ogni riga, mostra solo le colonne da visualizzare -->
                        <td
                          v-for="(col, colIndex) in validColumns"
                          :key="colIndex"
                          :class="[
                            {
                              'datev-column':
                                filteredHeaders[colIndex] ===
                                  'Cod. Conto - Datev Aziende' ||
                                filteredHeaders[colIndex] ===
                                  'Cod. Conto - Datev Lib. Prof.',
                              'italic-text': hasNessunaCorrelazione(
                                currentCodContoRows[rowIndex][col]
                              ),
                              'pdc-client-custom-cell':
                                isPdcClientCellSavedDifferentFromGlobal(
                                  rowIndex,
                                  col,
                                  currentCodContoRows
                                ),
                            },
                            tableCellEditClasses(
                              currentCodContoTableKey,
                              rowIndex,
                              col,
                              isProspettiCellInvalid(
                                rowIndex,
                                colIndex,
                                currentCodContoRows
                              )
                            ),
                          ]"
                          :title="
                            isPdcClientCellDifferentFromGlobal(
                              rowIndex,
                              col,
                              currentCodContoRows
                            )
                              ? 'Valore personalizzato rispetto alla tabella Tutti'
                              : ''
                          "
                        >
                          <template v-if="isEditableColumn(col)">
                            <div
                              :class="[
                                'prospetti-cell-input',
                                {
                                  'prospetti-cell-input--description':
                                    isCustomProspettiDescription(
                                      rowIndex,
                                      col,
                                      currentCodContoRows
                                    ) ||
                                    isPdcClientCellDifferentFromGlobal(
                                      rowIndex,
                                      col,
                                      currentCodContoRows
                                    ),
                                  'prospetti-cell-input--pdc-custom':
                                    isPdcClientCellSavedDifferentFromGlobal(
                                      rowIndex,
                                      col,
                                      currentCodContoRows
                                    ),
                                },
                              ]"
                            >
                              <input
                                v-model="currentCodContoRows[rowIndex][col]"
                                type="text"
                                class="editable-input"
                                :class="{
                                  'italic-text':
                                    isNessuno(
                                      currentCodContoRows[rowIndex][col]
                                    ) ||
                                    hasNessunaCorrelazione(
                                      currentCodContoRows[rowIndex][col]
                                    ),
                                }"
                                @input="
                                  handleProspettiCellInput(
                                    currentCodContoTableKey,
                                    rowIndex,
                                    colIndex,
                                    col,
                                    currentCodContoRows
                                  )
                                "
                                @keydown.ctrl.z.exact.prevent="
                                  undoProspettiTable(
                                    currentCodContoTableKey,
                                    currentCodContoRows
                                  )
                                "
                                @keydown.exact="
                                  blockLetters(
                                    $event,
                                    rowIndex,
                                    col,
                                    colIndex,
                                    currentCodContoRows
                                  )
                                "
                                @paste="blockPaste($event, colIndex)"
                                @focus="$event.target.select()"
                              />
                              <span
                                v-if="
                                  isCustomProspettiDescription(
                                    rowIndex,
                                    col,
                                    currentCodContoRows
                                  ) &&
                                  !isPdcClientCellDifferentFromGlobal(
                                    rowIndex,
                                    col,
                                    currentCodContoRows
                                  )
                                "
                                class="description-alias-marker"
                                tabindex="0"
                                @mouseenter="
                                  showProspettiDescriptionTooltip(
                                    $event,
                                    rowIndex,
                                    currentCodContoRows
                                  )
                                "
                                @mouseleave="hideProspettiDescriptionTooltip"
                                @focus="
                                  showProspettiDescriptionTooltip(
                                    $event,
                                    rowIndex,
                                    currentCodContoRows
                                  )
                                "
                                @blur="hideProspettiDescriptionTooltip"
                              >
                                <i class="fa-solid fa-user-pen"></i>
                              </span>
                              <span
                                v-if="
                                  isPdcClientCellDifferentFromGlobal(
                                    rowIndex,
                                    col,
                                    currentCodContoRows
                                  )
                                "
                                :class="[
                                  'pdc-client-custom-marker',
                                  {
                                    'pdc-client-custom-marker--pending':
                                      !isPdcClientCellSavedDifferentFromGlobal(
                                        rowIndex,
                                        col
                                      ),
                                  },
                                ]"
                                :title="
                                  isPdcClientCellSavedDifferentFromGlobal(
                                    rowIndex,
                                    col
                                  )
                                    ? 'Valore personalizzato salvato rispetto alla tabella Tutti'
                                    : 'Modifica non ancora salvata'
                                "
                              >
                                <i class="fa-solid fa-user-pen"></i>
                              </span>
                            </div>
                          </template>
                          <template v-else>
                            <span
                              :class="[
                                'prospetti-cell-display',
                                {
                                  'prospetti-cell-display--description':
                                    isCustomProspettiDescription(
                                      rowIndex,
                                      col,
                                      currentCodContoRows
                                    ) ||
                                    isPdcClientCellDifferentFromGlobal(
                                      rowIndex,
                                      col,
                                      currentCodContoRows
                                    ),
                                  'prospetti-cell-display--pdc-custom':
                                    isPdcClientCellSavedDifferentFromGlobal(
                                      rowIndex,
                                      col,
                                      currentCodContoRows
                                    ),
                                },
                              ]"
                            >
                              <span
                                :class="[
                                  'prospetti-cell-text',
                                  tableCellDisplayClasses(
                                    currentCodContoTableKey,
                                    rowIndex,
                                    col,
                                    isProspettiCellInvalid(
                                      rowIndex,
                                      colIndex,
                                      currentCodContoRows
                                    )
                                  ),
                                ]"
                              >
                                {{
                                  formatProspettiCellValue(
                                    currentCodContoRows[rowIndex][col]
                                  )
                                }}
                              </span>
                              <span
                                v-if="
                                  isCustomProspettiDescription(
                                    rowIndex,
                                    col,
                                    currentCodContoRows
                                  ) &&
                                  !isPdcClientCellDifferentFromGlobal(
                                    rowIndex,
                                    col,
                                    currentCodContoRows
                                  )
                                "
                                class="description-alias-marker"
                                tabindex="0"
                                @mouseenter="
                                  showProspettiDescriptionTooltip(
                                    $event,
                                    rowIndex,
                                    currentCodContoRows
                                  )
                                "
                                @mouseleave="hideProspettiDescriptionTooltip"
                                @focus="
                                  showProspettiDescriptionTooltip(
                                    $event,
                                    rowIndex,
                                    currentCodContoRows
                                  )
                                "
                                @blur="hideProspettiDescriptionTooltip"
                              >
                                <i class="fa-solid fa-user-pen"></i>
                              </span>
                              <span
                                v-if="
                                  isPdcClientCellDifferentFromGlobal(
                                    rowIndex,
                                    col,
                                    currentCodContoRows
                                  )
                                "
                                :class="[
                                  'pdc-client-custom-marker',
                                  {
                                    'pdc-client-custom-marker--pending':
                                      !isPdcClientCellSavedDifferentFromGlobal(
                                        rowIndex,
                                        col
                                      ),
                                  },
                                ]"
                                :title="
                                  isPdcClientCellSavedDifferentFromGlobal(
                                    rowIndex,
                                    col
                                  )
                                    ? 'Valore personalizzato salvato rispetto alla tabella Tutti'
                                    : 'Modifica non ancora salvata'
                                "
                              >
                                <i class="fa-solid fa-user-pen"></i>
                              </span>
                            </span>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="success-container">
                  <svg
                    class="checkcodicicontoIcon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p class="checkcodiciconto">
                    Tutti i Codici Conto individuati nel Prospetto Paghe sono
                    già presenti nel tuo
                    <span class="scrittapiano">Piano dei Conti</span>
                  </p>
                </div>
                <button
                  v-if="currentCodContoRows.length > 0 && !vettorePDCVisible"
                  key="edit-btn"
                  class="edit-button"
                  :class="{ 'editing-editbutton': isCurrentCodContoEditMode }"
                  @click="toggleCurrentCodContoEditMode"
                  :disabled="
                    !ha(user, 'modifica_descrizione_nomi_conto') ||
                    (tableEditingBlockedByDatevSections &&
                      !isCurrentCodContoEditMode)
                  "
                  :title="
                    !ha(user, 'modifica_descrizione_nomi_conto')
                      ? currentCodContoEditLockedTitle
                      : currentCodContoEditTitle
                  "
                >
                  <i class="fa-regular fa-pen-to-square edit-button-icon"></i>
                  <span class="edit-button-text">{{
                    isCurrentCodContoEditMode ? "Chiudi" : "Personalizza"
                  }}</span>
                  <!-- Lucchetto se bloccato -->
                  <i
                    v-if="!ha(user, 'modifica_descrizione_nomi_conto')"
                    class="fa-solid fa-lock lock-icon"
                  ></i>
                </button>
                <div
                  v-if="
                    currentCodContoRows.length > 0 &&
                    !vettorePDCVisible &&
                    hasTableChanges(currentCodContoTableKey)
                  "
                  class="edit-session-actions"
                >
                  <button
                    class="edit-button active-editbutton edit-session-save"
                    type="button"
                    title="Salva modifiche"
                    @click="
                      saveProspettiTable(
                        currentCodContoTableKey,
                        currentCodContoRows
                      )
                    "
                  >
                    <i class="fa-solid fa-floppy-disk edit-button-icon"></i>
                    <span class="edit-button-text">Salva modifiche</span>
                  </button>
                  <button
                    class="edit-session-utility"
                    type="button"
                    title="Annulla ultima modifica"
                    :disabled="!hasTableUndo(currentCodContoTableKey)"
                    @click="
                      undoProspettiTable(
                        currentCodContoTableKey,
                        currentCodContoRows
                      )
                    "
                  >
                    <i class="fa-solid fa-rotate-left"></i>
                  </button>
                  <button
                    class="edit-session-utility reset-all"
                    type="button"
                    title="Annulla tutte le modifiche"
                    :disabled="!hasTableChanges(currentCodContoTableKey)"
                    @click="resetCurrentCodContoTable"
                  >
                    Annulla
                  </button>
                </div>
              </div>
              <!-- </transition> -->
            </div>
            <button
              v-if="
                !datevConfigPanelOpen &&
                phase2View === 'codes' &&
                hasQualityDiagnostics
              "
              class="prev-subphase-btn"
              type="button"
              title="Torna al controllo qualità documento"
              aria-label="Torna al controllo qualità documento"
              @click="openStoredConversionDiagnostics"
            >
              <i class="fa-solid fa-arrow-left" aria-hidden="true"></i>
            </button>
            <div
              v-if="!datevConfigPanelOpen && phase2View === 'codes'"
              class="phase-action-row phase2-codes-action-row"
            >
              <button
                class="btnfase2"
                :class="{
                  'blocked-by-datev-sections':
                    hasPendingDatevConfigChanges && !datevSectionsApplying,
                }"
                @click="fase_3"
                :disabled="
                  calculating2 ||
                  datevSectionsApplying ||
                  hasPendingDatevConfigChanges
                "
                :title="
                  hasPendingDatevConfigChanges
                    ? 'Applica prima le modifiche alle sezioni DATEV'
                    : ''
                "
              >
                <span v-if="calculating2">
                  <div class="spinner"></div>
                  Elaborazione...
                </span>
                <span v-else>Converti file</span>
              </button>
            </div>
          </div>
        </div>
        <!--------------------- FASE 3 ---------------------->
        <div v-if="fase3" class="fase3">
          <h3 class="anteprimafase3 title-conv">
            ANTEPRIMA DEI PROSPETTI PAGHE ELABORATI
          </h3>
          <p class="numerofaseAttuale">Fase 3 di 3</p>
          <!-- Messaggio di risposta -->
          <div
            class="response-message"
            v-if="mergedOverall && mergedOverall.length"
          >
            <div
              class="merged-table-container"
              :class="{ expanded: isMergedTableExpanded }"
            >
              <table class="merged-table">
                <tbody>
                  <tr
                    v-for="(row, index) in mergedOverall"
                    :key="index"
                    :class="{
                      bilancino: isBilancino(row),
                      rigaCodDescrizione:
                        index > 0 && isBilancino(mergedOverall[index - 1]),
                    }"
                  >
                    <template v-if="isBilancino(row)">
                      <td colspan="2" class="bilancino">
                        <span class="bilancino-name-text">{{ row[0] }}</span>
                      </td>
                    </template>
                    <template v-else>
                      <td>{{ row[0] }}</td>
                      <td>{{ row[1] }}</td>
                    </template>
                  </tr>
                  <span class="expand-button-merged-span">
                    <i
                      @click="toggleMergedTableExpansion"
                      :class="
                        isMergedTableExpanded
                          ? 'fa-solid fa-compress expand-button-merged'
                          : 'fa-solid fa-expand expand-button-merged'
                      "
                      title="Espandi / Comprimi Tabella"
                    ></i>
                  </span>
                </tbody>
              </table>
            </div>
            <div class="scarica-file">
              <input
                type="checkbox"
                class="checkboxversionestesa"
                v-model="confermaConversione"
              />
              <label
                >Confermo di aver preso visione dei Codici Conto che vengono
                utilizzati per la conversione.</label
              >
              <span class="info-icon2">
                <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                <span class="tooltip2">
                  Mi assumo ogni responsabilità dell'utilizzo dei Codici Conto
                  da me selezionati.
                </span>
              </span>
              <p v-if="filePath">
                Il costo della conversione è di&nbsp;
                <span class="costoincoin">
                  {{ numeroClienti * creditiPerProspettoPaghe }}
                  <i class="fa-solid fa-coins"></i>
                </span>
                <span class="info-icon3">
                  <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                  <span class="tooltip3">
                    Il costo sarà addebitato solo al primo download. Potrai
                    scaricare il file più volte senza spese aggiuntive.
                  </span>
                </span>
              </p>
              <div class="phase-action-row">
                <a
                  v-if="filePath"
                  href="#"
                  @click="handleDownload"
                  class="download"
                  :class="{
                    'disabled-link': !confermaConversione,
                    'already-downloaded': hasDownloaded,
                  }"
                >
                  Download
                </a>
                <button
                  v-if="hasConversionDiagnostics"
                  class="diagnostics-reopen-button"
                  :class="diagnosticsReopenSeverity"
                  type="button"
                  :title="diagnosticsReopenTitle"
                  :aria-label="diagnosticsReopenTitle"
                  @click="openStoredConversionDiagnostics"
                >
                  <i :class="diagnosticsReopenIcon"></i>
                  <span
                    v-if="diagnosticsReopenCount"
                    class="diagnostics-reopen-count"
                  >
                    {{ diagnosticsReopenCount }}
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div class="skeleton-loader" v-if="!mergedOverall">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-text"></div>
            <div class="skeleton skeleton-button"></div>
          </div>
        </div>
      </div>
      <PDFViewer
        v-if="showPDF"
        :visible="showPDF"
        :src="filePDF_URL"
        :title="fileTitle"
        @close="showPDF = false"
      />
      <ExcelViewer
        v-if="showExcelModal"
        :rows="ExcelRows"
        :visible="showExcelModal"
        :title="fileTitle"
        @close="showExcelModal = false"
      />
      <div
        v-if="prospettiDescriptionTooltip.visible"
        class="description-alias-floating-tooltip"
        :class="`description-alias-floating-tooltip--${prospettiDescriptionTooltip.placement}`"
        :style="{
          top: `${prospettiDescriptionTooltip.top}px`,
          left: `${prospettiDescriptionTooltip.left}px`,
        }"
      >
        Descrizione associata a:
        <span class="desc-originale">
          {{ prospettiDescriptionTooltip.content }}
        </span>
      </div>
      <SimpleErrorModal
        :title="erroreModalTitolo"
        :message="erroreModalMessaggio"
        :isVisible="erroreModalVisibile"
        @close="
          erroreModalVisibile = false;
          erroreModalTitolo = 'Attenzione';
        "
      />
      <ConversionDiagnosticsModal
        :visible="conversionDiagnosticsModal.visible"
        :summary="conversionDiagnosticsModal.summary"
        :backend-message="conversionDiagnosticsModal.backendMessage"
        :processed-clients="diagnosticsProcessedClients"
        :can-go-back="canGoBackConversionDiagnosticsModal"
        :can-review-sections="canReviewDatevSectionsFromDiagnostics"
        @close="closeConversionDiagnosticsModal"
        @back="goBackConversionDiagnosticsModal"
        @review-sections="reviewDatevSectionsFromDiagnostics"
      />
      <ConfirmActionModal
        :visible="showResetConfirmModal"
        :title="resetConfirmTitle"
        :eyebrow="resetConfirmEyebrow"
        :message="resetConfirmMessage"
        :confirm-label="resetConfirmConfirmLabel"
        :cancel-label="resetConfirmCancelLabel"
        :icon-class="resetConfirmIconClass"
        :confirm-icon-class="resetConfirmConfirmIconClass"
        :tone="
          ['table-edits', 'table-reset', 'datev-reprocess'].includes(
            resetConfirmContext
          )
            ? 'info'
            : 'danger'
        "
        @close="handleConfirmActionClose"
        @confirm="handleConfirmActionConfirm"
      />
      <div
        v-if="showCausaleModal"
        class="modal-overlay"
        @click.self="closeProspettiCausaleModal"
      >
        <div class="causale-modal-content">
          <button
            type="button"
            class="causale-modal-close"
            aria-label="Chiudi"
            @click="closeProspettiCausaleModal"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <h3>Causale Prospetti Paghe</h3>
          <p>
            Il campo causale non e' presente. Inserisci il campo: il seguente
            valore sara' applicato a tutte le elaborazioni dei prospetti paghe
            esportate in CSV DATEV. Se vorrai potrai modificarlo in seguito
            dalla Libreria Codici Conto.
          </p>
          <input
            v-model.trim="causaleDraft"
            class="causale-input"
            type="text"
            maxlength="4"
            autocomplete="off"
            placeholder="C05"
            @input="handleCausaleDraftInput"
            @keyup.enter="saveProspettiCausale"
          />
          <span v-if="causaleError" class="causale-error">
            {{ causaleError }}
          </span>
          <button
            type="button"
            class="causale-save-button"
            :disabled="savingCausale"
            @click="saveProspettiCausale"
          >
            <i class="fa-solid fa-floppy-disk"></i>
            Salva
          </button>
        </div>
      </div>
      <PageLoadingOverlay
        :visible="isResettingConversion"
        :min-visible-ms="1000"
        :title="
          resetConfirmContext === 'leave'
            ? 'Uscita dal convertitore'
            : 'Reset del convertitore'
        "
        :message="
          resetConfirmContext === 'leave'
            ? 'Interruzione della conversione prima di cambiare pagina...'
            : 'Interruzione della conversione e pulizia dei dati in corso...'
        "
      />
      <ErrorMessageDisplay
        :errors="errorsData"
        :isVisible="showErrorModal"
        @close="showErrorModal = false"
        @fill-na="fillEmptyWithNA"
        @fill-no-corr="fillEmptyWithNoCorr"
        @proceed-warnings="proceedWithWarnings"
      />
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import axios from "axios";
import { API_BASE_URL } from "@/config.js";
import { getUserSettings } from "@/utils/settings.js";
import { haFunzionalita as ha, isPiano } from "@/utils/plans";
import { validFiscalCode } from "@/utils/fiscalCode.js";
import SimpleErrorModal from "../components/SimpleErrorModal.vue";
import ErrorMessageDisplay from "../components/ErrorMessageDisplay.vue";
import PDFViewer from "@/components/PDFViewer.vue";
import ExcelViewer from "@/components/ExcelViewer.vue";
import CoinPurchase from "@/components/CoinPurchase.vue";
import ConfirmActionModal from "@/components/ConfirmActionModal.vue";
import ConversionDiagnosticsModal from "@/components/ConversionDiagnosticsModal.vue";
import PageLoadingOverlay from "@/components/PageLoadingOverlay.vue";
import ProcessingWaitNotice from "@/components/ProcessingWaitNotice.vue";
import ConverterWelcomePanel from "@/components/ConverterWelcomePanel.vue";
import converterTableEditSession from "@/mixins/converterTableEditSession.js";
import AdminMsFiscalCodeGenerator from "@/components/AdminMsFiscalCodeGenerator.vue";
import {
  confirmClientRegistryAssociations,
  isClientRegistryConfirmation,
} from "@/utils/clientRegistryConfirmation.js";

export default {
  name: "ConvProspettiPaghe",
  mixins: [converterTableEditSession],
  components: {
    SimpleErrorModal,
    ErrorMessageDisplay,
    PDFViewer,
    ExcelViewer,
    CoinPurchase,
    ConfirmActionModal,
    ConversionDiagnosticsModal,
    PageLoadingOverlay,
    ProcessingWaitNotice,
    ConverterWelcomePanel,
    AdminMsFiscalCodeGenerator,
  },
  data() {
    return {
      currentPlan: "",
      msg: "",
      userEmail: "", // Inizialmente vuoto, verrà impostato successivamente
      selectedFile: null,
      filePDF_URL: null,
      fileTitle: null,
      jobId: null,
      jobStatus: null,
      jobPollTimer: null,
      isCancelling: false,
      finalConversionInProgress: false,
      showPDF: false,
      showExcelModal: false,
      ExcelRows: [],
      datevSectionInfos: [],
      originalDatevSectionInfos: [],
      datevAnomalySectionKeys: [],
      datevSectionsApplying: false,
      datevConfigPanelOpen: false,
      selectedDatevClientKey: "summary",
      datevClientMenuOpen: false,
      datevClientSearchQuery: "",
      datevPersistGlobalPreference: false,
      datevPersistClientPreferences: {},
      datevGlobalPreferenceValues: {},
      datevSavedClientPreferenceKeys: [],
      datevSavedClientPreferenceMaps: {},
      datevPendingClientPreferenceDeletes: {},
      datevGlobalSectionIncludeMap: {},
      originalDatevGlobalSectionIncludeMap: {},
      canManageSectionPreferences: false,
      fileType: "",
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      inputPcEditable: true, // Di default è abilitato
      excelPath: null,
      mergedOverall: null,
      hasDownloaded: false,
      hasOutputDownloadStarted: false,
      input_file_path: null,
      filePath: null,
      vettoreClienti: [],
      vettoreClienti_SEAC: [],
      vettoreCodConto: [],
      vettoreCodContoPDC: [],
      pdcClientGroups: {
        global: [],
        global_pdc: [],
        custom: [],
        custom_pdc: [],
        non_custom: [],
        non_custom_pdc: [],
      },
      clientCustomPdcEntries: {},
      pdcClientTableMode: "all",
      selectedPdcClientKey: "",
      pdcClientDropdownOpen: false,
      pdcCodeViewDropdownOpen: false,
      isEditModePdcClient: false,
      pdcClientGroupsToPersist: {},
      pdcClientGroupRowIndexesToPersist: {},
      pdcClientCustomRowKeysToRemove: {},
      pdcClientPdcGroupRowIndexesToPersist: {},
      pdcClientPdcCustomRowKeysToRemove: {},
      prospettiDescriptionTooltip: {
        visible: false,
        content: "",
        top: 0,
        left: 0,
        placement: "below",
      },
      originalPDC: null,
      headers: [
        "Descrizione nel Prospetto Paghe - Originale", // Index 0
        "Descrizione nel Prospetto Paghe", // Index 1
        "Cod. Conto - TeamSystem", // Index 2
        "Cod. Conto - Datev Aziende", // Index 3
        "Cod. Conto - Datev Lib. Prof.", // Index 4
        "Cod. Conto - Zucchetti", // Index 5
        "Cod. Conto - SEAC", // Index 6
        "Cod. Conto - Sistemi", // Index 7
        "Descrizione Cod. Conto", // Index 8
        "Descrizione Cod. Conto 2", // Index 9
        "DARE", // Index 10
        "AVERE", // Index 11
      ],
      fase0: false,
      fase1: false,
      fase2: false,
      fase3: false,
      phase2View: "codes",
      numeroClienti: 0,
      creditiPerProspettoPaghe: 0,
      calculating: false, // Variabile per controllare la visibilità del messaggio di calcolo in corso nella fase di Avvia conversione
      calculating2: false, // Variabile per controllare la visibilità del messaggio di calcolo in corso nelle fasi successsive
      input_PC: "",
      output_PC: "",
      showInfoMenu: false, // Variabile per mostrare/nascondere il menu informazioni
      showDictionaryMenu: false, // Variabile per mostrare/nascondere il menu utente
      showAccountMenu: false, // Variabile per mostrare/nascondere il menu piano conti
      isExtendedVersion: false, // Aggiunto per gestire lo stato del toggle
      flag_output_std: false,
      flag_csv_import: false,
      causaleProspettiPaghe: "",
      causaleDraft: "",
      causaleError: "",
      codContoDefault: "11/11/111",
      showCausaleModal: false,
      savingCausale: false,
      retryFase1AfterCausale: false,
      retryFase2AfterCausale: false,
      retryFase3AfterCausale: false,
      errorMessage: "",
      isShifted: false, // Nuova proprietà per controllare lo spostamento 1
      showResult: false, // Nuova proprietà per controllare lo spostamento 2
      isTableExpanded: false, // Controlla se la tabella è espansa
      isClientTableExpanded: false,
      isCodContoTableExpanded: false,
      isMergedTableExpanded: false,
      isTablePDCExpanded: false,
      creditiDisponibili: 0,
      conversioniEffettuate: 0,
      confermaConversione: false,
      showDelayedMessage: false,
      datevNewExtractorEnabled: false,
      teamsystemNewExtractorEnabled: false,
      delayedMessageUpdated: false,
      delayTimer: null,
      updateTimer: null,
      erroreModalVisibile: false,
      erroreModalTitolo: "Attenzione",
      erroreModalMessaggio: "",
      conversionDiagnosticsModal: {
        visible: false,
        summary: null,
        rootSummary: null,
        backendMessage: "",
        notificationQueue: [],
        notificationIndex: 0,
      },
      showResetConfirmModal: false,
      isResettingConversion: false,
      resetConfirmContext: "reset",
      resetConfirmTitle: "Interrompere la conversione?",
      resetConfirmEyebrow: "Reset convertitore",
      resetConfirmMessage:
        "La conversione è ancora in corso. Interrompendo l'elaborazione la pagina verrà azzerata.",
      resetConfirmConfirmLabel: "Interrompi e resetta",
      resetConfirmCancelLabel: "Annulla",
      resetConfirmIconClass: "fa-solid fa-triangle-exclamation",
      resetConfirmConfirmIconClass: "fa-solid fa-arrows-rotate",
      pendingRouteLeaveNext: null,
      pendingRouteLeaveTarget: null,
      pendingTableReset: null,
      showErrorModal: false,
      errorsData: [],
      showCoinPurchase: false,
      restoringFile: false,
      isEditMode: false,
      isEditModePDC: false,
      vettorePDCVisible: false,
      naConfirmed: false,
      noCorrConfirmed: false,
      settings: {
        flag_saldoProspettiPaghe: true,
        flag_saldoF24: true,
        flag_accorpato: false,
        software_contabile: "default",
        flag_mostra_codice_ditta: true, // default prudente
        // ← qui in futuro aggiungi altri flag senza toccare altro
      },
    };
  },
  computed: {
    user() {
      const data = localStorage.getItem("user");
      return data ? JSON.parse(data) : null;
    },
    errorAlertTitle() {
      const message = String(this.errorMessage || "").toLowerCase();
      if (message.includes("formato")) return "Formato file non valido";
      if (message.includes("software")) return "Selezione richiesta";
      if (message.includes("annullata")) return "Conversione annullata";
      return "Operazione non completata";
    },
    tableInteractionLocked() {
      return (
        this.calculating2 ||
        this.finalConversionInProgress ||
        this.tableEditingBlockedByDatevSections
      );
    },
    tableEditingBlockedByDatevSections() {
      return this.hasPendingDatevConfigChanges && !this.datevSectionsApplying;
    },
    datevIncludedSectionsCount() {
      return this.datevSectionsByClient.reduce(
        (count, clientGroup) =>
          count +
          clientGroup.sections.filter((section) => section.include).length,
        0
      );
    },
    datevTotalClientSectionsCount() {
      return this.datevSectionsByClient.reduce(
        (count, clientGroup) => count + clientGroup.sections.length,
        0
      );
    },
    datevClientsCount() {
      return this.datevSectionsByClient.length;
    },
    datevPayslipCount() {
      const payslipKeys = new Set(
        this.datevSectionInfos.map((section) =>
          [
            section.codice_ditta || "",
            section.denominazione_cliente || "",
            section.month || "",
            section.year || "",
          ].join("|")
        )
      );
      return payslipKeys.size || this.numeroClienti || this.datevClientsCount;
    },
    datevAnomalySectionKeySet() {
      return new Set(this.datevAnomalySectionKeys || []);
    },
    prospettiDistinctClientsCount() {
      const clienti =
        this.input_PC === "SEAC"
          ? this.vettoreClienti_SEAC
          : this.vettoreClienti;
      const clientKeys = new Set(
        (clienti || [])
          .map((cliente) => {
            const codiceDitta = cliente?.[0] || "";
            const nome = this.getNome(cliente?.[1]);
            return nome ? `${codiceDitta}|${nome}` : "";
          })
          .filter(Boolean)
      );
      return clientKeys.size || this.numeroClienti;
    },
    datevSectionsByClient() {
      const groups = new Map();
      for (const section of this.datevSectionInfos) {
        const codiceDittaRaw = section.codice_ditta || "";
        const codiceDitta = codiceDittaRaw || "Senza codice";
        const denominazione =
          section.denominazione_cliente || "Cliente senza nome";
        const key = denominazione;
        if (!groups.has(key)) {
          groups.set(key, {
            key,
            codice_ditta_raw: codiceDittaRaw,
            codice_ditta: codiceDitta,
            denominazione_cliente: denominazione,
            payslipKeys: new Set(),
            sectionsByName: new Map(),
          });
        }
        const group = groups.get(key);
        const sectionKey =
          section.section_key ||
          [
            section.codice_ditta || "",
            section.denominazione_cliente || "",
            section.month || "",
            section.year || "",
            section.section_name || "",
          ].join("|");
        const hasProblem = this.datevAnomalySectionKeySet.has(sectionKey);
        group.payslipKeys.add(
          [
            section.codice_ditta || "",
            section.denominazione_cliente || "",
            section.month || "",
            section.year || "",
          ].join("|")
        );
        const sectionName = section.section_name || "";
        if (!group.sectionsByName.has(sectionName)) {
          group.sectionsByName.set(sectionName, {
            client_section_key: `${denominazione}|${sectionName}`,
            section_name: sectionName,
            include: true,
            partial: false,
            problem: false,
            problem_count: 0,
            included_count: 0,
            total_count: 0,
            detail_parts: [],
            problem_detail_parts: [],
          });
        }
        const groupedSection = group.sectionsByName.get(sectionName);
        groupedSection.total_count += 1;
        if (hasProblem) {
          groupedSection.problem = true;
          groupedSection.problem_count += 1;
          groupedSection.problem_detail_parts.push(sectionKey);
        }
        if (section.include) {
          groupedSection.included_count += 1;
        }
        groupedSection.detail_parts.push(sectionKey);
      }
      return Array.from(groups.values()).map((group) => {
        const sections = Array.from(group.sectionsByName.values()).map(
          (section) => ({
            ...section,
            include: section.included_count === section.total_count,
            partial:
              section.included_count > 0 &&
              section.included_count < section.total_count,
            detail: section.detail_parts.join("\n"),
            problem_detail: section.problem_detail_parts.join("\n"),
            accepted_problem:
              section.problem && section.included_count === section.total_count,
          })
        );
        return {
          key: group.key,
          codice_ditta_raw: group.codice_ditta_raw,
          codice_ditta: group.codice_ditta,
          denominazione_cliente: group.denominazione_cliente,
          included_count: sections.filter((section) => section.include).length,
          total_count: sections.length,
          problem_count: sections.filter((section) => section.problem).length,
          excluded_problem_count: sections.filter(
            (section) => section.problem && !section.include
          ).length,
          prospetti_count: group.payslipKeys.size,
          sections,
        };
      });
    },
    filteredDatevClientMenuOptions() {
      const query = this.datevClientSearchQuery.trim().toLocaleLowerCase("it");
      if (!query) return this.datevSectionsByClient;
      return this.datevSectionsByClient.filter((clientGroup) =>
        `${clientGroup.denominazione_cliente} ${clientGroup.codice_ditta}`
          .toLocaleLowerCase("it")
          .includes(query)
      );
    },
    datevProblemSectionsCount() {
      return this.datevSectionsByClient.reduce(
        (count, clientGroup) => count + clientGroup.problem_count,
        0
      );
    },
    datevExcludedProblemSectionsCount() {
      return this.datevSectionsByClient.reduce(
        (count, clientGroup) => count + clientGroup.excluded_problem_count,
        0
      );
    },
    datevSectionReviewMessage() {
      if (this.datevExcludedProblemSectionsCount > 0) {
        const sectionLabel =
          this.datevExcludedProblemSectionsCount === 1
            ? "1 sezione e stata esclusa"
            : `${this.datevExcludedProblemSectionsCount} sezioni sono state escluse`;
        return `${sectionLabel} per problemi di riconoscimento. Puoi includerle manualmente e premere Rielabora.`;
      }
      return "Le sezioni con problemi che hai incluso verranno rielaborate mantenendo l'avviso visibile.";
    },
    isDatevGlobalView() {
      return this.selectedDatevClientKey === "global";
    },
    isDatevSummaryView() {
      return this.selectedDatevClientKey === "summary";
    },
    datevSavedClientPreferenceKeySet() {
      return new Set(this.datevSavedClientPreferenceKeys || []);
    },
    datevGlobalSections() {
      const sectionsByName = new Map();
      for (const section of this.datevSectionInfos) {
        const sectionName = section.section_name || "";
        if (!sectionName) continue;
        if (!sectionsByName.has(sectionName)) {
          sectionsByName.set(sectionName, {
            section_name: sectionName,
            total_count: 0,
            included_count: 0,
            problem: false,
          });
        }
        const groupedSection = sectionsByName.get(sectionName);
        groupedSection.total_count += 1;
        if (section.include) groupedSection.included_count += 1;
        if (this.datevAnomalySectionKeySet.has(section.section_key)) {
          groupedSection.problem = true;
        }
      }
      return Array.from(sectionsByName.values()).map((section) => ({
        ...section,
        include: this.getDatevGlobalIncludeForSection(section.section_name),
        partial: false,
      }));
    },
    filteredDatevSectionsByClient() {
      if (this.isDatevSummaryView) {
        return this.datevSectionsByClient;
      }
      if (this.isDatevGlobalView) return [];
      return this.datevSectionsByClient.filter(
        (clientGroup) => clientGroup.key === this.selectedDatevClientKey
      );
    },
    selectedDatevClientGroup() {
      if (this.isDatevGlobalView || this.isDatevSummaryView) return null;
      return (
        this.datevSectionsByClient.find(
          (clientGroup) => clientGroup.key === this.selectedDatevClientKey
        ) || null
      );
    },
    datevCurrentViewCanPersist() {
      return (
        this.canManageSectionPreferences &&
        this.datevCurrentViewHasPreferenceChanges
      );
    },
    datevCurrentViewHasPreferenceChanges() {
      if (this.isDatevGlobalView) {
        return Object.keys(this.datevGlobalPreferenceValues).length > 0;
      }
      if (this.selectedDatevClientGroup) {
        if (
          this.datevPendingClientPreferenceDeletes[
            this.selectedDatevClientGroup.key
          ]
        ) {
          return false;
        }
        return this.isDatevClientDirty(this.selectedDatevClientGroup.key);
      }
      return false;
    },
    datevPersistPermissionTooltip() {
      return this.canManageSectionPreferences
        ? ""
        : "Contatta l'amministratore del tuo studio per modificare le preferenze del convertitore";
    },
    datevCurrentPersistPreference: {
      get() {
        if (this.isDatevGlobalView) {
          return this.datevPersistGlobalPreference;
        }
        if (this.selectedDatevClientGroup) {
          return Boolean(
            this.datevPersistClientPreferences[
              this.selectedDatevClientGroup.key
            ]
          );
        }
        return false;
      },
      set(value) {
        if (!this.canManageSectionPreferences) {
          return;
        }
        if (this.isDatevGlobalView) {
          this.datevPersistGlobalPreference = Boolean(value);
        } else if (this.selectedDatevClientGroup) {
          this.$set(
            this.datevPersistClientPreferences,
            this.selectedDatevClientGroup.key,
            Boolean(value)
          );
        }
      },
    },
    hasDatevPendingPreferenceDeletes() {
      return Object.values(this.datevPendingClientPreferenceDeletes || {}).some(
        Boolean
      );
    },
    hasDatevPendingGlobalPreferenceChanges() {
      return Object.keys(this.datevGlobalPreferenceValues || {}).length > 0;
    },
    hasPendingDatevConfigChanges() {
      return (
        this.datevSectionsDirty ||
        this.hasDatevPendingGlobalPreferenceChanges ||
        this.hasDatevPendingPreferenceDeletes
      );
    },
    showDatevConfigPendingBadge() {
      return !this.datevConfigPanelOpen && this.hasPendingDatevConfigChanges;
    },
    canApplyDatevSectionChanges() {
      return this.hasPendingDatevConfigChanges && !this.datevSectionsApplying;
    },
    selectedDatevPanelTitle() {
      if (this.isDatevGlobalView) {
        return "Configurazione globale DATEV";
      }
      if (this.isDatevSummaryView) {
        return "Riepilogo estrazione";
      }
      if (this.selectedDatevClientGroup) {
        return this.formatDatevClientGroupTitle(this.selectedDatevClientGroup);
      }
      const clientiLabel =
        this.datevClientsCount === 1
          ? "1 cliente"
          : `${this.datevClientsCount} clienti`;
      return `${clientiLabel} - ${this.datevPayslipCount} Prospetti Paghe`;
    },
    selectedDatevPanelSubtitle() {
      if (this.isDatevGlobalView) {
        const includedCount = this.datevGlobalSections.filter(
          (section) => section.include
        ).length;
        return `${includedCount} sezioni attive su ${this.datevGlobalSections.length} individuate`;
      }
      if (this.isDatevSummaryView) {
        const clientiLabel =
          this.datevClientsCount === 1
            ? "1 cliente"
            : `${this.datevClientsCount} clienti`;
        return `${clientiLabel} - ${this.datevPayslipCount} Prospetti Paghe`;
      }
      return this.selectedDatevClientGroup
        ? `${this.selectedDatevClientGroup.included_count} sezioni incluse`
        : "";
    },
    selectedDatevIncludedSectionsCount() {
      return this.selectedDatevClientGroup
        ? this.selectedDatevClientGroup.included_count
        : this.datevIncludedSectionsCount;
    },
    datevSectionsDirty() {
      if (
        this.datevSectionInfos.length !== this.originalDatevSectionInfos.length
      ) {
        return this.datevSectionInfos.length > 0;
      }
      return this.datevSectionInfos.some((section, index) => {
        const original = this.originalDatevSectionInfos[index];
        return (
          !original ||
          section.section_key !== original.section_key ||
          Boolean(section.include) !== Boolean(original.include)
        );
      });
    },
    hasConversionDiagnostics() {
      const summary =
        this.conversionDiagnosticsModal.rootSummary ||
        this.conversionDiagnosticsModal.summary;
      if (!summary) return false;
      if (summary.has_user_visible_diagnostics !== undefined) {
        return Boolean(summary.has_user_visible_diagnostics);
      }
      return Boolean(summary.has_diagnostics);
    },
    hasQualityDiagnostics() {
      const summary = this.conversionDiagnosticsModal.rootSummary;
      return Boolean(
        summary &&
          ["warning", "degraded"].includes(summary.status) &&
          this.conversionDiagnosticsModal.notificationQueue.length
      );
    },
    canGoBackConversionDiagnosticsModal() {
      return (
        this.conversionDiagnosticsModal.visible &&
        this.conversionDiagnosticsModal.notificationIndex > 0
      );
    },
    canReviewDatevSectionsFromDiagnostics() {
      const summary = this.conversionDiagnosticsModal.summary;
      return Boolean(
        summary?.current_notification_kind === "excluded_sections" &&
          this.datevSectionInfos.length > 0 &&
          this.datevAnomalySectionKeys.length > 0
      );
    },
    diagnosticsReopenSeverity() {
      const summary =
        this.conversionDiagnosticsModal.rootSummary ||
        this.conversionDiagnosticsModal.summary;
      const status = summary?.status;
      if (status === "warning") return "is-warning";
      if (status === "degraded") return "is-degraded";
      return "is-failed";
    },
    diagnosticsReopenIcon() {
      const summary =
        this.conversionDiagnosticsModal.rootSummary ||
        this.conversionDiagnosticsModal.summary;
      return summary?.status === "warning"
        ? "fa-solid fa-circle-info"
        : "fa-solid fa-triangle-exclamation";
    },
    diagnosticsReopenTitle() {
      const summary =
        this.conversionDiagnosticsModal.rootSummary ||
        this.conversionDiagnosticsModal.summary;
      const title = summary?.user_title || "Controllo qualita documento";
      return `Rivedi avvisi: ${title}`;
    },
    diagnosticsReopenCount() {
      const summary =
        this.conversionDiagnosticsModal.rootSummary ||
        this.conversionDiagnosticsModal.summary ||
        {};
      const notifications = summary.user_notifications;
      if (Array.isArray(notifications) && notifications.length) {
        return notifications.length;
      }
      const events = summary.user_events;
      if (Array.isArray(events) && events.length) return events.length;
      return Number(
        summary.effective_drop_count ||
          summary.effective_warning_count ||
          summary.drop_anomalies_count ||
          summary.section_anomalies_count ||
          0
      );
    },
    diagnosticsProcessedClients() {
      const clienti =
        this.input_PC === "SEAC"
          ? this.vettoreClienti_SEAC
          : this.vettoreClienti;
      const names = [];

      (clienti || []).forEach((cliente) => {
        const name = this.getNome(cliente?.[1]);
        if (name && !names.includes(name)) {
          names.push(name);
        }
      });

      return names;
    },
    allPdcClientGroups() {
      return [
        ...(this.pdcClientGroups.non_custom || []),
        ...(this.pdcClientGroups.custom || []),
      ];
    },
    allPdcClientPdcGroups() {
      return [
        ...(this.pdcClientGroups.non_custom_pdc || []),
        ...(this.pdcClientGroups.custom_pdc || []),
      ];
    },
    hasPdcClientGroups() {
      return this.pdcClientTableOptions.length > 0;
    },
    pdcClientTableOptions() {
      const seen = new Set();
      return [...this.allPdcClientGroups, ...this.allPdcClientPdcGroups]
        .filter((group) => {
          const key = group?.client_key || "";
          if (!key || seen.has(key)) return false;
          seen.add(key);
          return true;
        })
        .map((group) => ({
          key: group.client_key,
          label: this.formatPdcClientLabel(group.client_key),
        }))
        .sort((a, b) => a.label.localeCompare(b.label, "it"));
    },
    currentPdcClientSelectionLabel() {
      if (!this.hasPdcClientGroups || this.pdcClientTableMode === "all") {
        return "Tutti";
      }
      return (
        this.pdcClientTableOptions.find(
          (client) => client.key === this.selectedPdcClientKey
        )?.label || "Cliente"
      );
    },
    currentPdcCodeViewLabel() {
      return this.vettorePDCVisible ? "Già salvati" : "Nuovi codici";
    },
    currentPdcCodeViewIcon() {
      return this.vettorePDCVisible ? "fa-solid fa-book" : "fa-solid fa-list";
    },
    isPdcClientTableView() {
      return (
        this.pdcClientTableMode === "client" &&
        Boolean(this.selectedPdcClientKey)
      );
    },
    selectedPdcClientGroup() {
      if (!this.isPdcClientTableView) return null;
      return (
        this.allPdcClientGroups.find(
          (group) => group.client_key === this.selectedPdcClientKey
        ) || null
      );
    },
    selectedPdcClientPdcGroup() {
      if (!this.isPdcClientTableView) return null;
      return (
        this.allPdcClientPdcGroups.find(
          (group) => group.client_key === this.selectedPdcClientKey
        ) || null
      );
    },
    currentCodContoRows() {
      if (this.isPdcClientTableView) {
        return this.selectedPdcClientGroup?.rows || [];
      }
      return this.vettoreCodConto;
    },
    currentCodContoPdcRows() {
      if (this.isPdcClientTableView) {
        return this.selectedPdcClientPdcGroup?.rows || [];
      }
      return this.vettoreCodContoPDC;
    },
    showPdcTableDashboard() {
      return (
        this.currentCodContoRows.length > 0 ||
        this.currentCodContoPdcRows.length > 0 ||
        this.vettoreCodConto.length > 0 ||
        this.vettoreCodContoPDC.length > 0
      );
    },
    currentCodContoTableKey() {
      return this.isPdcClientTableView
        ? this.getPdcClientTableKey(this.selectedPdcClientKey)
        : "pp-main";
    },
    currentCodContoPdcTableKey() {
      return this.isPdcClientTableView
        ? this.getPdcClientPdcTableKey(this.selectedPdcClientKey)
        : "pp-pdc";
    },
    currentCodContoTableLabel() {
      return this.isPdcClientTableView
        ? `CODICI CONTO - ${this.formatPdcClientLabel(
            this.selectedPdcClientKey
          )}`
        : "CODICI CONTO INDIVIDUATI";
    },
    currentCodContoPdcTableLabel() {
      return this.isPdcClientTableView
        ? `CODICI CONTO GIÀ SALVATI - ${this.formatPdcClientLabel(
            this.selectedPdcClientKey
          )}`
        : "CODICI CONTO GIÀ SALVATI";
    },
    hasCurrentPdcSavedView() {
      return (
        this.currentCodContoPdcRows.length > 0 ||
        this.vettoreCodContoPDC.length > 0 ||
        this.isPdcClientTableView
      );
    },
    isCurrentCodContoEditMode() {
      return this.isPdcClientTableView
        ? this.isEditModePdcClient
        : this.isEditMode;
    },
    currentPdcDashboardRows() {
      return this.vettorePDCVisible
        ? this.currentCodContoPdcRows
        : this.currentCodContoRows;
    },
    currentPdcDashboardTableKey() {
      return this.vettorePDCVisible
        ? this.currentCodContoPdcTableKey
        : this.currentCodContoTableKey;
    },
    currentPdcDashboardHasRows() {
      return this.currentPdcDashboardRows.length > 0;
    },
    currentPdcDashboardIsEditing() {
      return this.vettorePDCVisible
        ? this.isEditModePDC
        : this.isCurrentCodContoEditMode;
    },
    currentPdcDashboardHasChanges() {
      return this.hasTableChanges(this.currentPdcDashboardTableKey);
    },
    currentPdcDashboardCanUndo() {
      return this.hasTableUndo(this.currentPdcDashboardTableKey);
    },
    currentPdcDashboardExpanded() {
      return this.vettorePDCVisible
        ? this.isTablePDCExpanded
        : this.isCodContoTableExpanded;
    },
    currentPdcDashboardEditLabel() {
      if (this.currentPdcDashboardIsEditing) {
        return "Chiudi";
      }
      return this.vettorePDCVisible ? "Modifica" : "Personalizza";
    },
    currentPdcDashboardEditTitle() {
      if (!this.ha(this.user, "modifica_descrizione_nomi_conto")) {
        return this.vettorePDCVisible
          ? "Modifica Codici Conto gia salvati - Disponibile da piano Plus"
          : this.currentCodContoEditLockedTitle;
      }
      if (this.tableEditingBlockedByDatevSections) {
        return "Rielabora le sezioni prima di modificare i codici conto";
      }
      return this.vettorePDCVisible
        ? "Modifica Codici Conto gia salvati"
        : this.currentCodContoEditTitle;
    },
    canUseCurrentPdcDashboardEdit() {
      return (
        this.currentPdcDashboardHasRows &&
        this.ha(this.user, "modifica_descrizione_nomi_conto") &&
        (!this.tableEditingBlockedByDatevSections ||
          this.currentPdcDashboardIsEditing)
      );
    },
    currentCodContoEditTitle() {
      return this.isPdcClientTableView
        ? `Personalizza i codici conto per ${this.formatPdcClientLabel(
            this.selectedPdcClientKey
          )}`
        : "Personalizza descrizioni e codici conto";
    },
    currentCodContoEditLockedTitle() {
      return this.isPdcClientTableView
        ? "La personalizzazione per cliente e disponibile dal piano Plus"
        : "Passa a Plus per personalizzare le Descrizioni Codici Conto";
    },
    nomeContoTooltip() {
      const haModifica = this.ha(this.user, "modifica_descrizione_nomi_conto");
      const haSuggerimenti = this.ha(this.user, "suggerimenti_intelligenti");

      // Caso 1: Utente Base → tutto bloccato
      if (!haModifica && !haSuggerimenti) {
        return "Passa a Plus per personalizzare le Descrizioni Codici Conto o a\n Premium per avere i Suggerimenti Intelligenti!";
      }

      // Caso 2: Ha Plus (modifica sì, suggerimenti no)
      if (haModifica && !haSuggerimenti) {
        return "Passa a Premium per avere i Suggerimenti Intelligenti";
      }

      // Caso 3: Ha Premium (tutto sbloccato)
      if (haModifica && haSuggerimenti) {
        return "Suggerimenti Intelligenti attivati!";
      }

      // Fallback (non dovrebbe mai arrivare qui)
      return "Gestione Descrizioni Codici Conto";
    },
    validColumnsPDC() {
      const excludedColumnsMap = {
        TEAMSYSTEM: [0, 3, 4, 5, 6, 7, 9],
        DATEV: [0, 2, 5, 6, 7],
        ZUCCHETTI: [0, 2, 3, 4, 6, 7, 9],
        SEAC: [0, 2, 3, 4, 5, 7, 9],
        SISTEMI: [0, 2, 3, 4, 5, 6, 9],
      };
      const excluded = this.output_PC ? excludedColumnsMap[this.output_PC] : [];

      //Per DARE e AVERE None
      if (this.numeroClienti > 1) {
        const maxColIndex = this.headers.length - 1;
        excluded.push(maxColIndex, maxColIndex - 1); // Ultima e penultima
      }
      // Mostra tutte le colonne (0...headers.length-1) che non sono escluse
      return this.headers
        .map((_, index) => index)
        .filter((index) => !excluded.includes(index));
    },
    validColumns() {
      const excludedColumnsMap = {
        TEAMSYSTEM: [0, 3, 4, 5, 6, 7, 9],
        DATEV: [0, 2, 5, 6, 7],
        ZUCCHETTI: [0, 2, 3, 4, 6, 7, 9],
        SEAC: [0, 2, 3, 4, 5, 7, 9],
        SISTEMI: [0, 2, 3, 4, 5, 6, 9],
      };
      const excluded = this.output_PC ? excludedColumnsMap[this.output_PC] : [];

      //Per DARE e AVERE None
      if (this.numeroClienti > 1) {
        const maxColIndex = this.headers.length - 1;
        excluded.push(maxColIndex, maxColIndex - 1); // Ultima e penultima
      }
      // Mostra tutte le colonne (0...headers.length-1) che non sono escluse
      return this.headers
        .map((_, index) => index)
        .filter((index) => !excluded.includes(index));
    },
    filteredHeaders() {
      return this.validColumns.map((index) => {
        const header = this.headers[index];

        // Personalizza solo per DATEV
        if (this.output_PC === "DATEV") {
          if (header === "Descrizione Cod. Conto")
            return "Descrizione Cod. Conto - Datev Aziende";
          if (header === "Descrizione Cod. Conto 2")
            return "Descrizione Cod. Conto - Datev Lib. Prof.";
        }

        return header;
      });
    },

    filteredHeadersPDC() {
      return this.validColumnsPDC.map((index) => {
        const header = this.headers[index];

        // Stessa logica anche per la tabella PDC
        if (this.output_PC === "DATEV") {
          if (header === "Descrizione Cod. Conto")
            return "Descrizione Cod. Conto - Datev Aziende";
          if (header === "Descrizione Cod. Conto 2")
            return "Descrizione Cod. Conto - Datev Lib. Prof.";
        }

        return header;
      });
    },
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        this.determineCurrentPlan();
      },
    },
    output_PC(value) {
      if (value && this.errorAlertTitle === "Selezione richiesta") {
        this.errorMessage = "";
      }
      if (value === "DATEV" && this.needsProspettiCausale()) {
        this.openProspettiCausaleModal();
      }
    },
    flag_csv_import(value) {
      if (value && this.needsProspettiCausale()) {
        this.openProspettiCausaleModal();
      }
    },
    datevSectionsDirty(value) {
      if (!value) {
        this.datevPersistGlobalPreference = false;
        this.datevPersistClientPreferences = {};
        this.datevGlobalPreferenceValues = {};
      }
    },
    pdcClientTableMode(value) {
      if (value === "client") {
        this.ensureSelectedPdcClient();
      } else {
        this.isEditModePdcClient = false;
      }
    },
    selectedPdcClientKey() {
      this.isEditModePdcClient = this.isTableEditing(
        this.currentCodContoTableKey
      );
    },
  },
  methods: {
    ha,
    applyAdminMsFiscalCode({ index, fiscalCode }) {
      const clients =
        this.input_PC === "SEAC"
          ? this.vettoreClienti_SEAC
          : this.vettoreClienti;
      const client = clients[index];
      if (Array.isArray(client)) this.$set(client, 4, fiscalCode);
    },
    preventLockedTableInteraction(event) {
      if (!this.tableInteractionLocked) return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      if (
        this.tableEditingBlockedByDatevSections &&
        (target.closest(".datev-config-toggle") ||
          target.closest(".datev-config-panel"))
      ) {
        return;
      }

      const interactiveTarget = target.closest(
        [
          "input",
          "select",
          "textarea",
          "button",
          "label",
          "[contenteditable='true']",
          ".edit-button",
          ".btn-select",
          ".datev-config-toggle",
          ".datev-config-tab",
          ".datev-client-menu",
          ".datev-section-row",
        ].join(",")
      );

      if (!interactiveTarget) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof interactiveTarget.blur === "function") {
        interactiveTarget.blur();
      }
      if (target !== interactiveTarget && typeof target.blur === "function") {
        target.blur();
      }
    },
    isPiano,
    formatDatevClientGroupTitle(clientGroup) {
      const count = Number(clientGroup?.prospetti_count || 0);
      const label =
        count === 1 ? "1 Prospetto Paghe" : `${count} Prospetti Paghe`;
      return `${
        clientGroup?.denominazione_cliente || "Cliente senza nome"
      } - ${label}`;
    },
    isDatevClientCustomized(clientKey) {
      const key = clientKey || "";
      return (
        this.datevSavedClientPreferenceKeySet.has(key) &&
        !this.datevPendingClientPreferenceDeletes[key]
      );
    },
    isDatevClientProtectedFromGlobal(clientKey) {
      const key = clientKey || "";
      return (
        this.isDatevClientCustomized(key) ||
        Boolean(this.datevPersistClientPreferences[key])
      );
    },
    normalizeDatevSectionInfos(sectionInfos = []) {
      return sectionInfos.map((section) => ({
        ...section,
        include: Boolean(section.include),
        section_key:
          section.section_key ||
          [
            section.codice_ditta,
            section.denominazione_cliente,
            section.month,
            section.year,
            section.section_name,
          ].join("|"),
      }));
    },
    normalizeDatevSectionKeys(sectionKeys = []) {
      return (sectionKeys || [])
        .map((key) => {
          if (typeof key === "string") return key;
          if (Array.isArray(key)) return key.join("|");
          if (key && typeof key === "object") {
            return [
              key.codice_ditta || "",
              key.denominazione_cliente || "",
              key.month || "",
              key.year || "",
              key.section_name || "",
            ].join("|");
          }
          return "";
        })
        .filter(Boolean);
    },
    setDatevAnomalySectionKeys(sectionKeys = []) {
      this.datevAnomalySectionKeys =
        this.normalizeDatevSectionKeys(sectionKeys);
    },
    setDatevSectionInfos(sectionInfos = [], options = {}) {
      const normalized = this.normalizeDatevSectionInfos(sectionInfos);
      this.datevSectionInfos = normalized;
      this.originalDatevSectionInfos = JSON.parse(JSON.stringify(normalized));
      this.datevPersistGlobalPreference = false;
      this.datevPersistClientPreferences = {};
      this.datevGlobalPreferenceValues = {};
      this.datevPendingClientPreferenceDeletes = {};
      if (Array.isArray(options.savedClientPreferenceKeys)) {
        this.datevSavedClientPreferenceKeys = [
          ...options.savedClientPreferenceKeys,
        ];
      }
      if (
        options.savedClientPreferenceMaps &&
        typeof options.savedClientPreferenceMaps === "object"
      ) {
        this.datevSavedClientPreferenceMaps = Object.fromEntries(
          Object.entries(options.savedClientPreferenceMaps).map(
            ([clientKey, sectionMap]) => [
              clientKey,
              Object.fromEntries(
                Object.entries(sectionMap || {}).map(
                  ([sectionName, include]) => [sectionName, Boolean(include)]
                )
              ),
            ]
          )
        );
      } else {
        this.datevSavedClientPreferenceMaps = {};
      }
      if (
        options.globalSectionIncludeMap &&
        typeof options.globalSectionIncludeMap === "object"
      ) {
        this.datevGlobalSectionIncludeMap = {
          ...options.globalSectionIncludeMap,
        };
        this.originalDatevGlobalSectionIncludeMap = {
          ...options.globalSectionIncludeMap,
        };
      }
      if (Object.prototype.hasOwnProperty.call(options, "canManage")) {
        this.canManageSectionPreferences = Boolean(options.canManage);
      }
      if (!normalized.length) {
        this.datevConfigPanelOpen = false;
        this.selectedDatevClientKey = "summary";
        this.closeDatevClientMenu();
        this.datevSavedClientPreferenceKeys = [];
        this.datevSavedClientPreferenceMaps = {};
        this.datevGlobalSectionIncludeMap = {};
        this.originalDatevGlobalSectionIncludeMap = {};
      } else if (
        !["global", "summary"].includes(this.selectedDatevClientKey) &&
        !this.datevSectionsByClient.some(
          (clientGroup) => clientGroup.key === this.selectedDatevClientKey
        )
      ) {
        this.selectedDatevClientKey = "summary";
      }
    },
    toggleDatevConfigPanel() {
      this.datevConfigPanelOpen = !this.datevConfigPanelOpen;
      if (!this.datevConfigPanelOpen) this.closeDatevClientMenu();
    },
    handleDatevConfigToggle() {
      if (this.datevConfigPanelOpen) {
        this.toggleDatevConfigPanel();
        return;
      }
      if (this.phase2View === "quality") {
        this.openDatevSettingsFromQuality();
        return;
      }
      this.toggleDatevConfigPanel();
    },
    openDatevSettingsFromQuality() {
      this.datevConfigPanelOpen = true;
      const firstProblemClient = this.datevSectionsByClient.find(
        (clientGroup) => clientGroup.excluded_problem_count > 0
      );
      this.selectedDatevClientKey = firstProblemClient
        ? firstProblemClient.key
        : "summary";
      this.$nextTick(() => {
        const panel = this.$refs.datevConfigPanel;
        if (panel && typeof panel.scrollIntoView === "function") {
          panel.scrollIntoView({ block: "nearest", behavior: "smooth" });
        }
      });
    },
    selectDatevConfigView(view) {
      this.selectedDatevClientKey = view;
      this.closeDatevClientMenu();
    },
    toggleDatevClientMenu() {
      if (!this.datevSectionsByClient.length) return;
      this.datevClientMenuOpen = !this.datevClientMenuOpen;
      if (!this.datevClientMenuOpen) this.datevClientSearchQuery = "";
    },
    selectDatevClientView(clientKey) {
      this.selectedDatevClientKey = clientKey;
      this.closeDatevClientMenu();
    },
    closeDatevClientMenu() {
      this.datevClientMenuOpen = false;
      this.datevClientSearchQuery = "";
    },
    setDatevClientSectionInclude(denominazioneCliente, sectionName, include) {
      const targetDenominazioneCliente = denominazioneCliente || "";
      const targetSectionName = sectionName || "";
      if (
        this.datevPendingClientPreferenceDeletes[targetDenominazioneCliente]
      ) {
        this.$delete(
          this.datevPendingClientPreferenceDeletes,
          targetDenominazioneCliente
        );
      }
      this.datevSectionInfos = this.datevSectionInfos.map((section) => {
        if (
          (section.denominazione_cliente || "") ===
            targetDenominazioneCliente &&
          (section.section_name || "") === targetSectionName
        ) {
          return {
            ...section,
            include: Boolean(include),
          };
        }
        return section;
      });
    },
    setDatevGlobalSectionInclude(sectionName, include) {
      const targetSectionName = sectionName || "";
      const includeValue = Boolean(include);
      const originalGlobalInclude = Object.prototype.hasOwnProperty.call(
        this.originalDatevGlobalSectionIncludeMap,
        targetSectionName
      )
        ? Boolean(this.originalDatevGlobalSectionIncludeMap[targetSectionName])
        : this.getDatevGlobalIncludeForSection(targetSectionName);
      this.datevSectionInfos = this.datevSectionInfos.map((section) =>
        (section.section_name || "") === targetSectionName &&
        !this.isDatevClientProtectedFromGlobal(
          section.denominazione_cliente || ""
        )
          ? { ...section, include: includeValue }
          : section
      );

      this.$set(
        this.datevGlobalSectionIncludeMap,
        targetSectionName,
        includeValue
      );

      if (originalGlobalInclude === includeValue) {
        this.$delete(this.datevGlobalPreferenceValues, targetSectionName);
      } else {
        this.$set(
          this.datevGlobalPreferenceValues,
          targetSectionName,
          includeValue
        );
      }
    },
    getOriginalDatevSectionInclude(sectionKey) {
      const original = this.originalDatevSectionInfos.find(
        (section) => section.section_key === sectionKey
      );
      return original ? Boolean(original.include) : undefined;
    },
    isDatevSectionInfoChanged(section) {
      if (!section?.section_key) return false;
      const originalInclude = this.getOriginalDatevSectionInclude(
        section.section_key
      );
      return (
        originalInclude !== undefined &&
        Boolean(section.include) !== originalInclude
      );
    },
    isDatevGlobalSectionChanged(sectionName) {
      const targetSectionName = sectionName || "";
      if (
        Object.prototype.hasOwnProperty.call(
          this.datevGlobalPreferenceValues,
          targetSectionName
        )
      ) {
        return true;
      }
      return this.datevSectionInfos.some(
        (section) =>
          (section.section_name || "") === targetSectionName &&
          this.isDatevSectionInfoChanged(section)
      );
    },
    isDatevClientSectionChanged(clientGroup, groupedSection) {
      const targetClient = clientGroup?.denominazione_cliente || "";
      const targetSection = groupedSection?.section_name || "";
      return this.datevSectionInfos.some(
        (section) =>
          (section.denominazione_cliente || "") === targetClient &&
          (section.section_name || "") === targetSection &&
          this.isDatevSectionInfoChanged(section)
      );
    },
    getDatevSavedGlobalIncludeForSection(sectionName) {
      const targetSectionName = sectionName || "";
      if (
        Object.prototype.hasOwnProperty.call(
          this.originalDatevGlobalSectionIncludeMap,
          targetSectionName
        )
      ) {
        return Boolean(
          this.originalDatevGlobalSectionIncludeMap[targetSectionName]
        );
      }
      return this.getDatevGlobalIncludeForSection(targetSectionName);
    },
    isDatevClientSectionPermanentDiff(clientGroup, groupedSection) {
      const clientKey = clientGroup?.denominazione_cliente || "";
      const sectionName = groupedSection?.section_name || "";
      if (
        !clientKey ||
        !sectionName ||
        this.datevPendingClientPreferenceDeletes[clientKey]
      ) {
        return false;
      }
      const clientPreferenceMap =
        this.datevSavedClientPreferenceMaps?.[clientKey] || null;
      if (
        !clientPreferenceMap ||
        !Object.prototype.hasOwnProperty.call(clientPreferenceMap, sectionName)
      ) {
        return false;
      }
      return (
        Boolean(clientPreferenceMap[sectionName]) !==
        this.getDatevSavedGlobalIncludeForSection(sectionName)
      );
    },
    resetDatevPendingSectionChanges() {
      if (!this.hasPendingDatevConfigChanges || this.datevSectionsApplying)
        return;
      this.datevSectionInfos = JSON.parse(
        JSON.stringify(this.originalDatevSectionInfos)
      );
      this.datevPersistGlobalPreference = false;
      this.datevPersistClientPreferences = {};
      this.datevGlobalPreferenceValues = {};
      this.datevPendingClientPreferenceDeletes = {};
      this.datevGlobalSectionIncludeMap = {
        ...this.originalDatevGlobalSectionIncludeMap,
      };
    },
    isDatevClientDirty(clientKey) {
      const originalIncludeBySectionKey = new Map(
        this.originalDatevSectionInfos.map((section) => [
          section.section_key,
          Boolean(section.include),
        ])
      );
      return this.datevSectionInfos.some(
        (section) =>
          (section.denominazione_cliente || "") === clientKey &&
          Boolean(section.include) !==
            Boolean(originalIncludeBySectionKey.get(section.section_key))
      );
    },
    buildDatevClientSectionIncludeOverrides() {
      const originalIncludeBySectionKey = new Map(
        this.originalDatevSectionInfos.map((section) => [
          section.section_key,
          Boolean(section.include),
        ])
      );
      const changedClientSectionKeys = new Set();
      for (const section of this.datevSectionInfos) {
        if (
          Boolean(section.include) !==
          Boolean(originalIncludeBySectionKey.get(section.section_key))
        ) {
          changedClientSectionKeys.add(
            `${section.denominazione_cliente || ""}|${
              section.section_name || ""
            }`
          );
        }
      }
      return this.datevSectionsByClient.flatMap((clientGroup) =>
        clientGroup.sections
          .filter((section) =>
            changedClientSectionKeys.has(section.client_section_key)
          )
          .map((section) => ({
            denominazione_cliente: clientGroup.denominazione_cliente,
            section_name: section.section_name,
            include: Boolean(section.include),
          }))
      );
    },
    findDatevClientCodiceFiscale(denominazioneCliente) {
      const target = String(denominazioneCliente || "")
        .trim()
        .toLowerCase();
      if (!target) return "";
      for (const cliente of this.vettoreClienti || []) {
        const candidateNames = [cliente?.[1], cliente?.[3]]
          .map((value) => this.getNome(value || value))
          .filter(Boolean);
        const matches = candidateNames.some(
          (name) =>
            String(name || "")
              .trim()
              .toLowerCase() === target
        );
        if (matches && cliente?.[4]) {
          return String(cliente[4]).trim().toUpperCase();
        }
      }
      return "";
    },
    getDatevGlobalIncludeForSection(sectionName) {
      const targetSectionName = sectionName || "";
      if (
        Object.prototype.hasOwnProperty.call(
          this.datevGlobalSectionIncludeMap,
          targetSectionName
        )
      ) {
        return Boolean(this.datevGlobalSectionIncludeMap[targetSectionName]);
      }
      const originalSection = this.originalDatevSectionInfos.find(
        (section) => (section.section_name || "") === targetSectionName
      );
      return originalSection ? Boolean(originalSection.include) : false;
    },
    resetDatevClientPreferenceToGlobal(clientGroup) {
      if (!clientGroup?.key || !this.canManageSectionPreferences) return;
      this.$set(
        this.datevPendingClientPreferenceDeletes,
        clientGroup.key,
        true
      );
      this.$delete(this.datevPersistClientPreferences, clientGroup.key);
      this.datevSectionInfos = this.datevSectionInfos.map((section) => {
        if ((section.denominazione_cliente || "") !== clientGroup.key) {
          return section;
        }
        return {
          ...section,
          include: this.getDatevGlobalIncludeForSection(section.section_name),
        };
      });
    },
    buildDatevSectionPreferencePersistences() {
      if (!this.canManageSectionPreferences) {
        return [];
      }
      const persistences = [];
      if (
        this.datevPersistGlobalPreference &&
        Object.keys(this.datevGlobalPreferenceValues).length > 0
      ) {
        persistences.push({
          enabled: true,
          software_contabile: this.input_PC || "DATEV",
          scope_type: "global",
          merge_overrides: true,
          section_overrides: { ...this.datevGlobalPreferenceValues },
        });
      }

      for (const clientGroup of this.datevSectionsByClient) {
        if (
          this.datevPendingClientPreferenceDeletes[clientGroup.key] ||
          !this.datevPersistClientPreferences[clientGroup.key] ||
          !this.isDatevClientDirty(clientGroup.key)
        ) {
          continue;
        }
        persistences.push({
          enabled: true,
          software_contabile: this.input_PC || "DATEV",
          scope_type: "client",
          merge_overrides: false,
          client_denominazione: clientGroup.denominazione_cliente,
          client_codice_fiscale: this.findDatevClientCodiceFiscale(
            clientGroup.denominazione_cliente
          ),
          section_overrides: Object.fromEntries(
            clientGroup.sections.map((section) => [
              section.section_name,
              Boolean(section.include),
            ])
          ),
        });
      }
      return persistences;
    },
    buildDatevSectionPreferenceDeletions() {
      if (!this.canManageSectionPreferences) {
        return [];
      }
      return this.datevSectionsByClient
        .filter(
          (clientGroup) =>
            this.datevPendingClientPreferenceDeletes[clientGroup.key]
        )
        .map((clientGroup) => ({
          enabled: true,
          software_contabile: this.input_PC || "DATEV",
          scope_type: "client",
          client_denominazione: clientGroup.denominazione_cliente,
          client_codice_fiscale: this.findDatevClientCodiceFiscale(
            clientGroup.denominazione_cliente
          ),
        }));
    },
    buildDatevAcceptedAnomalySectionKeys() {
      return this.datevSectionInfos
        .filter(
          (section) =>
            Boolean(section.include) &&
            this.datevAnomalySectionKeySet.has(section.section_key)
        )
        .map((section) => section.section_key);
    },
    cleanProspettiRow(row = []) {
      return Array.isArray(row)
        ? row.map((cell, index) => {
            if (
              ([1, 2, 3, 4, 5, 6].includes(index) &&
                (cell == null || cell === "None")) ||
              this.isCodContoDefault(cell)
            ) {
              return null;
            }
            return cell;
          })
        : row;
    },
    cleanProspettiRows(rows = []) {
      return rows.map((row) => this.cleanProspettiRow(row));
    },
    normalizeCodContoValue(value) {
      return String(value ?? "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },
    isCodContoDefault(value) {
      return (
        this.codContoDefault &&
        this.normalizeCodContoValue(value) ===
          this.normalizeCodContoValue(this.codContoDefault)
      );
    },
    applyCodContoDefaultFromResponse(data = {}) {
      if (data.codContoDefault) {
        this.codContoDefault = String(data.codContoDefault);
      }
    },
    isCodContoValueColumn(col) {
      const normalized = String(col || "").trim();
      return normalized.startsWith("Cod. Conto -");
    },
    buildPdcRowKey(row = []) {
      if (!Array.isArray(row) || !row.length) return "";
      return String(row[0] || "")
        .replace(/\s+/g, " ")
        .trim();
    },
    normalizePdcCellValue(value) {
      if (value === null || value === undefined || value === "None") return "";
      return String(value).trim();
    },
    pdcCellsHaveSameValue(firstValue, secondValue) {
      return (
        this.normalizePdcCellValue(firstValue) ===
        this.normalizePdcCellValue(secondValue)
      );
    },
    isPdcClientPersonalizableColumn(originalIndex) {
      if ([1, 8, 9].includes(Number(originalIndex))) return true;
      switch (this.output_PC) {
        case "TEAMSYSTEM":
          return Number(originalIndex) === 2;
        case "DATEV":
          return Number(originalIndex) === 3 || Number(originalIndex) === 4;
        case "ZUCCHETTI":
          return Number(originalIndex) === 5;
        case "SEAC":
          return Number(originalIndex) === 6;
        case "SISTEMI":
          return Number(originalIndex) === 7;
        default:
          return false;
      }
    },
    normalizePdcClientRows(rows = []) {
      return (rows || []).map((item) => {
        const rawRow =
          item && typeof item === "object" && !Array.isArray(item)
            ? item.row || []
            : item;
        const row = this.cleanProspettiRow(rawRow);
        const explicitKey =
          item && typeof item === "object" && !Array.isArray(item)
            ? item.key
            : "";
        return {
          key: explicitKey || this.buildPdcRowKey(row),
          row,
          is_cliente_custom: Boolean(
            item &&
              typeof item === "object" &&
              !Array.isArray(item) &&
              item.is_cliente_custom
          ),
        };
      });
    },
    getPdcClientTableKey(clientKey) {
      return `pp-client-${encodeURIComponent(clientKey || "")}`;
    },
    getPdcClientPdcTableKey(clientKey) {
      return `pp-client-pdc-${encodeURIComponent(clientKey || "")}`;
    },
    getPdcClientKeyFromTableKey(tableKey) {
      const prefix = "pp-client-";
      const pdcPrefix = "pp-client-pdc-";
      const key = String(tableKey || "");
      if (key.startsWith(pdcPrefix)) return "";
      if (!key.startsWith(prefix)) return "";
      return decodeURIComponent(key.slice(prefix.length));
    },
    getPdcClientKeyFromPdcTableKey(tableKey) {
      const prefix = "pp-client-pdc-";
      if (!String(tableKey || "").startsWith(prefix)) return "";
      return decodeURIComponent(String(tableKey).slice(prefix.length));
    },
    formatPdcClientLabel(clientKey) {
      const raw = String(clientKey || "").trim();
      if (!raw) return "Cliente senza nome";
      const parts = raw.split("|").filter(Boolean);
      return parts[parts.length - 1] || raw;
    },
    normalizePdcClientGroups(groups = []) {
      return (groups || []).map((group) => {
        const normalizedRows = this.normalizePdcClientRows(group?.rows || []);
        return {
          client_key: String(group?.client_key || ""),
          rows: normalizedRows.map((item) => item.row),
          row_meta: normalizedRows.reduce((acc, item, index) => {
            const key = item.key || this.buildPdcRowKey(item.row) || `${index}`;
            acc[key] = {
              key,
              is_cliente_custom: Boolean(item.is_cliente_custom),
            };
            return acc;
          }, {}),
        };
      });
    },
    setPdcClientGroups(groupsPayload = {}) {
      this.pdcClientGroups = {
        global: this.normalizePdcClientGroups(groupsPayload.global || []),
        global_pdc: this.normalizePdcClientGroups(
          groupsPayload.global_pdc || []
        ),
        custom: this.normalizePdcClientGroups(groupsPayload.custom || []),
        custom_pdc: this.normalizePdcClientGroups(
          groupsPayload.custom_pdc || []
        ),
        non_custom: this.normalizePdcClientGroups(
          groupsPayload.non_custom || []
        ),
        non_custom_pdc: this.normalizePdcClientGroups(
          groupsPayload.non_custom_pdc || []
        ),
      };
      this.pdcClientGroupsToPersist = {};
      this.pdcClientGroupRowIndexesToPersist = {};
      this.pdcClientCustomRowKeysToRemove = {};
      this.pdcClientPdcGroupRowIndexesToPersist = {};
      this.pdcClientPdcCustomRowKeysToRemove = {};
      this.allPdcClientGroups.forEach((group) => {
        const label = `CODICI CONTO - ${this.formatPdcClientLabel(
          group.client_key
        )}`;
        this.primeTableEditSession(
          this.getPdcClientTableKey(group.client_key),
          label,
          group.rows,
          true
        );
      });
      this.allPdcClientPdcGroups.forEach((group) => {
        const label = `CODICI CONTO GIÀ SALVATI - ${this.formatPdcClientLabel(
          group.client_key
        )}`;
        this.primeTableEditSession(
          this.getPdcClientPdcTableKey(group.client_key),
          label,
          group.rows,
          true
        );
      });
      this.ensureSelectedPdcClient();
      if (!this.hasPdcClientGroups) {
        this.pdcClientTableMode = "all";
        this.selectedPdcClientKey = "";
      }
    },
    ensureSelectedPdcClient() {
      if (!this.pdcClientTableOptions.length) {
        this.selectedPdcClientKey = "";
        return;
      }
      const exists = this.pdcClientTableOptions.some(
        (client) => client.key === this.selectedPdcClientKey
      );
      if (!exists) {
        this.selectedPdcClientKey = this.pdcClientTableOptions[0].key;
      }
    },
    selectAllPdcClientRows() {
      this.pdcClientTableMode = "all";
      this.pdcClientDropdownOpen = false;
      this.pdcCodeViewDropdownOpen = false;
      this.isEditModePdcClient = false;
      this.isEditModePDC = this.isTableEditing("pp-pdc");
    },
    selectPdcClientRows(clientKey) {
      this.selectedPdcClientKey = clientKey;
      this.pdcClientTableMode = "client";
      this.pdcClientDropdownOpen = false;
      this.pdcCodeViewDropdownOpen = false;
      this.isEditModePdcClient = this.isTableEditing(
        this.getPdcClientTableKey(clientKey)
      );
      this.isEditModePDC = this.isTableEditing(
        this.getPdcClientPdcTableKey(clientKey)
      );
    },
    togglePdcCodeViewDropdown() {
      this.pdcCodeViewDropdownOpen = !this.pdcCodeViewDropdownOpen;
      if (this.pdcCodeViewDropdownOpen) {
        this.pdcClientDropdownOpen = false;
      }
    },
    togglePdcClientViewDropdown() {
      this.pdcClientDropdownOpen = !this.pdcClientDropdownOpen;
      if (this.pdcClientDropdownOpen) {
        this.pdcCodeViewDropdownOpen = false;
      }
    },
    toggleCurrentPdcTableExpansion() {
      if (this.vettorePDCVisible) {
        this.toggleTablePDCExpansion();
        return;
      }
      this.toggleCodContoTableExpansion();
    },
    toggleCurrentPdcTableEditMode() {
      if (!this.canUseCurrentPdcDashboardEdit) return;
      if (this.vettorePDCVisible) {
        this.toggleEditModePDC();
        return;
      }
      this.toggleCurrentCodContoEditMode();
    },
    saveCurrentPdcDashboardTable() {
      if (!this.currentPdcDashboardHasChanges) return;
      this.saveProspettiTable(
        this.currentPdcDashboardTableKey,
        this.currentPdcDashboardRows
      );
    },
    undoCurrentPdcDashboardTable() {
      if (!this.currentPdcDashboardCanUndo) return;
      this.undoProspettiTable(
        this.currentPdcDashboardTableKey,
        this.currentPdcDashboardRows
      );
    },
    resetCurrentPdcDashboardTable() {
      if (!this.currentPdcDashboardHasChanges) return;
      if (this.vettorePDCVisible) {
        this.resetProspettiTable(
          this.currentCodContoPdcTableKey,
          this.isPdcClientTableView ? null : "vettoreCodContoPDC",
          this.isPdcClientTableView ? this.currentCodContoPdcRows : null
        );
        return;
      }
      this.resetCurrentCodContoTable();
    },
    closePdcFilterDropdownsOnOutsideClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const isPdcFilterTarget =
        target.closest(".btnPDCvisible") ||
        target.closest(".pdc-code-view-menu") ||
        target.closest(".pdc-client-view-controls");
      if (!isPdcFilterTarget) {
        this.pdcCodeViewDropdownOpen = false;
        this.pdcClientDropdownOpen = false;
      }
      if (!target.closest(".datev-client-tab-control")) {
        this.closeDatevClientMenu();
      }
    },
    selectPdcCodeView(showSaved) {
      this.vettorePDCVisible = showSaved;
      this.pdcCodeViewDropdownOpen = false;
      this.pdcClientDropdownOpen = false;
      this.isEditMode = this.isTableEditing(this.currentCodContoTableKey);
      this.isEditModePDC = this.isTableEditing(this.currentCodContoPdcTableKey);
    },
    findPdcClientGroup(clientKey) {
      return (
        this.allPdcClientGroups.find(
          (group) => group.client_key === clientKey
        ) || null
      );
    },
    findPdcClientPdcGroup(clientKey) {
      return (
        this.allPdcClientPdcGroups.find(
          (group) => group.client_key === clientKey
        ) || null
      );
    },
    findGlobalPdcClientGroup(clientKey) {
      return (
        (this.pdcClientGroups.global || []).find(
          (group) => group.client_key === clientKey
        ) || null
      );
    },
    findGlobalPdcClientPdcGroup(clientKey) {
      return (
        (this.pdcClientGroups.global_pdc || []).find(
          (group) => group.client_key === clientKey
        ) || null
      );
    },
    getPdcClientRowMeta(group, rowIndex) {
      const row = group?.rows?.[rowIndex];
      const rowKey = this.buildPdcRowKey(row);
      return rowKey ? group?.row_meta?.[rowKey] || null : null;
    },
    isPdcClientRowExplicitlyCustom(group, rowIndex) {
      if (!group) return false;
      if (this.getPdcClientRowMeta(group, rowIndex)?.is_cliente_custom) {
        return true;
      }
      const tableKey = this.getPdcClientTableKey(group.client_key);
      const pendingIndexes =
        this.pdcClientGroupRowIndexesToPersist[group.client_key] || [];
      return (
        pendingIndexes.includes(rowIndex) ||
        this.getDirtyRowIndexesForTable(tableKey).includes(rowIndex)
      );
    },
    findPdcRowIndexByKey(rows = [], rowKey = "") {
      if (!rowKey) return -1;
      return (rows || []).findIndex(
        (row) => this.buildPdcRowKey(row) === rowKey
      );
    },
    getPdcClientPersonalizableColumns() {
      return [...Array(10).keys()].filter((index) =>
        this.isPdcClientPersonalizableColumn(index)
      );
    },
    getGlobalPdcClientRow(group, rowIndex) {
      const row = group?.rows?.[rowIndex];
      const rowKey = this.buildPdcRowKey(row);
      const globalGroup = this.findGlobalPdcClientGroup(group?.client_key);
      const globalRowIndex = this.findPdcRowIndexByKey(
        globalGroup?.rows || [],
        rowKey
      );
      return globalGroup?.rows?.[globalRowIndex] || null;
    },
    getGlobalPdcClientPdcRow(group, rowIndex) {
      const row = group?.rows?.[rowIndex];
      const rowKey = this.buildPdcRowKey(row);
      const globalGroup = this.findGlobalPdcClientPdcGroup(group?.client_key);
      const globalRowIndex = this.findPdcRowIndexByKey(
        globalGroup?.rows || [],
        rowKey
      );
      return globalGroup?.rows?.[globalRowIndex] || null;
    },
    isPdcClientRowDifferentFromGlobal(group, rowIndex) {
      const clientRow = group?.rows?.[rowIndex];
      const globalRow = this.getGlobalPdcClientRow(group, rowIndex);
      if (!clientRow || !globalRow) return false;

      return this.getPdcClientPersonalizableColumns().some(
        (colIndex) =>
          !this.pdcCellsHaveSameValue(clientRow[colIndex], globalRow[colIndex])
      );
    },
    isPdcClientCellDifferentFromGlobal(rowIndex, colIndex) {
      if (!this.isPdcClientTableView) return false;
      if (!this.isPdcClientPersonalizableColumn(colIndex)) return false;

      const clientGroup = this.selectedPdcClientGroup;
      const globalGroup = this.findGlobalPdcClientGroup(
        clientGroup?.client_key
      );
      const clientRow = clientGroup?.rows?.[rowIndex];
      const rowKey = this.buildPdcRowKey(clientRow);
      const globalRowIndex = this.findPdcRowIndexByKey(
        globalGroup?.rows || [],
        rowKey
      );
      const globalRow = globalGroup?.rows?.[globalRowIndex];

      if (!clientRow || !globalRow) return false;
      return !this.pdcCellsHaveSameValue(
        clientRow[colIndex],
        globalRow[colIndex]
      );
    },
    isPdcClientCellSavedDifferentFromGlobal(rowIndex, colIndex) {
      if (!this.isPdcClientTableView) return false;
      if (!this.isPdcClientPersonalizableColumn(colIndex)) return false;
      const clientGroup = this.selectedPdcClientGroup;
      const isSavedCustom = Boolean(
        this.getPdcClientRowMeta(clientGroup, rowIndex)?.is_cliente_custom
      );
      return (
        isSavedCustom &&
        !this.isTableCellDirty(
          this.getPdcClientTableKey(clientGroup?.client_key),
          rowIndex,
          colIndex
        ) &&
        this.isPdcClientCellDifferentFromGlobal(rowIndex, colIndex)
      );
    },
    isPdcClientPdcRowExplicitlyCustom(group, rowIndex) {
      if (!group) return false;
      const row = group?.rows?.[rowIndex];
      const rowKey = this.buildPdcRowKey(row);
      const meta = rowKey ? group?.row_meta?.[rowKey] || null : null;
      if (meta?.is_cliente_custom) return true;
      const tableKey = this.getPdcClientPdcTableKey(group.client_key);
      const pendingIndexes =
        this.pdcClientPdcGroupRowIndexesToPersist[group.client_key] || [];
      return (
        pendingIndexes.includes(rowIndex) ||
        this.getDirtyRowIndexesForTable(tableKey).includes(rowIndex)
      );
    },
    isPdcClientPdcRowDifferentFromGlobal(group, rowIndex) {
      const clientRow = group?.rows?.[rowIndex];
      const globalRow = this.getGlobalPdcClientPdcRow(group, rowIndex);
      if (!clientRow) return false;
      if (!globalRow)
        return this.isPdcClientPdcRowExplicitlyCustom(group, rowIndex);

      return this.getPdcClientPersonalizableColumns().some(
        (colIndex) =>
          !this.pdcCellsHaveSameValue(clientRow[colIndex], globalRow[colIndex])
      );
    },
    isPdcClientPdcCellDifferentFromGlobal(rowIndex, colIndex) {
      if (!this.isPdcClientTableView) return false;
      if (!this.isPdcClientPersonalizableColumn(colIndex)) return false;

      const clientGroup = this.selectedPdcClientPdcGroup;
      const clientRow = clientGroup?.rows?.[rowIndex];
      const globalRow = this.getGlobalPdcClientPdcRow(clientGroup, rowIndex);

      if (!clientRow) return false;
      if (!globalRow) {
        return this.isPdcClientPdcRowExplicitlyCustom(clientGroup, rowIndex);
      }
      return !this.pdcCellsHaveSameValue(
        clientRow[colIndex],
        globalRow[colIndex]
      );
    },
    isPdcClientPdcCellSavedDifferentFromGlobal(rowIndex, colIndex) {
      if (!this.isPdcClientTableView) return false;
      if (!this.isPdcClientPersonalizableColumn(colIndex)) return false;
      const clientGroup = this.selectedPdcClientPdcGroup;
      const isSavedCustom = Boolean(
        this.getPdcClientRowMeta(clientGroup, rowIndex)?.is_cliente_custom
      );
      return (
        isSavedCustom &&
        !this.isTableCellDirty(
          this.getPdcClientPdcTableKey(clientGroup?.client_key),
          rowIndex,
          colIndex
        ) &&
        this.isPdcClientPdcCellDifferentFromGlobal(rowIndex, colIndex)
      );
    },
    setPdcClientRowCustomState(group, rowIndex, isCustom) {
      if (!group) return;
      const row = group.rows?.[rowIndex];
      const rowKey = this.buildPdcRowKey(row) || `${rowIndex}`;
      if (!rowKey) return;
      const currentMeta = group.row_meta?.[rowKey] || { key: rowKey };
      this.$set(group.row_meta, rowKey, {
        ...currentMeta,
        key: rowKey,
        is_cliente_custom: Boolean(isCustom),
      });
    },
    setPdcClientPdcRowCustomState(group, rowIndex, isCustom) {
      this.setPdcClientRowCustomState(group, rowIndex, isCustom);
    },
    markPdcClientRowForCustomRemoval(group, rowIndex) {
      const clientKey = group?.client_key;
      const rowKey = this.buildPdcRowKey(group?.rows?.[rowIndex]);
      if (!clientKey || !rowKey) return;
      const existing = this.pdcClientCustomRowKeysToRemove[clientKey] || [];
      this.$set(this.pdcClientCustomRowKeysToRemove, clientKey, [
        ...new Set([...existing, rowKey]),
      ]);
    },
    clearPdcClientRowCustomRemoval(group, rowIndex) {
      const clientKey = group?.client_key;
      const rowKey = this.buildPdcRowKey(group?.rows?.[rowIndex]);
      if (!clientKey || !rowKey) return;
      const next = (
        this.pdcClientCustomRowKeysToRemove[clientKey] || []
      ).filter((key) => key !== rowKey);
      if (next.length) {
        this.$set(this.pdcClientCustomRowKeysToRemove, clientKey, next);
      } else {
        this.$delete(this.pdcClientCustomRowKeysToRemove, clientKey);
      }
    },
    markPdcClientPdcRowForCustomRemoval(group, rowIndex) {
      const clientKey = group?.client_key;
      const rowKey = this.buildPdcRowKey(group?.rows?.[rowIndex]);
      if (!clientKey || !rowKey) return;
      const existing = this.pdcClientPdcCustomRowKeysToRemove[clientKey] || [];
      this.$set(this.pdcClientPdcCustomRowKeysToRemove, clientKey, [
        ...new Set([...existing, rowKey]),
      ]);
    },
    clearPdcClientPdcRowCustomRemoval(group, rowIndex) {
      const clientKey = group?.client_key;
      const rowKey = this.buildPdcRowKey(group?.rows?.[rowIndex]);
      if (!clientKey || !rowKey) return;
      const next = (
        this.pdcClientPdcCustomRowKeysToRemove[clientKey] || []
      ).filter((key) => key !== rowKey);
      if (next.length) {
        this.$set(this.pdcClientPdcCustomRowKeysToRemove, clientKey, next);
      } else {
        this.$delete(this.pdcClientPdcCustomRowKeysToRemove, clientKey);
      }
    },
    getDirtyRowIndexesForTable(tableKey) {
      const dirtyCells = this.tableEditSessions?.[tableKey]?.dirtyCells || {};
      return [
        ...new Set(
          Object.keys(dirtyCells)
            .map((key) => Number(String(key).split("-")[0]))
            .filter((index) => Number.isInteger(index) && index >= 0)
        ),
      ];
    },
    markPdcClientRowsAsCustom(tableKey) {
      const clientKey = this.getPdcClientKeyFromTableKey(tableKey);
      const group = this.findPdcClientGroup(clientKey);
      if (!group) return;

      this.getDirtyRowIndexesForTable(tableKey).forEach((rowIndex) => {
        const wasCustom = this.isPdcClientRowExplicitlyCustom(group, rowIndex);
        const isStillDifferent = this.isPdcClientRowDifferentFromGlobal(
          group,
          rowIndex
        );
        this.setPdcClientRowCustomState(group, rowIndex, isStillDifferent);
        if (isStillDifferent) {
          this.clearPdcClientRowCustomRemoval(group, rowIndex);
        } else if (wasCustom) {
          this.markPdcClientRowForCustomRemoval(group, rowIndex);
        }
      });
    },
    markPdcClientPdcRowsAsCustom(tableKey) {
      const clientKey = this.getPdcClientKeyFromPdcTableKey(tableKey);
      const group = this.findPdcClientPdcGroup(clientKey);
      if (!group) return;

      this.getDirtyRowIndexesForTable(tableKey).forEach((rowIndex) => {
        const wasCustom = this.isPdcClientPdcRowExplicitlyCustom(
          group,
          rowIndex
        );
        const isStillDifferent = this.isPdcClientPdcRowDifferentFromGlobal(
          group,
          rowIndex
        );
        this.setPdcClientPdcRowCustomState(group, rowIndex, isStillDifferent);
        if (isStillDifferent) {
          this.clearPdcClientPdcRowCustomRemoval(group, rowIndex);
        } else if (wasCustom) {
          this.markPdcClientPdcRowForCustomRemoval(group, rowIndex);
        }
      });
    },
    markPdcClientGroupForPersistence(tableKey) {
      const clientKey = this.getPdcClientKeyFromTableKey(tableKey);
      if (clientKey) {
        this.$set(this.pdcClientGroupsToPersist, clientKey, true);
        const group = this.findPdcClientGroup(clientKey);
        const existingIndexes =
          this.pdcClientGroupRowIndexesToPersist[clientKey] || [];
        const mergedIndexes = [
          ...new Set([
            ...existingIndexes,
            ...this.getDirtyRowIndexesForTable(tableKey).filter((rowIndex) =>
              this.isPdcClientRowDifferentFromGlobal(group, rowIndex)
            ),
          ]),
        ];
        if (mergedIndexes.length) {
          this.$set(
            this.pdcClientGroupRowIndexesToPersist,
            clientKey,
            mergedIndexes
          );
        } else {
          this.$delete(this.pdcClientGroupRowIndexesToPersist, clientKey);
        }
      }
    },
    markPdcClientPdcGroupForPersistence(tableKey) {
      const clientKey = this.getPdcClientKeyFromPdcTableKey(tableKey);
      if (!clientKey) return;

      const group = this.findPdcClientPdcGroup(clientKey);
      const existingIndexes =
        this.pdcClientPdcGroupRowIndexesToPersist[clientKey] || [];
      const mergedIndexes = [
        ...new Set([
          ...existingIndexes,
          ...this.getDirtyRowIndexesForTable(tableKey).filter((rowIndex) =>
            this.isPdcClientPdcRowDifferentFromGlobal(group, rowIndex)
          ),
        ]),
      ];
      if (mergedIndexes.length) {
        this.$set(
          this.pdcClientPdcGroupRowIndexesToPersist,
          clientKey,
          mergedIndexes
        );
      } else {
        this.$delete(this.pdcClientPdcGroupRowIndexesToPersist, clientKey);
      }
    },
    syncClientSessionCell(tableKey, rowIndex, colIndex, value) {
      const session = this.tableEditSessions?.[tableKey];
      if (!session?.baselineInitialized) return;

      if (!Array.isArray(session.baseline?.[rowIndex])) return;
      this.$set(session.baseline[rowIndex], colIndex, value);
      const keyCell = `${rowIndex}-${colIndex}`;
      this.$delete(session.currentValues, keyCell);
      this.$delete(session.dirtyCells, keyCell);
    },
    propagateMainPdcCellToClientGroups(rowIndex, colIndex) {
      if (
        !Number.isInteger(rowIndex) ||
        !Number.isInteger(colIndex) ||
        !this.isPdcClientPersonalizableColumn(colIndex)
      ) {
        return;
      }

      const globalRow = this.vettoreCodConto?.[rowIndex];
      const rowKey = this.buildPdcRowKey(globalRow);
      if (!rowKey) return;

      (this.pdcClientGroups.global || []).forEach((group) => {
        const globalClientRowIndex = this.findPdcRowIndexByKey(
          group.rows || [],
          rowKey
        );
        if (globalClientRowIndex < 0) return;
        this.$set(
          group.rows[globalClientRowIndex],
          colIndex,
          globalRow[colIndex]
        );
      });

      this.allPdcClientGroups.forEach((group) => {
        const clientRowIndex = this.findPdcRowIndexByKey(
          group.rows || [],
          rowKey
        );
        if (clientRowIndex < 0) return;
        if (this.isPdcClientRowExplicitlyCustom(group, clientRowIndex)) {
          return;
        }

        this.$set(group.rows[clientRowIndex], colIndex, globalRow[colIndex]);
        this.syncClientSessionCell(
          this.getPdcClientTableKey(group.client_key),
          clientRowIndex,
          colIndex,
          globalRow[colIndex]
        );
      });
    },
    propagateSavedPdcCellToClientGroups(rowIndex, colIndex) {
      if (
        !Number.isInteger(rowIndex) ||
        !Number.isInteger(colIndex) ||
        !this.isPdcClientPersonalizableColumn(colIndex)
      ) {
        return;
      }

      const globalRow = this.vettoreCodContoPDC?.[rowIndex];
      const rowKey = this.buildPdcRowKey(globalRow);
      if (!rowKey) return;

      (this.pdcClientGroups.global_pdc || []).forEach((group) => {
        const globalClientRowIndex = this.findPdcRowIndexByKey(
          group.rows || [],
          rowKey
        );
        if (globalClientRowIndex < 0) return;
        this.$set(
          group.rows[globalClientRowIndex],
          colIndex,
          globalRow[colIndex]
        );
      });

      this.allPdcClientPdcGroups.forEach((group) => {
        const clientRowIndex = this.findPdcRowIndexByKey(
          group.rows || [],
          rowKey
        );
        if (clientRowIndex < 0) return;
        if (this.isPdcClientPdcRowExplicitlyCustom(group, clientRowIndex)) {
          return;
        }

        this.$set(group.rows[clientRowIndex], colIndex, globalRow[colIndex]);
        this.syncClientSessionCell(
          this.getPdcClientPdcTableKey(group.client_key),
          clientRowIndex,
          colIndex,
          globalRow[colIndex]
        );
      });
    },
    applyMainPdcChangesToClientGroups() {
      const session = this.tableEditSessions?.["pp-main"];
      if (!session || !this.hasTableChanges(session)) return;

      Object.keys(session.dirtyCells || {}).forEach((cellKey) => {
        const [rowIndexRaw, colIndexRaw] = String(cellKey).split("-");
        const rowIndex = Number(rowIndexRaw);
        const colIndex = Number(colIndexRaw);
        this.propagateMainPdcCellToClientGroups(rowIndex, colIndex);
      });
    },
    applySavedPdcChangesToClientGroups() {
      const session = this.tableEditSessions?.["pp-pdc"];
      if (!session || !this.hasTableChanges(session)) return;

      Object.keys(session.dirtyCells || {}).forEach((cellKey) => {
        const [rowIndexRaw, colIndexRaw] = String(cellKey).split("-");
        const rowIndex = Number(rowIndexRaw);
        const colIndex = Number(colIndexRaw);
        this.propagateSavedPdcCellToClientGroups(rowIndex, colIndex);
      });
    },
    buildPdcClientGroupsPayloadForConversion() {
      const customRemovals = Object.entries(
        this.pdcClientCustomRowKeysToRemove || {}
      )
        .map(([clientKey, rowKeys]) => ({
          client_key: clientKey,
          row_keys: [...new Set(rowKeys || [])],
        }))
        .filter((group) => group.row_keys.length);
      const customPdcRemovals = Object.entries(
        this.pdcClientPdcCustomRowKeysToRemove || {}
      )
        .map(([clientKey, rowKeys]) => ({
          client_key: clientKey,
          row_keys: [...new Set(rowKeys || [])],
        }))
        .filter((group) => group.row_keys.length);
      const customGroups = this.allPdcClientGroups.filter((group) => {
        const key = this.getPdcClientTableKey(group.client_key);
        return (
          this.hasTableChanges(key) ||
          Boolean(
            (this.pdcClientGroupRowIndexesToPersist[group.client_key] || [])
              .length
          )
        );
      });
      const customPdcGroups = this.allPdcClientPdcGroups.filter((group) => {
        const key = this.getPdcClientPdcTableKey(group.client_key);
        return (
          this.hasTableChanges(key) ||
          Boolean(
            (this.pdcClientPdcGroupRowIndexesToPersist[group.client_key] || [])
              .length
          )
        );
      });
      if (
        !customGroups.length &&
        !customPdcGroups.length &&
        !customRemovals.length &&
        !customPdcRemovals.length
      ) {
        return null;
      }
      return {
        custom: customGroups
          .map((group) => {
            const tableKey = this.getPdcClientTableKey(group.client_key);
            const rowIndexes = [
              ...new Set([
                ...(this.pdcClientGroupRowIndexesToPersist[group.client_key] ||
                  []),
                ...this.getDirtyRowIndexesForTable(tableKey),
              ]),
            ];
            return {
              client_key: group.client_key,
              rows: rowIndexes
                .filter((rowIndex) =>
                  this.isPdcClientRowDifferentFromGlobal(group, rowIndex)
                )
                .map((rowIndex) => group.rows[rowIndex])
                .filter((row) => Array.isArray(row)),
            };
          })
          .filter((group) => group.rows.length),
        custom_removals: [...customRemovals, ...customPdcRemovals],
        custom_pdc: customPdcGroups
          .map((group) => {
            const tableKey = this.getPdcClientPdcTableKey(group.client_key);
            const rowIndexes = [
              ...new Set([
                ...(this.pdcClientPdcGroupRowIndexesToPersist[
                  group.client_key
                ] || []),
                ...this.getDirtyRowIndexesForTable(tableKey),
              ]),
            ];
            return {
              client_key: group.client_key,
              rows: rowIndexes
                .filter((rowIndex) =>
                  this.isPdcClientPdcRowDifferentFromGlobal(group, rowIndex)
                )
                .map((rowIndex) => group.rows[rowIndex])
                .filter((row) => Array.isArray(row)),
            };
          })
          .filter((group) => group.rows.length),
        non_custom: [],
        non_custom_pdc: [],
      };
    },
    applyCheckPdcResponse(responseData) {
      this.vettoreCodConto = this.cleanProspettiRows(
        responseData.vettoreCodConto || []
      );
      this.vettoreCodContoPDC = this.cleanProspettiRows(
        responseData.vettoreCodContoPDC || []
      );
      this.originalPDC = JSON.parse(JSON.stringify(this.vettoreCodContoPDC));
      this.primeTableEditSession(
        "pp-main",
        "CODICI CONTO INDIVIDUATI",
        this.vettoreCodConto,
        true
      );
      this.primeTableEditSession(
        "pp-pdc",
        "CODICI CONTO GIÀ SALVATI",
        this.vettoreCodContoPDC,
        true
      );
      this.clientCustomPdcEntries =
        responseData.client_custom_pdc_entries || {};
      this.setPdcClientGroups(responseData.pdc_client_groups || {});
    },
    async applyDatevSectionChanges() {
      if (!this.canApplyDatevSectionChanges) return;
      this.datevSectionsApplying = true;
      this.calculating2 = true;
      try {
        const response = await axios.post(
          `${API_BASE_URL}/prospetti_paghe/datev/sections/apply`,
          {
            job_id: this.jobId,
            input_PC: this.input_PC,
            output_PC: this.output_PC,
            vettoreClienti: this.vettoreClienti,
            flag_saldoProspettiPaghe: this.settings.flag_saldoProspettiPaghe,
            anomaly_excluded_section_keys: this.datevAnomalySectionKeys,
            accepted_anomaly_section_keys:
              this.buildDatevAcceptedAnomalySectionKeys(),
            client_section_include_overrides:
              this.buildDatevClientSectionIncludeOverrides(),
            section_preference_persistences:
              this.buildDatevSectionPreferencePersistences(),
            section_preference_deletions:
              this.buildDatevSectionPreferenceDeletions(),
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (Array.isArray(response.data.vettoreClienti)) {
          this.vettoreClienti = response.data.vettoreClienti;
        }
        if (Number.isFinite(Number(response.data.numeroClienti))) {
          this.numeroClienti = Number(response.data.numeroClienti);
        }
        this.applyCheckPdcResponse(response.data);
        this.setDatevAnomalySectionKeys(
          response.data.datev_anomaly_section_keys ||
            this.datevAnomalySectionKeys
        );
        this.setDatevSectionInfos(response.data.datev_section_infos || [], {
          savedClientPreferenceKeys:
            response.data.datev_saved_client_preference_keys || [],
          savedClientPreferenceMaps:
            response.data.datev_saved_client_preference_maps || {},
          globalSectionIncludeMap:
            response.data.datev_global_section_include_map || {},
          canManage: response.data.can_manage_section_preferences,
        });
        this.datevConfigPanelOpen = false;
      } catch (error) {
        console.error("Errore ricalcolo sezioni DATEV:", error);
        this.erroreModalMessaggio =
          error.response?.data?.error ||
          "Errore durante il ricalcolo delle sezioni DATEV.";
        this.erroreModalVisibile = true;
      } finally {
        this.datevSectionsApplying = false;
        this.calculating2 = false;
      }
    },
    openDatevReprocessConfirm() {
      if (!this.canApplyDatevSectionChanges) return;
      this.closeDatevClientMenu();
      this.resetConfirmContext = "datev-reprocess";
      this.resetConfirmTitle = "Rielaborare con le sezioni impostate?";
      this.resetConfirmEyebrow = "Impostazioni di estrazione";
      this.resetConfirmMessage =
        "Verrà rieseguita l'elaborazione usando le sezioni selezionate. I dati correnti estratti in questa fase verranno sostituiti dai nuovi risultati.";
      this.resetConfirmConfirmLabel = "Rielabora";
      this.resetConfirmCancelLabel = "Annulla";
      this.resetConfirmIconClass = "fa-solid fa-circle-info";
      this.resetConfirmConfirmIconClass = "fa-solid fa-rotate";
      this.showResetConfirmModal = true;
    },
    showConversionDiagnosticsModal(
      summary,
      backendMessage = "",
      inline = false
    ) {
      const notificationQueue = this.getDiagnosticsNotificationQueue(summary);
      const showInline = Boolean(
        inline &&
          summary &&
          summary.status !== "failed" &&
          notificationQueue.length
      );
      this.conversionDiagnosticsModal = {
        visible: Boolean(summary && notificationQueue.length && !showInline),
        summary: this.buildActiveDiagnosticsSummary(
          summary,
          notificationQueue,
          0
        ),
        rootSummary: summary || null,
        backendMessage: backendMessage || "",
        notificationQueue,
        notificationIndex: 0,
      };
      this.phase2View = showInline ? "quality" : "codes";
    },
    openStoredConversionDiagnostics() {
      const rootSummary =
        this.conversionDiagnosticsModal.rootSummary ||
        this.conversionDiagnosticsModal.summary;
      if (!rootSummary) return;
      const notificationQueue =
        this.getDiagnosticsNotificationQueue(rootSummary);
      if (!notificationQueue.length) return;
      this.conversionDiagnosticsModal.rootSummary = rootSummary;
      this.conversionDiagnosticsModal.notificationQueue = notificationQueue;
      this.conversionDiagnosticsModal.notificationIndex = 0;
      this.conversionDiagnosticsModal.summary =
        this.buildActiveDiagnosticsSummary(rootSummary, notificationQueue, 0);
      if (["warning", "degraded"].includes(rootSummary.status)) {
        this.conversionDiagnosticsModal.visible = false;
        this.phase2View = "quality";
      } else {
        this.conversionDiagnosticsModal.visible = true;
      }
    },
    closeConversionDiagnosticsModal() {
      const nextIndex = this.conversionDiagnosticsModal.notificationIndex + 1;
      const queue = this.conversionDiagnosticsModal.notificationQueue || [];
      if (nextIndex < queue.length) {
        this.conversionDiagnosticsModal.notificationIndex = nextIndex;
        this.conversionDiagnosticsModal.summary =
          this.buildActiveDiagnosticsSummary(
            this.conversionDiagnosticsModal.rootSummary,
            queue,
            nextIndex
          );
        this.conversionDiagnosticsModal.visible = true;
        return;
      }
      this.conversionDiagnosticsModal.visible = false;
    },
    goBackConversionDiagnosticsModal() {
      const previousIndex =
        this.conversionDiagnosticsModal.notificationIndex - 1;
      const queue = this.conversionDiagnosticsModal.notificationQueue || [];
      if (previousIndex < 0 || previousIndex >= queue.length) return;

      this.conversionDiagnosticsModal.notificationIndex = previousIndex;
      this.conversionDiagnosticsModal.summary =
        this.buildActiveDiagnosticsSummary(
          this.conversionDiagnosticsModal.rootSummary,
          queue,
          previousIndex
        );
      this.conversionDiagnosticsModal.visible = true;
    },
    advanceConversionQuality() {
      const modal = this.conversionDiagnosticsModal;
      const nextIndex = modal.notificationIndex + 1;
      if (nextIndex < modal.notificationQueue.length) {
        modal.notificationIndex = nextIndex;
        modal.summary = this.buildActiveDiagnosticsSummary(
          modal.rootSummary,
          modal.notificationQueue,
          nextIndex
        );
        return;
      }
      this.phase2View = "codes";
    },
    goBackConversionQuality() {
      const modal = this.conversionDiagnosticsModal;
      const previousIndex = modal.notificationIndex - 1;
      if (previousIndex < 0) return;
      modal.notificationIndex = previousIndex;
      modal.summary = this.buildActiveDiagnosticsSummary(
        modal.rootSummary,
        modal.notificationQueue,
        previousIndex
      );
    },
    reviewDatevSectionsFromDiagnostics() {
      this.conversionDiagnosticsModal.visible = false;
      this.openDatevSettingsFromQuality();
    },
    clearConversionDiagnosticsModal() {
      this.conversionDiagnosticsModal.visible = false;
      this.conversionDiagnosticsModal.summary = null;
      this.conversionDiagnosticsModal.rootSummary = null;
      this.conversionDiagnosticsModal.backendMessage = "";
      this.conversionDiagnosticsModal.notificationQueue = [];
      this.conversionDiagnosticsModal.notificationIndex = 0;
      this.phase2View = "codes";
    },
    getDiagnosticsNotificationQueue(summary) {
      const notifications = summary?.user_notifications;
      if (Array.isArray(notifications) && notifications.length) {
        return this.filterDiagnosticsNotificationQueue(notifications);
      }
      return summary ? [null] : [];
    },
    filterDiagnosticsNotificationQueue(notifications) {
      const excludedPages = new Set();
      notifications.forEach((notification) => {
        if (notification?.kind !== "excluded_pages") return;
        (notification?.user_events || []).forEach((event) => {
          this.getDiagnosticsEventPages(event).forEach((page) =>
            excludedPages.add(page)
          );
        });
      });

      return notifications
        .map((notification) => {
          if (notification?.kind !== "excluded_sections") {
            return notification;
          }

          const userEvents = (notification.user_events || [])
            .map((event) => {
              const pages = this.getDiagnosticsEventPages(event);
              if (!pages.length || !excludedPages.size) return event;

              const availablePages = pages.filter(
                (page) => !excludedPages.has(page)
              );
              if (!availablePages.length) return null;
              if (availablePages.length === pages.length) return event;
              return {
                ...event,
                pages: availablePages,
              };
            })
            .filter(Boolean);

          if (!userEvents.length) return null;
          return {
            ...notification,
            user_events: userEvents,
          };
        })
        .filter(Boolean);
    },
    getDiagnosticsEventPages(event) {
      if (!Array.isArray(event?.pages)) return [];
      return event.pages
        .map((page) => Number(page))
        .filter((page) => Number.isFinite(page));
    },
    buildActiveDiagnosticsSummary(summary, notificationQueue, index) {
      if (!summary) return null;
      const queue = notificationQueue || [];
      const notification = queue[index];
      if (!notification) {
        return {
          ...summary,
          has_more_notifications: false,
        };
      }
      return {
        ...summary,
        status: notification.status || summary.status,
        user_title: notification.user_title || summary.user_title,
        user_message: notification.user_message || summary.user_message,
        support_message: notification.support_message,
        user_events: Array.isArray(notification.user_events)
          ? notification.user_events
          : [],
        current_notification_kind: notification.kind,
        notification_index: index,
        notification_count: queue.length,
        has_more_notifications: index < queue.length - 1,
      };
    },
    determineCurrentPlan() {
      if (isPiano(this.user, "premium")) {
        this.currentPlan = "Premium";
      } else if (isPiano(this.user, "plus")) {
        this.currentPlan = "Plus";
      } else {
        this.currentPlan = "Base";
      }
    },
    getJobStorageKey() {
      return "conversion-job:prospetti";
    },
    isPersistableJobStatus(status) {
      return ["queued", "running", "cancel_requested"].includes(status);
    },
    isPollableJobStatus(status) {
      return ["queued", "running", "cancel_requested"].includes(status);
    },
    isConversionBusy() {
      return (
        (this.jobId &&
          !["completed", "failed", "cancelled"].includes(this.jobStatus)) ||
        this.calculating ||
        this.calculating2
      );
    },
    hasUndownloadedCompletedOutput() {
      return (
        this.fase3 && Boolean(this.filePath) && !this.hasOutputDownloadStarted
      );
    },
    shouldConfirmReset() {
      if (this.hasUndownloadedCompletedOutput()) {
        return true;
      }

      return (
        this.isConversionBusy() &&
        (this.calculating ||
          this.calculating2 ||
          this.fase1 ||
          this.fase2 ||
          this.fase3)
      );
    },
    openConversionInterruptModal(context, routeNext = null) {
      this.resetConfirmContext = context;
      this.pendingRouteLeaveNext = routeNext;

      if (this.hasUndownloadedCompletedOutput()) {
        this.resetConfirmTitle =
          context === "leave"
            ? "Uscire senza scaricare?"
            : "Resettare senza scaricare?";
        this.resetConfirmEyebrow = "Download non ancora eseguito";
        this.resetConfirmMessage =
          context === "leave"
            ? "La conversione è terminata, ma il file elaborato non è stato scaricato. Uscendo dalla pagina perderai questo risultato."
            : "La conversione è terminata, ma il file elaborato non è stato scaricato. Resettando il convertitore perderai questo risultato.";
        this.resetConfirmConfirmLabel =
          context === "leave"
            ? "Esci senza scaricare"
            : "Resetta senza scaricare";
        this.resetConfirmCancelLabel = "Annulla";
        this.resetConfirmConfirmIconClass =
          context === "leave"
            ? "fa-solid fa-right-from-bracket"
            : "fa-solid fa-arrows-rotate";
      } else if (context === "leave") {
        this.resetConfirmTitle = "Uscire dalla pagina?";
        this.resetConfirmEyebrow = "Conversione in corso";
        this.resetConfirmMessage =
          "La conversione è ancora in corso. Uscendo dalla pagina interromperai l'elaborazione e i dati temporanei verranno puliti.";
        this.resetConfirmConfirmLabel = "Interrompi e esci";
        this.resetConfirmCancelLabel = "Annulla";
        this.resetConfirmConfirmIconClass = "fa-solid fa-right-from-bracket";
      } else {
        this.resetConfirmTitle = "Interrompere la conversione?";
        this.resetConfirmEyebrow = "Reset convertitore";
        this.resetConfirmMessage =
          "La conversione è ancora in corso. Interrompendo l'elaborazione la pagina verrà azzerata.";
        this.resetConfirmConfirmLabel = "Interrompi e resetta";
        this.resetConfirmCancelLabel = "Annulla";
        this.resetConfirmConfirmIconClass = "fa-solid fa-arrows-rotate";
      }

      this.resetConfirmIconClass = "fa-solid fa-triangle-exclamation";
      this.showResetConfirmModal = true;
    },
    cancelConversionInterrupt() {
      if (this.pendingRouteLeaveNext) {
        this.pendingRouteLeaveNext(false);
      }
      this.showResetConfirmModal = false;
      this.pendingRouteLeaveNext = null;
      this.pendingRouteLeaveTarget = null;
      this.resetConfirmContext = "reset";
    },
    shouldConfirmTableEditsBeforeConversion() {
      return (
        !this.pendingTableEditConversion &&
        this.pendingTableEditLabels.length > 0
      );
    },
    openTableEditsConversionConfirm() {
      const labels = this.pendingTableEditLabels.join(", ");
      this.resetConfirmContext = "table-edits";
      this.resetConfirmTitle = "Salvare le modifiche?";
      this.resetConfirmEyebrow = "Modifiche non confermate";
      this.resetConfirmMessage = `Hai modifiche non salvate in: ${labels}. Vuoi salvarle e proseguire con la conversione?`;
      this.resetConfirmConfirmLabel = "Salva e converti";
      this.resetConfirmCancelLabel = "Annulla";
      this.resetConfirmIconClass = "fa-solid fa-circle-info";
      this.resetConfirmConfirmIconClass = "fa-solid fa-floppy-disk";
      this.showResetConfirmModal = true;
    },
    handleConfirmActionClose() {
      if (this.resetConfirmContext === "table-edits") {
        this.showResetConfirmModal = false;
        this.resetConfirmContext = "reset";
        return;
      }
      if (this.resetConfirmContext === "table-reset") {
        this.showResetConfirmModal = false;
        this.resetConfirmContext = "reset";
        this.pendingTableReset = null;
        return;
      }
      if (this.resetConfirmContext === "datev-reprocess") {
        this.showResetConfirmModal = false;
        this.resetConfirmContext = "reset";
        return;
      }
      this.cancelConversionInterrupt();
    },
    handleConfirmActionConfirm() {
      if (this.resetConfirmContext === "table-edits") {
        this.showResetConfirmModal = false;
        this.commitAllProspettiTableEdits();
        this.resetConfirmContext = "reset";
        this.pendingTableEditConversion = true;
        this.$nextTick(() => {
          this.fase_3();
          this.pendingTableEditConversion = false;
        });
        return;
      }
      if (this.resetConfirmContext === "table-reset") {
        this.showResetConfirmModal = false;
        this.confirmResetProspettiTable();
        this.resetConfirmContext = "reset";
        return;
      }
      if (this.resetConfirmContext === "datev-reprocess") {
        this.showResetConfirmModal = false;
        this.resetConfirmContext = "reset";
        this.applyDatevSectionChanges();
        return;
      }
      this.confirmResetDuringJob();
    },
    commitAllProspettiTableEdits() {
      if (this.tableEditSessions["pp-main"]) {
        this.applyMainPdcChangesToClientGroups();
        this.commitTableEditSession("pp-main", this.vettoreCodConto);
      }
      if (this.tableEditSessions["pp-pdc"]) {
        this.applySavedPdcChangesToClientGroups();
        this.commitTableEditSession("pp-pdc", this.vettoreCodContoPDC);
      }
      this.allPdcClientGroups.forEach((group) => {
        const key = this.getPdcClientTableKey(group.client_key);
        if (this.hasTableChanges(key)) {
          this.markPdcClientRowsAsCustom(key);
          this.markPdcClientGroupForPersistence(key);
        }
        if (this.tableEditSessions[key]) {
          this.commitTableEditSession(key, group.rows);
        }
      });
      this.allPdcClientPdcGroups.forEach((group) => {
        const key = this.getPdcClientPdcTableKey(group.client_key);
        if (this.hasTableChanges(key)) {
          this.markPdcClientPdcRowsAsCustom(key);
          this.markPdcClientPdcGroupForPersistence(key);
        }
        if (this.tableEditSessions[key]) {
          this.commitTableEditSession(key, group.rows);
        }
      });
      this.isEditMode = false;
      this.isEditModePDC = false;
      this.isEditModePdcClient = false;
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async waitForResetOverlayMinimum(startedAt) {
      const remaining = Math.max(1000 - (Date.now() - startedAt), 0);
      if (remaining > 0) {
        await this.wait(remaining);
      }
    },
    navigateHomeSafely() {
      if (this.shouldConfirmReset()) {
        this.pendingRouteLeaveTarget = "/home";
        this.openConversionInterruptModal("leave");
        return;
      }

      this.$router.push("/home");
    },
    persistJobState() {
      if (this.jobId && this.isPersistableJobStatus(this.jobStatus)) {
        sessionStorage.setItem(
          this.getJobStorageKey(),
          JSON.stringify({
            jobId: this.jobId,
            finalConversionInProgress: this.finalConversionInProgress,
          })
        );
      } else {
        this.removePersistedJobState();
      }
    },
    removePersistedJobState() {
      sessionStorage.removeItem(this.getJobStorageKey());
    },
    async cleanupPurgeableJobs() {
      try {
        await axios.post(`${API_BASE_URL}/conversion_jobs/cleanup_purgeable`, {
          tool: "prospetti_paghe",
        });
      } catch (error) {
        console.error("Errore durante il cleanup dei job prospetti:", error);
      }
    },
    async cleanupSpecificJob(jobId) {
      if (!jobId) return;
      try {
        await axios.post(`${API_BASE_URL}/conversion_jobs/${jobId}/cleanup`);
      } catch (error) {
        if (![404, 409].includes(error.response?.status)) {
          console.error("Errore durante il cleanup del job:", error);
        }
      }
    },
    async waitForJobToBecomePurgeable(jobId, timeoutMs = 5000) {
      if (!jobId) return false;
      const deadline = Date.now() + timeoutMs;
      while (Date.now() < deadline) {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/conversion_jobs/${jobId}/status`
          );
          const status = response.data.job?.status;
          if (["draft", "completed", "failed", "cancelled"].includes(status)) {
            return true;
          }
        } catch (error) {
          if (error.response?.status === 404) {
            return true;
          }
        }
        await new Promise((resolve) => setTimeout(resolve, 400));
      }
      return false;
    },
    handleWindowBeforeUnload(event) {
      if (this.hasUndownloadedCompletedOutput()) {
        event.preventDefault();
        event.returnValue = "";
        return "";
      }
      return undefined;
    },
    handleWindowPageHide() {
      if (!this.jobId) return;
      const jobId = this.jobId;
      if (this.isPollableJobStatus(this.jobStatus)) {
        fetch(`${API_BASE_URL}/conversion_jobs/${jobId}/cancel`, {
          method: "POST",
          credentials: "include",
          keepalive: true,
        }).catch(() => {});
        return;
      }
      fetch(`${API_BASE_URL}/conversion_jobs/${jobId}/cleanup`, {
        method: "POST",
        credentials: "include",
        keepalive: true,
      }).catch(() => {});
    },
    clearJobState() {
      this.stopJobPolling();
      this.jobId = null;
      this.jobStatus = null;
      this.isCancelling = false;
      this.finalConversionInProgress = false;
      this.persistJobState();
    },
    stopJobPolling() {
      if (this.jobPollTimer) {
        clearInterval(this.jobPollTimer);
        this.jobPollTimer = null;
      }
    },
    startJobPolling() {
      this.stopJobPolling();
      if (!this.jobId) return;
      this.fetchJobStatus();
      this.jobPollTimer = setInterval(() => {
        this.fetchJobStatus(true);
      }, 2500);
    },
    async fetchJobStatus(silent = false) {
      if (!this.jobId) return;
      try {
        const response = await axios.get(
          `${API_BASE_URL}/conversion_jobs/${this.jobId}/status`
        );
        this.applyJobState(response.data.job);
      } catch (error) {
        if (error.response?.status === 404) {
          this.calculating = false;
          this.calculating2 = false;
          this.stopJobPolling();
          this.clearJobState();
          return;
        }
        if (!silent) {
          console.error("Errore nel recupero dello stato job:", error);
        }
      }
    },
    applyJobState(job) {
      if (!job) return;
      this.jobId = job.job_id;
      this.jobStatus = job.status;
      this.persistJobState();

      if (job.status === "draft") {
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.stopJobPolling();
        this.clearJobState();
        return;
      }

      this.isShifted = true;
      this.showResult = true;
      this.fase0 = false;

      if (job.status === "completed") {
        this.removePersistedJobState();
        this.filePath = job.result_file_name;
        this.filesNames = job.result_files || [];
        this.downloadType = job.result_file_type;
        this.hasOutputDownloadStarted = false;
        this.fileName =
          job.result_file_type === "zip"
            ? "Prospetti Paghe.zip"
            : job.result_file_name;
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.fase1 = false;
        this.fase2 = false;
        this.fase3 = true;
        this.errorMessage = "";
        this.stopJobPolling();
        this.getMergedOverall();
        return;
      }

      if (job.status === "failed") {
        const failedJobId = job.job_id;
        this.removePersistedJobState();
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.errorMessage = job.error_message || job.message || "Errore job";
        this.stopJobPolling();
        this.clearJobState();
        this.cleanupSpecificJob(failedJobId);
        this.cleanupPurgeableJobs();
        return;
      }

      if (job.status === "cancelled") {
        const cancelledJobId = job.job_id;
        this.removePersistedJobState();
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.errorMessage = "Conversione annullata.";
        this.stopJobPolling();
        this.clearJobState();
        this.cleanupSpecificJob(cancelledJobId);
        this.cleanupPurgeableJobs();
        return;
      }

      this.calculating = false;
      this.calculating2 = true;
      this.fase1 = false;
      this.fase2 = true;
      this.fase3 = false;
    },
    async resumeStoredJob() {
      const raw = sessionStorage.getItem(this.getJobStorageKey());
      if (!raw) return;

      try {
        const parsed = JSON.parse(raw);
        if (!parsed?.jobId) return;
        this.jobId = parsed.jobId;
        this.finalConversionInProgress = Boolean(
          parsed.finalConversionInProgress
        );
        await this.fetchJobStatus();
        if (this.jobId && this.isPollableJobStatus(this.jobStatus)) {
          this.startJobPolling();
        }
      } catch (error) {
        console.error("Errore nel ripristino del job:", error);
      }
    },
    async cancelActiveJob(resetAfter = true) {
      if (!this.jobId) {
        if (resetAfter) this.resetConversione();
        return;
      }

      const jobId = this.jobId;
      this.isCancelling = true;
      try {
        await axios.post(`${API_BASE_URL}/conversion_jobs/${jobId}/cancel`);
      } catch (error) {
        console.error("Errore nell'annullamento del job:", error);
      } finally {
        this.isCancelling = false;
      }

      await this.waitForJobToBecomePurgeable(jobId);
      await this.cleanupSpecificJob(jobId);
      await this.cleanupPurgeableJobs();
      this.stopJobPolling();
      this.clearJobState();
      if (resetAfter) {
        this.resetConversione();
      }
    },
    fase_1() {
      if (this.selectedFile) {
        if (!this.output_PC) {
          this.errorMessage =
            "Devi selezionare il Software contabile di conversione!";
          setTimeout(() => {
            this.errorMessage = "";
          }, 4000);
          return;
        }
        if (this.needsProspettiCausale()) {
          this.openProspettiCausaleModal({ retryFase1AfterSave: true });
          return;
        }
        this.inputPcEditable = false;
        this.excelPath = null;
        this.calculating = true; // Mostra il messaggio di calcolo in corso
        this.errorMessage = "";
        const formData = new FormData();
        this.jobId = this.jobId || crypto.randomUUID();
        formData.append("pdfFile", this.selectedFile);
        formData.append("output_PC", this.output_PC);
        formData.append("job_id", this.jobId);

        this.startDelayMessageTimer();
        axios
          .post(`${API_BASE_URL}/fase_1`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.clearDelayMessageTimer();
            this.applyCodContoDefaultFromResponse(res.data);
            this.jobId = res.data.job_id || this.jobId;
            this.input_file_path = res.data.input_file_path;
            this.input_PC = res.data.input_PC;
            this.vettoreClienti = res.data.vettoreClienti;
            console.log("this.vettoreClienti è");
            console.log(this.vettoreClienti);
            this.vettoreClienti_SEAC = res.data.vettoreClienti_SEAC;
            this.numeroClienti = res.data.numeroClienti;
            this.creditiDisponibili = res.data.crediti_disponibili;
            this.fase1 = true;
            return this.nextConversionStep(); // Mantiene il loading durante l'ingresso dei risultati
          })
          .catch((err) => {
            this.clearDelayMessageTimer();
            if (err.response?.data?.code === "JOB_ALREADY_RUNNING") {
              this.applyJobState(err.response.data.job);
              this.startJobPolling();
              return;
            }
            // Qui gestisci l'errore ricevuto dal backend
            if (err.response && err.response.data && err.response.data.error) {
              this.errorMessage = err.response.data.error; // Mostra il messaggio di errore ricevuto
            } else {
              this.errorMessage = "Errore nella richiesta al server.";
            }
            this.fase1 = false;
          })
          .then(() => {
            this.calculating = false; // Nasconde il messaggio di calcolo in corso
            if (this.errorMessage) {
              setTimeout(() => {
                this.errorMessage = null;
              }, 3500);
            }
          });
      }
    },
    fase_2(registryConfirmed = false) {
      // Controllo per input_PC "SEAC": verifica che gli indici 1 e 2 di vettoreClienti_SEAC siano completi
      if (this.input_PC === "SEAC") {
        const clientiIncompletiSEAC = this.vettoreClienti_SEAC.some(
          (cliente) =>
            cliente[2] === 0 ||
            cliente[2] === "" ||
            cliente[2] === null ||
            cliente[2] === undefined ||
            cliente[3] === 0 ||
            cliente[3] === "" ||
            cliente[3] === null ||
            cliente[3] === undefined
        );

        if (clientiIncompletiSEAC) {
          this.erroreModalMessaggio =
            "Specifica per ogni cliente Contabilità Ordinaria o Contabilità Semplificata prima di proseguire.";
          this.erroreModalVisibile = true;
          return; // Interrompe l'esecuzione
        }
      }

      // Controllo per output_PC "DATEV": tutti i clienti devono avere una selezione
      if (this.output_PC === "DATEV") {
        const clientiIncompleti = this.vettoreClienti.some(
          (cliente) =>
            cliente[2] === 0 ||
            cliente[2] === "" ||
            cliente[2] === null ||
            cliente[2] === undefined
        );

        if (clientiIncompleti) {
          this.erroreModalMessaggio =
            "Specifica per ogni cliente se è un Azienda o un Libero Professionista prima di proseguire.";
          this.erroreModalVisibile = true;
          return;
        }
      }
      if (this.needsProspettiCausale()) {
        this.openProspettiCausaleModal({ retryFase2AfterSave: true });
        return;
      }
      const clienti =
        this.input_PC === "SEAC"
          ? this.vettoreClienti_SEAC
          : this.vettoreClienti;

      let ciSonoMancanti = false;
      let ciSonoNonValidi = false;

      clienti.forEach((cliente) => {
        const codDitta = (cliente[0] || "").trim();
        const codiceFiscale = (cliente[4] || "").trim();

        // Controllo CF → sempre obbligatorio
        if (!codiceFiscale) {
          ciSonoMancanti = true;
        }

        if (codiceFiscale && !this.isValidCodiceFiscale(codiceFiscale)) {
          ciSonoNonValidi = true;
        }

        // Controllo codice ditta → obbligatorio SOLO se il flag è true
        if (this.settings.flag_mostra_codice_ditta && !codDitta) {
          ciSonoMancanti = true;
        }
      });

      // Errore sui CF non validi (indipendente dal flag)
      if (ciSonoNonValidi) {
        this.erroreModalMessaggio =
          "Alcuni Codici fiscali non sono validi.\n\n";
        this.erroreModalVisibile = true;
        return;
      }

      // Errore sui campi mancanti
      if (ciSonoMancanti) {
        if (this.settings.flag_mostra_codice_ditta) {
          // Caso classico: entrambi obbligatori
          this.erroreModalMessaggio =
            "Inserisci Codice ditta e Codice fiscale per tutti i clienti.";
        } else {
          // Solo CF obbligatorio
          this.erroreModalMessaggio =
            "Inserisci il Codice fiscale per tutti i clienti.";
        }

        this.erroreModalVisibile = true;
        return;
      }
      this.calculating2 = true;

      // Costruisci l'oggetto da inviare al backend
      const payload = {
        job_id: this.jobId,
        input_PC: this.input_PC,
        input_file_path: this.input_file_path,
        output_PC: this.output_PC,
        vettoreClienti: this.vettoreClienti,
        vettoreClienti_SEAC: this.vettoreClienti_SEAC,
        flag_saldoProspettiPaghe: this.settings.flag_saldoProspettiPaghe,
        confirm_registry_associations: registryConfirmed,
      };
      this.startDelayMessageTimer();
      // Effettua la richiesta HTTP al backend
      axios
        .post(`${API_BASE_URL}/fase_2`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.clearDelayMessageTimer();
          this.applyCodContoDefaultFromResponse(response.data);
          this.jobId = response.data.job_id || this.jobId;
          if (Array.isArray(response.data.vettoreClienti)) {
            this.vettoreClienti = response.data.vettoreClienti;
          }
          if (Number.isFinite(Number(response.data.numeroClienti))) {
            this.numeroClienti = Number(response.data.numeroClienti);
          }
          const cleanedData = this.cleanProspettiRows(
            response.data.vettoreCodConto || []
          );
          this.vettoreCodConto = cleanedData;
          console.log("this.vettoreCodConto:");
          console.log(this.vettoreCodConto);
          const cleanedDataPDC = this.cleanProspettiRows(
            response.data.vettoreCodContoPDC || []
          );
          this.vettoreCodContoPDC = cleanedDataPDC;
          this.originalPDC = JSON.parse(JSON.stringify(cleanedDataPDC));
          this.primeTableEditSession(
            "pp-main",
            "CODICI CONTO INDIVIDUATI",
            this.vettoreCodConto,
            true
          );
          this.primeTableEditSession(
            "pp-pdc",
            "CODICI CONTO GIÀ SALVATI",
            this.vettoreCodContoPDC,
            true
          );
          this.clientCustomPdcEntries =
            response.data.client_custom_pdc_entries || {};
          this.setPdcClientGroups(response.data.pdc_client_groups || {});
          this.setDatevAnomalySectionKeys(
            response.data.datev_anomaly_section_keys || []
          );
          this.setDatevSectionInfos(response.data.datev_section_infos || [], {
            savedClientPreferenceKeys:
              response.data.datev_saved_client_preference_keys || [],
            savedClientPreferenceMaps:
              response.data.datev_saved_client_preference_maps || {},
            globalSectionIncludeMap:
              response.data.datev_global_section_include_map || {},
            canManage: response.data.can_manage_section_preferences,
          });
          // Salva una copia profonda dei dati filtrati
          this.fase1 = false;
          this.fase2 = true;
          this.calculating2 = false;
          const diagnosticsSummary = response.data.diagnostics_summary;
          if (
            diagnosticsSummary &&
            diagnosticsSummary.has_user_visible_diagnostics !== false &&
            diagnosticsSummary.has_diagnostics
          ) {
            this.showConversionDiagnosticsModal(diagnosticsSummary, "", true);
          }
        })
        .catch(async (error) => {
          this.clearDelayMessageTimer();
          if (isClientRegistryConfirmation(error)) {
            this.calculating2 = false;
            confirmClientRegistryAssociations(error, () => this.fase_2(true));
            return;
          }
          console.error("Errore nella conversione:", error);
          const responseData = error.response?.data || {};
          let diagnosticsSummary = responseData.diagnostics_summary;
          const backendMessage =
            responseData.error ||
            "Errore durante la conversione. Riprova o contatta l'assistenza.";

          if (!diagnosticsSummary) {
            diagnosticsSummary =
              await this.fetchDiagnosticsSummaryForCurrentJob();
          }

          if (
            diagnosticsSummary &&
            diagnosticsSummary.has_user_visible_diagnostics !== false
          ) {
            this.showConversionDiagnosticsModal(
              diagnosticsSummary,
              backendMessage
            );
          } else {
            this.erroreModalTitolo = "Errore conversione";
            this.erroreModalMessaggio = backendMessage;
            this.erroreModalVisibile = true;
          }
          this.calculating2 = false;
        });
    },

    async fetchDiagnosticsSummaryForCurrentJob() {
      if (!this.jobId) return null;
      try {
        const response = await axios.get(
          `${API_BASE_URL}/conversion_jobs/${this.jobId}/diagnostics_summary`
        );
        const summary = response.data?.diagnostics_summary;
        return summary &&
          summary.has_diagnostics &&
          summary.has_user_visible_diagnostics !== false
          ? summary
          : null;
      } catch (error) {
        console.error("Errore recupero diagnostica job:", error);
        return null;
      }
    },

    fase_3() {
      if (this.shouldConfirmTableEditsBeforeConversion()) {
        this.openTableEditsConversionConfirm();
        return;
      }
      if (!this.validateAllInputs()) {
        return; // Interrompe l'esecuzione se manca qualche dato
      }
      if (this.needsProspettiCausale()) {
        this.openProspettiCausaleModal({ retryAfterSave: true });
        return;
      }
      this.finalConversionInProgress = true;
      this.calculating2 = true;
      // Creazione del nuovo array con gli elementi interni accorciati
      // Determina le colonne visibili per l'output_PC attuale
      const validColumns = this.getValidColumns();
      // === 1. Prepara il vettore principale ===
      let finalVector = this.vettoreCodConto.map((row) =>
        row
          .map((cell, index) =>
            index === 0 || validColumns.includes(index) ? cell : null
          )
          .slice(0, -2)
      );
      // === 2. Unisci PDC SOLO se modificato ===
      if (this.isPDCModified() && this.vettoreCodContoPDC.length > 0) {
        const pdcValidCols = this.validColumnsPDC || validColumns;
        const pdcRows = this.vettoreCodContoPDC.map((row) =>
          row
            .map((cell, index) =>
              index === 0 || pdcValidCols.includes(index) ? cell : null
            )
            .slice(0, -2)
        );
        finalVector = [...finalVector, ...pdcRows];
        console.log("PDC MODIFICATO → righe aggiunte:", pdcRows.length);
      } else {
        console.log("PDC NON MODIFICATO → non unito");
      }

      console.log("VETTORE FINALE (unificato):", finalVector);

      this.flag_output_std = !this.flag_csv_import;

      // Costruisci l'oggetto da inviare al backend
      const payload = {
        job_id: this.jobId,
        input_PC: this.input_PC,
        output_PC: this.output_PC,
        vettoreClienti: this.vettoreClienti,
        flag_output_std: this.flag_output_std,
        flag_overall: this.isExtendedVersion,
        vettoreCodConto: finalVector,
        causale: this.causaleProspettiPaghe || null,
      };
      const pdcClientGroupsPayload =
        this.buildPdcClientGroupsPayloadForConversion();
      if (pdcClientGroupsPayload) {
        payload.pdc_client_groups = pdcClientGroupsPayload;
        payload.client_custom_pdc_entries = this.clientCustomPdcEntries;
      }
      this.startDelayMessageTimer();
      // Effettua la richiesta HTTP al backend
      axios
        .post(`${API_BASE_URL}/fase_3`, payload, {
          headers: { "Content-Type": "application/json" }, // NON serve responseType blob qui
        })
        .then((res) => {
          this.clearDelayMessageTimer();
          this.naConfirmed = false;

          if (res.data.success && res.data.job) {
            this.hasDownloaded = false;
            this.applyJobState(res.data.job);
            this.startJobPolling();
          } else {
            this.errorMessage = res.data.error || "Errore generico dal backend";
            this.calculating2 = false;
            this.finalConversionInProgress = false;
          }
        })
        .catch((err) => {
          this.clearDelayMessageTimer();
          this.errorMessage = "Errore di comunicazione col server";
          this.calculating2 = false;
          this.finalConversionInProgress = false;
          console.error("Errore nella richiesta Axios:", err);
        });
    },
    nextConversionStep() {
      this.isShifted = true;
      this.showResult = true;
      return this.$nextTick().then(
        () =>
          new Promise((resolve) => {
            setTimeout(resolve, 720);
          })
      );
    },
    loadSettings() {
      const loaded = getUserSettings();

      // Merge sicuro: sovrascrive i default con i valori reali (se presenti)
      this.settings = {
        ...this.settings, // mantiene i default se qualcosa manca
        ...loaded,
      };

      // Dopo aver caricato le settings, applica le preferenze specifiche
      this.applySoftwarePreference();

      console.log("Tutte le impostazioni caricate:", this.settings);
    },

    // Metodo separato solo per applicare la preferenza software
    // (lo teniamo separato per chiarezza, ma potrebbe anche stare dentro loadAllSettings)
    applySoftwarePreference() {
      const saved = this.settings.software_contabile || "default";

      const mapping = {
        TEAMSYSTEM: "TEAMSYSTEM",
        DATEV: "DATEV",
        ZUCCHETTI: "ZUCCHETTI",
        SISTEMI: "SISTEMI",
        SEAC: "SEAC",
      };

      if (mapping[saved]) {
        this.output_PC = mapping[saved];
      }
    },
    async refreshConversione() {
      if (this.shouldConfirmReset()) {
        this.openConversionInterruptModal("reset");
        return;
      }
      if (this.jobId) {
        if (this.isPollableJobStatus(this.jobStatus)) {
          await this.cancelActiveJob(false);
        } else {
          await this.cleanupSpecificJob(this.jobId);
          await this.cleanupPurgeableJobs();
        }
      }
      this.resetConversione();
    },
    async confirmResetDuringJob() {
      const context = this.resetConfirmContext;
      const routeNext = this.pendingRouteLeaveNext;
      const routeTarget = this.pendingRouteLeaveTarget;
      const isCompletedOutputPending = this.hasUndownloadedCompletedOutput();
      this.showResetConfirmModal = false;
      this.isResettingConversion = true;
      const resetStartedAt = Date.now();
      try {
        if (isCompletedOutputPending) {
          if (this.jobId) {
            await this.cleanupSpecificJob(this.jobId);
            await this.cleanupPurgeableJobs();
          }
          this.clearJobState();
        } else {
          await this.cancelActiveJob(false);
        }
        await this.waitForResetOverlayMinimum(resetStartedAt);
        if (context === "leave" && routeTarget) {
          this.$router.push(routeTarget);
        } else if (context === "leave" && routeNext) {
          routeNext();
        } else {
          this.resetConversione();
          await this.$nextTick();
          await this.wait(40);
        }
      } finally {
        this.isResettingConversion = false;
        this.pendingRouteLeaveNext = null;
        this.pendingRouteLeaveTarget = null;
        this.resetConfirmContext = "reset";
      }
    },
    resetConversione() {
      setTimeout(() => {
        this.isShifted = false; // Rimuove il "shift" per tornare alla posizione iniziale
      }, 10); // Il delay di 10ms è per permettere alla transizione di essere applicata
      // Resetta il file input
      if (this.filePDF_URL) {
        URL.revokeObjectURL(this.filePDF_URL);
      }
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
      this.showResult = false;
      this.fase0 = true;
      this.fase1 = false;
      this.fase2 = false;
      this.fase3 = false;
      this.phase2View = "codes";
      this.selectedFile = null;
      this.filePDF_URL = null;
      this.fileTitle = null;
      this.ExcelRows = [];
      this.fileType = "";
      this.excelPath = null;
      this.input_file_path = null;
      this.mergedOverall = null;
      this.filePath = null;
      this.showPDF = false;
      this.showExcelModal = false;
      this.input_PC = "";
      this.errorMessage = "";
      this.flag_csv_import = false;
      this.flag_output_std = false;
      this.isExtendedVersion = false;
      this.vettoreClienti = [];
      this.vettoreCodConto = [];
      this.vettoreCodContoPDC = [];
      this.pdcClientGroups = {
        global: [],
        global_pdc: [],
        custom: [],
        custom_pdc: [],
        non_custom: [],
        non_custom_pdc: [],
      };
      this.clientCustomPdcEntries = {};
      this.pdcClientTableMode = "all";
      this.selectedPdcClientKey = "";
      this.pdcClientDropdownOpen = false;
      this.pdcCodeViewDropdownOpen = false;
      this.isEditModePdcClient = false;
      this.pdcClientGroupsToPersist = {};
      this.pdcClientGroupRowIndexesToPersist = {};
      this.pdcClientCustomRowKeysToRemove = {};
      this.datevSectionInfos = [];
      this.originalDatevSectionInfos = [];
      this.datevAnomalySectionKeys = [];
      this.datevSectionsApplying = false;
      this.datevConfigPanelOpen = false;
      this.selectedDatevClientKey = "summary";
      this.datevClientMenuOpen = false;
      this.datevClientSearchQuery = "";
      this.datevPersistGlobalPreference = false;
      this.datevPersistClientPreferences = {};
      this.datevGlobalPreferenceValues = {};
      this.datevSavedClientPreferenceKeys = [];
      this.datevSavedClientPreferenceMaps = {};
      this.datevPendingClientPreferenceDeletes = {};
      this.datevGlobalSectionIncludeMap = {};
      this.originalDatevGlobalSectionIncludeMap = {};
      this.canManageSectionPreferences = false;
      this.originalPDC = null;
      this.confermaConversione = false;
      this.hasDownloaded = false;
      this.hasOutputDownloadStarted = false;
      this.isEditMode = false;
      this.isEditModePDC = false;
      this.clearAllTableEditSessions();
      this.vettorePDCVisible = false;
      this.isTableExpanded = false;
      this.isClientTableExpanded = false;
      this.isCodContoTableExpanded = false;
      this.isMergedTableExpanded = false;
      this.isTablePDCExpanded = false;
      this.errorsData = [];
      this.showErrorModal = false;
      this.erroreModalVisibile = false;
      this.erroreModalMessaggio = "";
      this.clearConversionDiagnosticsModal();
      this.naConfirmed = false;
      this.noCorrConfirmed = false;
      this.showCoinPurchase = false;
      this.clearDelayMessageTimer();
      this.clearJobState();
      this.loadSettings();
    },
    async fetchClients() {
      try {
        const response = await axios.get(`${API_BASE_URL}/vettore_datev`);
        this.vettoreClienti = response.data;
      } catch (error) {
        console.error("Errore nel recupero dei clienti:", error);
      }
    },
    getMergedOverall() {
      if (!this.jobId) return;
      axios
        .get(`${API_BASE_URL}/merged_overall`, {
          params: { job_id: this.jobId },
          responseType: "arraybuffer", // Importante per dati binari
        })
        .then((response) => {
          const data = new Uint8Array(response.data); // Converte i dati in array di byte
          const workbook = XLSX.read(data, { type: "array" }); // Legge il file Excel
          const firstSheetName = workbook.SheetNames[0]; // Prende il nome del primo foglio
          const worksheet = workbook.Sheets[firstSheetName];

          // Converte i dati del foglio in JSON e li salva in mergedOverall
          this.mergedOverall = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          });
          // Normalizza le righe per avere lo stesso numero di colonne
          const maxColumns = this.mergedOverall[0].length;
          this.mergedOverall.forEach((row) => {
            while (row.length < maxColumns) {
              row.push(""); // Aggiunge celle vuote se mancano
            }
          });
          this.mergedOverall[0].push(""); // Aggiunge un header vuoto per la colonna del cestino
        })
        .catch((error) => {
          console.error("Errore nel caricamento di Merged Overall:", error);
        });
    },
    isBilancino(row) {
      const firstCell = row?.[0]?.toString().trim() || "";
      const secondCell = row?.[1];
      const secondCellIsEmpty =
        secondCell === undefined ||
        secondCell === null ||
        secondCell === "" ||
        secondCell === "None";

      return firstCell.startsWith("Prospetto Paghe") && secondCellIsEmpty;
    },
    handleFileChange(event) {
      console.log(
        "Change event triggered - files length:",
        event.target.files.length,
        "restoringFile:",
        this.restoringFile
      );

      // If we're restoring, skip processing to avoid infinite loop
      if (this.restoringFile) {
        this.restoringFile = false;
        console.log(
          "Restoration complete - selectedFile:",
          this.selectedFile?.name,
          "fileTitle:",
          this.fileTitle,
          "input files:",
          this.$refs.fileInput.files[0]?.name
        );
        // Check if files were cleared unexpectedly and reapply restoration
        if (this.selectedFile && !this.$refs.fileInput.files.length) {
          console.log(
            "Files cleared unexpectedly, reapplying restoration for:",
            this.selectedFile.name
          );
          this.$nextTick(() => {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(this.selectedFile);
            this.$refs.fileInput.files = dataTransfer.files;
            console.log(
              "Re-restoration attempted - input files:",
              this.$refs.fileInput.files[0]?.name
            );
          });
        }
        return;
      }

      const newFile = event.target.files[0];

      // Detect cancel: files.length === 0 (browser cleared it)
      if (!newFile) {
        if (this.selectedFile) {
          console.log(
            "Cancel detected - restoring file:",
            this.selectedFile.name
          );
          this.$nextTick(() => {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(this.selectedFile);
            this.$refs.fileInput.files = dataTransfer.files;
            this.restoringFile = true; // Set flag for potential change event
            this.fileTitle = this.selectedFile.name; // Ensure fileTitle is in sync
            console.log(
              "Restoration attempted - input files:",
              this.$refs.fileInput.files[0]?.name
            );
          });
        } else {
          this.fileTitle = "Nessun file selezionato";
          console.log("No previous file to restore");
        }
        return;
      }
      const previousFile = this.selectedFile;
      const isSameFile =
        previousFile &&
        previousFile.name === newFile.name &&
        previousFile.lastModified === newFile.lastModified;

      if (isSameFile) {
        this.inputPcEditable = false;
        this.fileTitle = previousFile.name;
        console.log("Same file selected, no changes");
        return;
      }

      if (previousFile) {
        this.resetConversione();
        if (this.$refs.fileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(newFile);
          this.$refs.fileInput.files = dataTransfer.files;
        }
      }

      this.errorMessage = "";

      // Estrazione estensione file
      const filename = newFile.name;
      const estensione = filename.split(".").pop().toLowerCase();

      // Set fileType per distinguere CSV da Excel
      if (estensione === "csv") {
        this.fileType = "csv";
      } else if (["xls", "xlsx", "xlsm"].includes(estensione)) {
        this.fileType = "excel";
      } else {
        this.fileType = "";
      }

      // Se il file è PDF, URL per visualizzazione
      if (newFile.type === "application/pdf") {
        if (this.filePDF_URL) URL.revokeObjectURL(this.filePDF_URL); // Clean up previous URL
        this.filePDF_URL = URL.createObjectURL(newFile);
      } else {
        if (this.filePDF_URL) URL.revokeObjectURL(this.filePDF_URL); // Clean up previous URL
        this.filePDF_URL = null;
      }

      // Gestione primo caricamento o file diverso
      if (!this.selectedFile) {
        this.selectedFile = newFile;
        this.inputPcEditable = true;
        this.fileTitle = this.selectedFile.name;
        this.leggiFileExcelOCsv(newFile, estensione);
        console.log("First file selected:", this.selectedFile.name);
        return;
      }

      // Controlla se è cambiato il file selezionato
      if (
        this.selectedFile.name !== newFile.name ||
        this.selectedFile.lastModified !== newFile.lastModified
      ) {
        this.selectedFile = newFile;
        this.inputPcEditable = true;
        this.resetConversione();
        this.leggiFileExcelOCsv(newFile, estensione);
        console.log("New file selected:", this.selectedFile.name);
      } else {
        this.inputPcEditable = false;
        console.log("Same file selected, no changes");
      }

      this.fileTitle = this.selectedFile.name;
      console.log(
        "After handleFileChange - selectedFile:",
        this.selectedFile?.name,
        "fileTitle:",
        this.fileTitle,
        "input files:",
        this.$refs.fileInput.files[0]?.name
      );
    },

    leggiFileExcelOCsv(file, estensione) {
      if (estensione === "csv") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const testoCsv = e.target.result;
          this.ExcelRows = testoCsv.split("\n").map((line) => line.split(","));
        };
        reader.readAsText(file);
      } else if (estensione === "xls" || estensione === "xlsx") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          this.ExcelRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        };
        reader.readAsArrayBuffer(file);
      } else {
        this.ExcelRows = [];
        this.fileType = "";
      }
    },
    openPDFPreview() {
      this.showPDF = true;
    },
    cleanbackend() {},
    getValidColumns() {
      // Mappa delle colonne da escludere in base a output_PC
      const excludedColumnsMap = {
        TEAMSYSTEM: [0, 3, 4, 5, 6, 7, 9],
        DATEV: [0, 2, 5, 6, 7],
        ZUCCHETTI: [0, 2, 3, 4, 6, 7, 9],
        SEAC: [0, 2, 3, 4, 5, 7, 9],
        SISTEMI: [0, 2, 3, 4, 5, 6, 9],
      };

      // Ottieni gli indici da escludere per il valore attuale di output_PC
      const excludedColumns = excludedColumnsMap[this.output_PC] || [];

      if (this.numeroClienti > 1) {
        const maxColIndex = this.headers.length - 1;
        excludedColumns.push(maxColIndex, maxColIndex - 1); // Ultima e penultima
      }
      // Restituisci solo gli indici che non sono da escludere
      return this.headers
        .map((_, index) => index)
        .filter((index) => !excludedColumns.includes(index));
    },
    isEditableColumn(originalIndex) {
      if (this.isPdcClientTableView) {
        if (
          !this.ha(this.user, "modifica_descrizione_nomi_conto") ||
          !this.isEditModePdcClient
        ) {
          return false;
        }
        if (originalIndex === 1 || originalIndex === 8 || originalIndex === 9) {
          return true;
        }
        switch (this.output_PC) {
          case "TEAMSYSTEM":
            return originalIndex === 2;
          case "DATEV":
            return originalIndex === 3 || originalIndex === 4;
          case "ZUCCHETTI":
            return originalIndex === 5;
          case "SEAC":
            return originalIndex === 6;
          case "SISTEMI":
            return originalIndex === 7;
          default:
            return false;
        }
      }
      // Always editable for SEAC input at index 1
      if (this.input_PC === "SEAC" && originalIndex === 1) {
        return true;
      }
      // Columns 1 and 8 are editable only when edit mode is active
      if (
        this.isEditMode &&
        (originalIndex === 1 || originalIndex === 8 || originalIndex === 9)
      ) {
        return true;
      }
      // Existing logic for other columns
      switch (this.output_PC) {
        case "TEAMSYSTEM":
          return originalIndex === 2;
        case "DATEV":
          return originalIndex === 3 || originalIndex === 4;
        case "ZUCCHETTI":
          return originalIndex === 5;
        case "SEAC":
          return originalIndex === 6;
        case "SISTEMI":
          return originalIndex === 7;
        default:
          return false;
      }
    },
    isEditableColumnPDC(originalIndex) {
      // Columns 1 and 8 are editable only when edit mode is active
      if (
        this.isEditModePDC &&
        (originalIndex === 1 ||
          originalIndex === 2 ||
          originalIndex === 3 ||
          originalIndex === 4 ||
          originalIndex === 5 ||
          originalIndex === 6 ||
          originalIndex === 7 ||
          originalIndex === 8 ||
          originalIndex === 9)
      ) {
        return true;
      }
    },
    toggleEditMode() {
      if (this.tableEditingBlockedByDatevSections && !this.isEditMode) return;
      this.toggleTableEditSession(
        "pp-main",
        "CODICI CONTO INDIVIDUATI",
        this.vettoreCodConto
      );
      this.isEditMode = this.isTableEditing("pp-main");
    },
    toggleEditModePDC() {
      if (this.tableEditingBlockedByDatevSections && !this.isEditModePDC)
        return;
      this.toggleTableEditSession(
        this.currentCodContoPdcTableKey,
        this.currentCodContoPdcTableLabel,
        this.currentCodContoPdcRows
      );
      this.isEditModePDC = this.isTableEditing(this.currentCodContoPdcTableKey);
    },
    toggleCurrentCodContoEditMode() {
      if (this.isPdcClientTableView) {
        if (
          this.tableEditingBlockedByDatevSections &&
          !this.isEditModePdcClient
        ) {
          return;
        }
        this.toggleTableEditSession(
          this.currentCodContoTableKey,
          this.currentCodContoTableLabel,
          this.currentCodContoRows
        );
        this.isEditModePdcClient = this.isTableEditing(
          this.currentCodContoTableKey
        );
        return;
      }
      this.toggleEditMode();
    },
    handleProspettiCellInput(tableKey, rowIndex, colIndex, col, vettore) {
      if (this.tableEditingBlockedByDatevSections) return;
      this.validateInput(rowIndex, colIndex, vettore);
      this.trackTableCellChange(
        tableKey,
        rowIndex,
        col,
        vettore[rowIndex][col],
        vettore,
        String(tableKey || "").startsWith("pp-client-pdc-")
          ? this.currentCodContoPdcTableLabel
          : String(tableKey || "").startsWith("pp-client-")
          ? this.currentCodContoTableLabel
          : tableKey === "pp-pdc"
          ? "CODICI CONTO GIÀ SALVATI"
          : "CODICI CONTO INDIVIDUATI"
      );
    },
    saveProspettiTable(tableKey, vettore) {
      if (tableKey === "pp-main") {
        this.applyMainPdcChangesToClientGroups();
      }
      if (tableKey === "pp-pdc") {
        this.applySavedPdcChangesToClientGroups();
      }
      if (
        String(tableKey || "").startsWith("pp-client-") &&
        !String(tableKey || "").startsWith("pp-client-pdc-")
      ) {
        this.markPdcClientRowsAsCustom(tableKey);
        this.markPdcClientGroupForPersistence(tableKey);
      }
      if (String(tableKey || "").startsWith("pp-client-pdc-")) {
        this.markPdcClientPdcRowsAsCustom(tableKey);
        this.markPdcClientPdcGroupForPersistence(tableKey);
      }
      this.commitTableEditSession(tableKey, vettore);
      if (tableKey === "pp-main") this.isEditMode = false;
      if (
        tableKey === "pp-pdc" ||
        String(tableKey || "").startsWith("pp-client-pdc-")
      ) {
        this.isEditModePDC = false;
      }
      if (
        String(tableKey || "").startsWith("pp-client-") &&
        !String(tableKey || "").startsWith("pp-client-pdc-")
      ) {
        this.isEditModePdcClient = false;
      }
    },
    undoProspettiTable(tableKey, vettore) {
      this.undoLastTableChange(tableKey, ({ rowIndex, colIndex, oldValue }) => {
        this.$set(vettore[rowIndex], colIndex, oldValue);
      });
    },
    resetProspettiTable(tableKey, tableName, targetRows = null) {
      if (!this.hasTableChanges(tableKey)) return;
      const label = this.tableEditSessions[tableKey]?.label || "questa tabella";
      this.pendingTableReset = { tableKey, tableName, targetRows };
      this.resetConfirmContext = "table-reset";
      this.resetConfirmTitle = "Annullare le modifiche?";
      this.resetConfirmEyebrow = "Modifiche tabella";
      this.resetConfirmMessage = `Le modifiche non salvate in ${label} verranno eliminate. Vuoi continuare?`;
      this.resetConfirmConfirmLabel = "Annulla modifiche";
      this.resetConfirmCancelLabel = "Mantieni modifiche";
      this.resetConfirmIconClass = "fa-solid fa-rotate-left";
      this.resetConfirmConfirmIconClass = "fa-solid fa-rotate-left";
      this.showResetConfirmModal = true;
    },
    confirmResetProspettiTable() {
      if (!this.pendingTableReset) return;
      const { tableKey, tableName, targetRows } = this.pendingTableReset;
      if (Array.isArray(targetRows)) {
        const session = this.ensureTableEditSession(tableKey);
        const restored = JSON.parse(JSON.stringify(session.baseline || []));
        targetRows.splice(0, targetRows.length, ...restored);
        this.$set(session, "currentValues", {});
        this.$set(session, "dirtyCells", {});
        this.$set(session, "undoStack", []);
      } else {
        this.resetTableEditSession(tableKey, tableName);
      }
      this.pendingTableReset = null;
    },
    resetCurrentCodContoTable() {
      if (this.isPdcClientTableView) {
        this.resetProspettiTable(
          this.currentCodContoTableKey,
          null,
          this.currentCodContoRows
        );
        return;
      }
      this.resetProspettiTable("pp-main", "vettoreCodConto");
    },
    formatProspettiCellValue(value) {
      return value === "None" ? "" : value;
    },
    getOriginalProspettiDescription(rowIndex, vettore) {
      return vettore?.[rowIndex]?.[0] || "";
    },
    showProspettiDescriptionTooltip(event, rowIndex, vettore) {
      const content = this.getOriginalProspettiDescription(rowIndex, vettore);
      if (!content) return;

      const rect = event.currentTarget.getBoundingClientRect();
      const spacing = 8;
      const estimatedTooltipHeight = 58;
      const placement =
        rect.bottom + spacing + estimatedTooltipHeight > window.innerHeight
          ? "above"
          : "below";

      this.prospettiDescriptionTooltip = {
        visible: true,
        content,
        top: placement === "above" ? rect.top - spacing : rect.bottom + spacing,
        left: Math.min(
          Math.max(rect.left + rect.width / 2, 16),
          window.innerWidth - 16
        ),
        placement,
      };
    },
    hideProspettiDescriptionTooltip() {
      this.prospettiDescriptionTooltip.visible = false;
    },
    isCustomProspettiDescription(rowIndex, colIndex, vettore) {
      if (Number(colIndex) !== 1) return false;
      const original = this.getOriginalProspettiDescription(rowIndex, vettore);
      const current = vettore?.[rowIndex]?.[1];
      const originalText =
        original === null || original === undefined
          ? ""
          : String(original).trim();
      const currentText =
        current === null || current === undefined ? "" : String(current).trim();
      return Boolean(
        originalText && currentText && originalText !== currentText
      );
    },
    isProspettiCellInvalid(rowIndex, colIndex, vettore) {
      const isPDC = vettore === this.vettoreCodContoPDC;
      const headers = isPDC ? this.filteredHeadersPDC : this.filteredHeaders;
      const columns = isPDC ? this.validColumnsPDC : this.validColumns;
      const columnName = headers[colIndex];
      const realColIndex = columns[colIndex];
      const value = vettore?.[rowIndex]?.[realColIndex];
      return !this.isProspettiValueValid(columnName, value);
    },
    isProspettiValueValid(columnName, value) {
      const str =
        value === null || value === undefined ? "" : String(value).trim();
      if (!str || str === "N.A." || str === "NESSUNA CORRELAZIONE") return true;
      if (
        !columnName ||
        columnName.includes("Descrizione") ||
        !columnName.includes("Cod. Conto")
      ) {
        return true;
      }
      if (columnName === "Cod. Conto - TeamSystem") {
        return /^\d{2}\/\d{2}\/\d{3}$/.test(str);
      }
      if (columnName === "Cod. Conto - Sistemi") {
        return /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/.test(str);
      }
      if (columnName === "Cod. Conto - SEAC") {
        return /^\d{6}$/.test(str);
      }
      if (
        columnName === "Cod. Conto - Datev Aziende" ||
        columnName === "Cod. Conto - Datev Lib. Prof."
      ) {
        return /^\d{5,11}$/.test(str);
      }
      return /^\d+$/.test(str);
    },
    // BLOCCA lettere se c'è già un numero
    blockLetters(event, rowIndex, colKey, colIndex, vettore) {
      const headerName = this.filteredHeaders[colIndex]; // o filteredHeaders
      if (!headerName || !/Cod\. Conto/i.test(headerName)) {
        return; // ← NON fare nulla → permetti tutto
      }
      const currentValue = vettore[rowIndex][colKey] || "";
      const hasNumbers = /\d/.test(currentValue);
      // === Gestione speciale per Backspace/Delete su "N.A." ===
      if (
        currentValue === "N.A." &&
        (event.key === "Backspace" || event.key === "Delete")
      ) {
        event.preventDefault(); // Blocca il comportamento di default
        this.$set(vettore[rowIndex], colKey, ""); // Svuota la cella
        return; // Esci subito
      }
      // Se c'è almeno un numero → BLOCCA tutte le lettere
      if (hasNumbers) {
        const key = event.key;

        // Tasti sempre permessi
        const allowed = [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End",
        ];

        // Ctrl+C, Ctrl+V, Ctrl+A, Ctrl+Z
        if (event.ctrlKey || event.metaKey) return;

        // Se non è numero e non è tasto permesso → BLOCCA
        if (!allowed.includes(key) && !/[0-9]/.test(key)) {
          event.preventDefault();
        }
      }
    },

    // Incolla: prendi solo numeri
    blockPaste(event, colIndex) {
      const headerName = this.filteredHeaders[colIndex];
      if (!headerName || !headerName.includes("Cod. conto")) {
        return; // ← incolla tutto
      }

      event.preventDefault();
      const pasted = (event.clipboardData || window.clipboardData).getData(
        "text"
      );
      const numbersOnly = pasted.replace(/\D/g, "");
      const textToInsert = headerName.includes("Datev")
        ? numbersOnly.slice(0, 11)
        : numbersOnly;
      document.execCommand("insertText", false, textToInsert);
    },
    isPDCModified() {
      if (!this.originalPDC) return false;
      if (this.vettoreCodContoPDC.length !== this.originalPDC.length)
        return true;

      for (let i = 0; i < this.vettoreCodContoPDC.length; i++) {
        for (let j = 0; j < this.vettoreCodContoPDC[i].length; j++) {
          if (this.vettoreCodContoPDC[i][j] !== this.originalPDC[i][j]) {
            return true;
          }
        }
      }
      return false;
    },
    validateInput(rowIndex, colIndex, vettore) {
      const columnName = this.filteredHeaders[colIndex];
      if (!columnName) return;

      let value = vettore[rowIndex][this.validColumns[colIndex]];

      if (
        columnName === "Descrizione nel Prospetto Paghe" ||
        columnName === "Descrizione Cod. Conto" ||
        columnName === "Descrizione Cod. Conto 2" ||
        columnName === "Descrizione Cod. Conto - Datev Aziende" ||
        columnName === "Descrizione Cod. Conto - Datev Lib. Prof."
      ) {
        return;
      }
      // --- NUOVA LOGICA ROBUSTA PER "Nessuno" ---
      // Prendi solo le lettere e verifica se compongono "nessuno" (ignorando numeri e simboli)
      const onlyLetters = (value || "").replace(/[^a-zA-Z]/g, "").toLowerCase();
      if (onlyLetters === "na") {
        // Se ci sono cifre nel valore (anche inserite in mezzo), usale come nuovo valore.
        const onlyNumbers = (value || "").replace(/\D/g, "");
        if (onlyNumbers.length > 0) {
          value = onlyNumbers;
        } else {
          // Non ci sono numeri: tieni esattamente "Nessuno"
          vettore[rowIndex][this.validColumns[colIndex]] = "N.A.";
          return;
        }
      }

      // Se dopo aver gestito il caso "Nessuno" il valore contiene ancora lettere,
      // allora è un input letterale non valido -> reset a "Nessuno"
      if (/[a-zA-Z]/.test(value)) {
        vettore[rowIndex][this.validColumns[colIndex]] = "N.A.";
        return;
      }
      if (columnName === "Cod. Conto - TeamSystem") {
        value = value.replace(/[^0-9]/g, "");

        if (value.length > 2 && value[2] !== "/") {
          value = value.slice(0, 2) + "/" + value.slice(2);
        }
        if (value.length > 5 && value[5] !== "/") {
          value = value.slice(0, 5) + "/" + value.slice(5);
        }

        value = value.slice(0, 9);
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else if (columnName === "Cod. Conto - Sistemi") {
        value = value.replace(/[^0-9]/g, "");

        if (value.length > 2 && value[2] !== ".") {
          value = value.slice(0, 2) + "." + value.slice(2);
        }
        if (value.length > 5 && value[5] !== ".") {
          value = value.slice(0, 5) + "." + value.slice(5);
        }
        if (value.length > 8 && value[8] !== ".") {
          value = value.slice(0, 8) + "." + value.slice(8);
        }

        value = value.slice(0, 12);
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else if (columnName === "Cod. Conto - SEAC") {
        value = value.replace(/[^0-9]/g, "");
        value = value.slice(0, 6); // Limita a massimo 6 cifre numeriche
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else if (
        columnName === "Cod. Conto - Datev Aziende" ||
        columnName === "Cod. Conto - Datev Lib. Prof."
      ) {
        value = value.replace(/\D/g, "").slice(0, 11);
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else {
        value = value.replace(/\D/g, "");
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      }
    },
    validateAllInputs() {
      const validColumns = this.getValidColumns();
      let emptyCells = {
        "Codici Conto mancanti": [],
        "Descrizioni nel Prospetto Paghe mancanti": [],
        "Descrizioni Codici Conto mancanti": [],
      };
      let formatErrors = [];
      let reservedCodContoDefaultCells = [];
      let naCells = [];
      let noCorrCells = [];

      // Espressioni regolari (esattamente come le tue)
      const teamSystemRegex = /^\d{2}\/\d{2}\/\d{3}$/;
      const numberRegex = /^\d+$/;
      const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;

      //valida un vettore
      const validateVector = (vector, headers, validCols, prefix = "") => {
        // --- 1. Controllo celle vuote e formato ---
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (let i = 0; i < validCols.length; i++) {
            const colIndex = validCols[i];
            const visibleHeader = headers[i];
            const col = this.headers[colIndex];
            const cellValue = vector[rowIndex][colIndex];

            const cellStr =
              cellValue === null || cellValue === undefined
                ? ""
                : String(cellValue);

            // SALTA N.A. e NESSUNA CORRELAZIONE nel controllo celle vuote
            if (cellStr === "N.A." || cellStr === "NESSUNA CORRELAZIONE") {
              continue;
            }

            if (
              this.isCodContoValueColumn(col) &&
              this.isCodContoDefault(cellStr)
            ) {
              reservedCodContoDefaultCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${visibleHeader || col}`
              );
              continue;
            }

            // Controllo celle vuote
            if (!cellValue || cellValue.toString().trim() === "") {
              if (col === "Descrizione nel Prospetto Paghe") {
                emptyCells["Descrizioni nel Prospetto Paghe mancanti"].push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  } - Descrizione nel Prospetto Paghe`
                );
              } else if (
                col === "Descrizione Cod. Conto" ||
                col === "Descrizione Cod. Conto 2"
              ) {
                emptyCells["Descrizioni Codici Conto mancanti"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
              } else {
                emptyCells["Codici Conto mancanti"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${col}`
                );
              }
              continue; // Salta formato se vuota
            }

            // === Controlli formato (identici ai tuoi) ===
            if (col === "Cod. Conto - TeamSystem" && cellValue) {
              if (!teamSystemRegex.test(cellValue)) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${col}: formato errato (XX/XX/XXX)`
                );
              }
            }

            if (col === "Cod. Conto - Sistemi" && cellValue) {
              if (!sistemiRegex.test(cellValue)) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${col}: formato errato (XX.XX.XX o XX.XX.XX.XXX)`
                );
              }
            }

            if (col === "Cod. Conto - SEAC" && cellValue) {
              const cleanedValue = cellValue.replace(/[^0-9]/g, "");
              if (
                !numberRegex.test(cleanedValue) ||
                cleanedValue.length !== 6
              ) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${col}: deve contenere esattamente 6 cifre`
                );
              }
            }

            if (
              [
                "Cod. Conto - Datev Aziende",
                "Cod. Conto - Datev Lib. Prof.",
              ].includes(col) &&
              cellValue
            ) {
              if (!numberRegex.test(cellValue)) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${col}: deve essere un numero intero`
                );
              } else if (cellValue.length < 5 || cellValue.length > 11) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${col}: deve contenere da 5 a 11 cifre`
                );
              }
            }

            if (
              col === "Cod. Conto - Zucchetti" &&
              cellValue &&
              !numberRegex.test(cellValue)
            ) {
              formatErrors.push(
                `${prefix}Riga ${
                  rowIndex + 1
                }, ${col}: deve essere un numero intero`
              );
            }
          }
        }

        // --- 2. Rileva "N.A." e "NESSUNA CORRELAZIONE" ---
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (let i = 0; i < validCols.length; i++) {
            const colIndex = validCols[i];
            const visibleHeader = headers[i];
            const col = this.headers[colIndex];
            const cellValue = vector[rowIndex][colIndex];
            const cellStr = String(cellValue).trim().toUpperCase();

            if (
              !col.includes("Descrizione") &&
              !col.includes("Descrizione Cod. Conto") &&
              cellStr === "N.A."
            ) {
              naCells.push(`${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`);
            }
            if (
              (col === "Descrizione Cod. Conto" ||
                col === "Descrizione Cod. Conto 2") &&
              cellStr === "NESSUNA CORRELAZIONE"
            ) {
              noCorrCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
              );
            }
          }
        }
      };

      // === 1. Valida vettoreCodConto (come facevi tu) ===
      validateVector(
        this.vettoreCodConto,
        this.filteredHeaders,
        validColumns,
        ""
      );

      // === 2. Valida vettoreCodContoPDC (NUOVO!) ===
      if (this.vettoreCodContoPDC.length > 0) {
        validateVector(
          this.vettoreCodContoPDC,
          this.filteredHeadersPDC,
          this.validColumnsPDC,
          "[SALVATI] "
        );
      }

      // === Reporting errori (identico al tuo) ===
      const detectedErrors = [];
      const codiciContoSection = "CODICI CONTO INDIVIDUATI";

      if (emptyCells["Codici Conto mancanti"].length > 0) {
        detectedErrors.push({
          section: codiciContoSection,
          type: "empty-cells",
          title: "Codici Conto mancanti:",
          messages: emptyCells["Codici Conto mancanti"],
        });
      }
      if (emptyCells["Descrizioni nel Prospetto Paghe mancanti"].length > 0) {
        detectedErrors.push({
          section: codiciContoSection,
          type: "empty-cells",
          title: "Descrizioni nel Prospetto Paghe mancanti:",
          messages: emptyCells["Descrizioni nel Prospetto Paghe mancanti"],
        });
      }
      if (emptyCells["Descrizioni Codici Conto mancanti"].length > 0) {
        detectedErrors.push({
          section: codiciContoSection,
          type: "empty-cells",
          title: "Descrizioni Codici Conto mancanti:",
          messages: emptyCells["Descrizioni Codici Conto mancanti"],
        });
      }

      if (formatErrors.length > 0) {
        detectedErrors.push({
          section: codiciContoSection,
          type: "format-errors",
          title: "Codici Conto non validi:",
          messages: formatErrors,
        });
      }
      if (reservedCodContoDefaultCells.length > 0) {
        detectedErrors.push({
          section: codiciContoSection,
          type: "format-errors",
          title: `Codice conto ${this.codContoDefault} riservato:`,
          messages: reservedCodContoDefaultCells,
        });
      }
      // AVVISI (SOLO SE NESSUN ERRORE BLOCCANTE)
      if (detectedErrors.length === 0) {
        const hasNA = !this.naConfirmed && naCells.length > 0;
        const hasNoCorr = !this.noCorrConfirmed && noCorrCells.length > 0;

        if (hasNA || hasNoCorr) {
          // HELPER UNIFICATI
          const plural = (c, s, p) => (c === 1 ? s : p);
          const foundM = (c) => (c === 1 ? "Trovato" : "Trovati"); // Maschile (per codici o misti)
          const foundF = (c) => (c === 1 ? "Trovata" : "Trovate"); // Femminile (per descrizioni)
          const assignedM = (c) => (c === 1 ? "assegnato" : "assegnati"); // Maschile
          const thisTheseM = (c) => (c === 1 ? "questo" : "questi"); // Maschile
          const thisTheseF = (c) => (c === 1 ? "questa" : "queste"); // Femminile
          const theTheM = (c) => (c === 1 ? "Il" : "I"); // Maschile
          const theTheF = (c) => (c === 1 ? "La" : "Le"); // Femminile
          const willBe = (c) => (c === 1 ? "verrà" : "verranno"); // Neutro
          const valuedM = (c) => (c === 1 ? "valorizzato" : "valorizzati"); // Maschile (per codici)
          const keptF = (c) => (c === 1 ? "mantenuta" : "mantenute"); // Femminile (per descrizioni)

          let title = "",
            messages = [],
            question = "";

          if (hasNA && hasNoCorr) {
            const cod = plural(naCells.length, "Codice Conto", "Codici Conto");
            const nom = plural(
              noCorrCells.length,
              "Descrizione Codice Conto",
              "Descrizioni Codici Conto"
            );
            title = `${foundM(naCells.length + noCorrCells.length)} ${
              naCells.length
            } ${cod} con 'N.A.' e ${
              noCorrCells.length
            } ${nom} con 'NESSUNA CORRELAZIONE':`;
            messages = [...naCells, ...noCorrCells];
            question = `Vuoi proseguire? ${theTheM(
              naCells.length
            )} ${cod} ${willBe(naCells.length)} ${valuedM(
              naCells.length
            )} con 'N.A.' e ${theTheF(
              noCorrCells.length
            ).toLowerCase()} ${nom} ${willBe(noCorrCells.length)} ${keptF(
              noCorrCells.length
            )} come 'NESSUNA CORRELAZIONE'.`;
          } else if (hasNA) {
            const cod = plural(naCells.length, "Codice Conto", "Codici Conto");
            title = `${foundM(naCells.length)} ${
              naCells.length
            } ${cod} con 'N.A.' (non ${assignedM(naCells.length)}):`;
            messages = naCells;
            question = `Vuoi proseguire senza assegnare ${thisTheseM(
              naCells.length
            )} ${cod}?<br>${
              willBe(naCells.length).charAt(0).toUpperCase() +
              willBe(naCells.length).slice(1)
            } ${valuedM(naCells.length)} con 'N.A.'.`;
          } else if (hasNoCorr) {
            const nom = plural(
              noCorrCells.length,
              "Descrizione Codice Conto",
              "Descrizioni Codici Conto"
            );
            title = `${foundF(noCorrCells.length)} ${
              noCorrCells.length
            } ${nom} con 'NESSUNA CORRELAZIONE':`;
            messages = noCorrCells;
            question = `Vuoi proseguire con ${thisTheseF(
              noCorrCells.length
            )} ${nom} senza correlazione?<br>${
              willBe(noCorrCells.length).charAt(0).toUpperCase() +
              willBe(noCorrCells.length).slice(1)
            } ${keptF(noCorrCells.length)} come 'NESSUNA CORRELAZIONE'.`;
          }

          detectedErrors.push({
            section: codiciContoSection,
            type: "combined-warning",
            title,
            messages,
            question,
          });
        }
      }

      if (detectedErrors.length > 0) {
        this.errorsData = detectedErrors;
        this.showErrorModal = true;
        return false;
      }

      return true;
    },
    fillEmptyWithNoCorr() {
      const fill = (vector, validColumns) => {
        vector.forEach((row) => {
          validColumns.forEach((colIndex) => {
            const col = this.headers[colIndex];
            const value = row[colIndex];
            if (
              (col === "Descrizione Cod. Conto" ||
                col === "Descrizione Cod. Conto 2") &&
              (!value || String(value).trim() === "")
            ) {
              this.$set(row, colIndex, "NESSUNA CORRELAZIONE");
            }
          });
        });
      };
      fill(this.vettoreCodConto, this.getValidColumns());
      if (this.vettoreCodContoPDC.length > 0) {
        fill(this.vettoreCodContoPDC, this.validColumnsPDC);
      }
      this.showErrorModal = false;
    },
    //Riempe celle vuote non N.A.
    fillEmptyWithNA() {
      console.log("RIEMPIMENTO N.A. IN CORSO...");

      const fill = (vector, validColumns) => {
        const changedCells = [];
        vector.forEach((row, rowIndex) => {
          // ← Rimosso rowIndex
          validColumns.forEach((colIndex) => {
            const col = this.headers[colIndex];
            const value = row[colIndex];

            if (!value || String(value).trim() === "") {
              if (
                !col.includes("Descrizione Cod. Conto") &&
                !col.includes("Descrizione")
              ) {
                this.$set(row, colIndex, "N.A.");
                changedCells.push({ rowIndex, colIndex });
              }
            }
          });
        });
        return changedCells;
      };

      const changedMainCells = fill(
        this.vettoreCodConto,
        this.getValidColumns()
      );
      changedMainCells.forEach(({ rowIndex, colIndex }) => {
        this.propagateMainPdcCellToClientGroups(rowIndex, colIndex);
      });
      if (this.vettoreCodContoPDC.length > 0) {
        const changedPdcCells = fill(
          this.vettoreCodContoPDC,
          this.validColumnsPDC
        );
        changedPdcCells.forEach(({ rowIndex, colIndex }) => {
          this.propagateSavedPdcCellToClientGroups(rowIndex, colIndex);
        });
      }

      this.showErrorModal = false;
    },
    proceedWithWarnings() {
      this.naConfirmed = true;
      this.noCorrConfirmed = true;
      this.showErrorModal = false;
      this.fase_3();
    },
    getNome(testo) {
      if (!testo) return "";
      const parti = testo.split(" - ");
      return parti[0]?.trim() || "";
    },

    // Estrae la parte dopo " - "
    getData(testo) {
      if (!testo) return "";
      const parti = testo.split(" - ");
      return parti[1]?.trim() || "";
    },
    formattaCFPI(event, cliente) {
      let valore = event.target.value
        .replace(/[^0-9A-Za-z]/g, "")
        .toUpperCase();

      this.$set(cliente, 4, valore);

      // riposizionamento cursore opzionale
      this.$nextTick(() => {
        event.target.value = valore;
        event.target.setSelectionRange(valore.length, valore.length);
      });
    },

    isValidCodiceFiscale(val) {
      if (!val) return true; // vuoto → ok (non obbligatorio)
      return validFiscalCode(val);
    },
    selezionaColonna(tipo) {
      if (tipo === 1 || tipo === 2) {
        // SEAC: Contabilità Ordinaria (1) o Semplificata (2)
        const tuttiSelezionati = this.vettoreClienti_SEAC.every(
          (cliente) => cliente[2] === tipo
        );
        this.vettoreClienti_SEAC = this.vettoreClienti_SEAC.map((cliente) => {
          const newCliente = [...cliente];
          newCliente[2] = tuttiSelezionati ? null : tipo; // null per deselezionare
          return newCliente;
        });
      } else if (tipo === 3 || tipo === 4) {
        // DATEV: Aziende (3) o Liberi Professionisti (4), mappa su 1 e 2
        const valore = tipo === 3 ? 1 : 2; // Mappa tipo 3->1, tipo 4->2
        const tuttiSelezionati = this.vettoreClienti.every(
          (cliente) => cliente[2] === valore
        );
        this.vettoreClienti = this.vettoreClienti.map((cliente) => {
          const newCliente = [...cliente];
          newCliente[2] = tuttiSelezionati ? null : valore; // null per deselezionare
          return newCliente;
        });
      }
    },
    hasNessunaCorrelazione(value) {
      if (typeof value === "string") {
        return value.toLowerCase().includes("nessuna correlazione");
      }
      return false;
    },
    isNessuno(value) {
      return value === "N.A.";
    },
    toggleTablePDCExpansion() {
      this.isTablePDCExpanded = !this.isTablePDCExpanded;
    },
    toggleClientTableExpansion() {
      this.isClientTableExpanded = !this.isClientTableExpanded;
    },
    toggleCodContoTableExpansion() {
      this.isCodContoTableExpanded = !this.isCodContoTableExpanded;
    },
    toggleMergedTableExpansion() {
      this.isMergedTableExpanded = !this.isMergedTableExpanded;
    },
    toggleTableExpansion() {
      this.isTableExpanded = !this.isTableExpanded;
    },
    async handleDownload(event) {
      event.preventDefault();

      if (!this.confermaConversione) {
        this.errorMessage = "Devi confermare il numero di conversioni!";
        return;
      }

      try {
        const response = await axios.post(
          `${API_BASE_URL}/conversion_jobs/${this.jobId}/download`,
          null,
          { responseType: "blob" }
        );
        this.hasDownloaded = true;
        this.fetchConversionCount();

        // Crea link per scaricare il blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", this.fileName);
        document.body.appendChild(link);
        link.click();
        this.hasOutputDownloadStarted = true;
        link.remove();
        window.URL.revokeObjectURL(url);

        // Invia log dopo download
        await axios.post(`${API_BASE_URL}/log_download`, {
          job_id: this.jobId,
          file_name: this.selectedFile
            ? this.selectedFile.name
            : "file_sconosciuto",
          output_file_name: this.filePath,
          output_display_name: this.fileName,
          file_scaricati: this.filesNames ? this.filesNames : [],
          operazione: "Conversione Prospetto Paghe",
        });
        this.removePersistedJobState();
      } catch (error) {
        this.errorMessage =
          error.response?.status === 402
            ? "Coin non sufficienti per scaricare il file."
            : "Errore durante il processo di download.";
        console.error("Errore nel handleDownload:", error);
      }
    },

    // Metodo per ottenere il contatore delle conversioni dal backend
    fetchConversionCount() {
      axios
        .get(`${API_BASE_URL}/get_conversion_count`)
        .then((response) => {
          this.creditiDisponibili = response.data.crediti_disponibili;
        })
        .catch((error) => {
          console.error("Errore nel recupero del contatore:", error);
        });
    },
    fetchPrezziConversione() {
      axios
        .get(`${API_BASE_URL}/getPrezziConversione`)
        .then((response) => {
          this.creditiPerProspettoPaghe =
            response.data.crediti_per_prospetto_paghe;
        })
        .catch((error) => {
          console.error("Errore nel recupero dei prezzi conversione:", error);
        });
    },
    async fetchDatevExtractorSetting() {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/datev_extractor_setting`
        );
        this.datevNewExtractorEnabled = !!response.data.use_datev_new_extractor;
        this.teamsystemNewExtractorEnabled =
          !!response.data.use_teamsystem_new_extractor;
      } catch (error) {
        console.warn("Impossibile leggere lo stato dell'estrattore IA:", error);
        this.datevNewExtractorEnabled = false;
        this.teamsystemNewExtractorEnabled = false;
      }
    },
    async fetchUserCausali() {
      try {
        const response = await axios.get(`${API_BASE_URL}/user_causali`);
        this.causaleProspettiPaghe =
          response.data?.causale_prospetti_paghe || "";
      } catch (error) {
        console.warn("Impossibile leggere la causale Prospetti Paghe:", error);
      }
    },
    normalizeCausale(value) {
      return String(value || "")
        .trim()
        .toUpperCase();
    },
    isValidCausale(value) {
      return /^[A-Z0-9]{1,4}$/.test(this.normalizeCausale(value));
    },
    handleCausaleDraftInput() {
      this.causaleDraft = this.normalizeCausale(this.causaleDraft).slice(0, 4);
      this.causaleError = "";
    },
    needsProspettiCausale() {
      return (
        this.flag_csv_import &&
        this.output_PC === "DATEV" &&
        !this.normalizeCausale(this.causaleProspettiPaghe)
      );
    },
    openProspettiCausaleModal({
      retryAfterSave = false,
      retryFase1AfterSave = false,
      retryFase2AfterSave = false,
    } = {}) {
      this.retryFase1AfterCausale = retryFase1AfterSave;
      this.retryFase2AfterCausale = retryFase2AfterSave;
      this.retryFase3AfterCausale = retryAfterSave;
      this.causaleDraft = this.normalizeCausale(this.causaleProspettiPaghe);
      this.causaleError = "";
      this.showCausaleModal = true;
    },
    closeProspettiCausaleModal() {
      this.showCausaleModal = false;
      this.retryFase1AfterCausale = false;
      this.retryFase2AfterCausale = false;
      this.retryFase3AfterCausale = false;
      this.causaleError = "";
    },
    async saveProspettiCausale() {
      const causale = this.normalizeCausale(this.causaleDraft);
      if (!this.isValidCausale(causale)) {
        this.causaleError =
          "La causale deve contenere da 1 a 4 caratteri alfanumerici.";
        return;
      }
      this.savingCausale = true;
      try {
        const response = await axios.post(`${API_BASE_URL}/user_causali`, {
          causale_prospetti_paghe: causale,
        });
        this.causaleProspettiPaghe =
          response.data?.causale_prospetti_paghe || causale;
        this.showCausaleModal = false;
        const shouldRetryFase1 = this.retryFase1AfterCausale;
        const shouldRetryFase2 = this.retryFase2AfterCausale;
        const shouldRetryFase3 = this.retryFase3AfterCausale;
        this.retryFase1AfterCausale = false;
        this.retryFase2AfterCausale = false;
        this.retryFase3AfterCausale = false;
        if (shouldRetryFase1) {
          this.fase_1();
        } else if (shouldRetryFase2) {
          this.fase_2();
        } else if (shouldRetryFase3) {
          this.fase_3();
        }
      } catch (error) {
        this.causaleError =
          error.response?.data?.error ||
          "Errore durante il salvataggio della causale.";
      } finally {
        this.savingCausale = false;
      }
    },
    startDelayMessageTimer() {
      this.delayTimer = setTimeout(() => {
        this.showDelayedMessage = true;
      }, 10000);
      // Cambia il testo dopo 30 secondi totali
      this.updateTimer = setTimeout(() => {
        this.delayedMessageUpdated = true;
      }, 30000);
    },
    clearDelayMessageTimer() {
      clearTimeout(this.delayTimer);
      clearTimeout(this.updateTimer);
      this.showDelayedMessage = false;
      this.delayedMessageUpdated = false;
    },
  },
  created() {
    this.userEmail = localStorage.getItem("userEmail");
  },
  async mounted() {
    this.fetchConversionCount();
    this.fetchPrezziConversione();
    this.fetchDatevExtractorSetting();
    this.fetchUserCausali();
    this.loadSettings();
    await this.cleanupPurgeableJobs();
    await this.resumeStoredJob();
    document.addEventListener(
      "click",
      this.closePdcFilterDropdownsOnOutsideClick
    );
    window.addEventListener("focus", this.fetchDatevExtractorSetting);
    window.addEventListener("beforeunload", this.handleWindowBeforeUnload);
    window.addEventListener("pagehide", this.handleWindowPageHide);
  },
  beforeDestroy() {
    document.removeEventListener(
      "click",
      this.closePdcFilterDropdownsOnOutsideClick
    );
    window.removeEventListener("focus", this.fetchDatevExtractorSetting);
    window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
    window.removeEventListener("pagehide", this.handleWindowPageHide);
    this.stopJobPolling();
  },
  beforeRouteLeave(to, from, next) {
    if (this.shouldConfirmReset()) {
      this.openConversionInterruptModal("leave", next);
      return;
    }

    const finalize = async () => {
      if (!this.jobId) return;
      if (this.isPollableJobStatus(this.jobStatus)) {
        await this.cancelActiveJob(false);
        return;
      }
      await this.cleanupSpecificJob(this.jobId);
      await this.cleanupPurgeableJobs();
      this.clearJobState();
    };

    finalize().finally(() => next());
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  min-height: 10rem;
  background: white;
  border-radius: 12px;
  width: calc(100vw - 2rem);
  max-width: 66rem;
  min-width: 0;
  padding: 1rem;
  box-sizing: border-box;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  position: relative;
  animation: modalFadeIn 0.3s ease;
  max-height: calc(100vh - 2rem);
  overflow: auto;
}

.modal-content :deep(.store-card),
.modal-content :deep(.skeleton-loader) {
  margin: 0 auto;
}

.causale-modal-content {
  position: relative;
  width: min(28rem, calc(100vw - 2rem));
  background: #fff;
  border-radius: 8px;
  padding: 1.6rem 1.4rem 1.4rem;
  box-shadow: 0 18px 45px rgba(15, 42, 62, 0.22);
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.causale-modal-close {
  position: absolute;
  top: 0.65rem;
  right: 0.65rem;
  width: 2rem;
  height: 2rem;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #607178;
  font-size: 1.05rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.causale-modal-close:hover {
  background: #f1f4f6;
  color: #102a3e;
}

.causale-modal-content h3 {
  margin: 0;
  color: #102a3e;
  font-size: 1.35rem;
}

.causale-modal-content p {
  margin: 0;
  color: #4d5f6d;
  font-size: 0.98rem;
  line-height: 1.45;
}

.causale-input {
  height: 2.5rem;
  border: 1px solid #bfcbd5;
  border-radius: 6px;
  padding: 0 0.7rem;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.causale-error {
  color: #b42318;
  font-size: 0.9rem;
  font-weight: 700;
}

.causale-save-button {
  align-self: flex-end;
  border: 0;
  border-radius: 6px;
  background: #2367ad;
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
  padding: 0.65rem 1.1rem;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  cursor: pointer;
}

.causale-save-button:disabled {
  opacity: 0.65;
  cursor: wait;
}

.modal-close {
  position: absolute;
  top: 0.5rem;
  right: 0.7rem;
  background: none;
  border: none;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  color: #666;
}

.modal-close:hover {
  color: #000;
}
@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.italic-text {
  font-style: italic;
  font-size: 0.75rem !important;
  color: rgb(156, 156, 156);
}
.titleConvProspetti {
  color: #4c6058;
}
.contenitore-prospetti {
  position: relative;
}
.datev-result-loading {
  position: absolute;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-radius: 5px;
  background: rgba(248, 249, 250, 0.68);
  backdrop-filter: blur(2px);
}
.datev-result-loading--panel {
  z-index: 300;
}
.datev-result-loading-panel {
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  width: min(28rem, 100%);
  padding: 1.05rem 1.2rem;
  color: #252a31;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  box-shadow: 0 18px 45px rgba(20, 26, 34, 0.16);
}
.datev-result-loading-spinner {
  flex: 0 0 auto;
  width: 2.35rem;
  height: 2.35rem;
  border: 3px solid #dfe6ee;
  border-top-color: #4f7769;
  border-radius: 50%;
  animation: datev-result-spin 0.8s linear infinite;
}
.datev-result-loading-title,
.datev-result-loading-message {
  margin: 0;
}
.datev-result-loading-title {
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.25;
}
.datev-result-loading-message {
  margin-top: 0.25rem;
  color: #636c78;
  font-size: 0.9rem;
  line-height: 1.35;
}
@keyframes datev-result-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fase2-results-body {
  display: block;
  padding-top: 0;
}
.result-container {
  height: 30.5rem;
}
.result-container--quality {
  overflow: hidden;
}
.result-container--quality .fase2 {
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
}
.result-container--quality .fase2-topbar {
  flex: 0 0 auto;
}
.result-container--quality .response-message {
  display: flex;
  flex: 1 1 0;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
}
.result-container--datev-config-open {
  height: clamp(34rem, 68dvh, 46rem);
}
.result-container--datev-config-open .fase2 {
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
}
.result-container--datev-config-open .fase2-topbar {
  flex: 0 0 auto;
  margin-bottom: 0.65rem;
}
.result-container--datev-config-open .response-message {
  display: flex;
  flex: 1 1 0;
  min-height: 0;
  flex-direction: column;
}
.fase2-results-body.dashboard-table-expanded {
  position: absolute;
  inset: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: #fff;
  border-radius: 5px;
}
.codconto-table-dashboard {
  position: relative;
  z-index: 1001;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.9rem;
  min-height: 42px;
  margin: 0 auto;
  padding: 0.4rem 0.6rem;
  width: calc(100% - 1rem);
  border: 1px solid #dce5eb;
  border-radius: 10px 10px 0 0;
  background: #ffffff;
  box-shadow: none;
}
.codconto-dashboard-tools,
.codconto-dashboard-filters {
  display: inline-flex;
  align-items: center;
  gap: 0.42rem;
  min-width: 0;
}
.codconto-dashboard-tools {
  order: 2;
  flex: 0 0 auto;
  justify-content: flex-end;
  margin-left: auto;
}
.codconto-dashboard-filters {
  order: 1;
  flex: 1 1 auto;
  justify-content: flex-start;
  margin-right: auto;
}
.codconto-dashboard-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  height: 29px;
  gap: 0.35rem;
  padding: 0 0.68rem;
  border: 1px solid rgba(72, 84, 116, 0.2);
  border-radius: 7px;
  background: #ffffff;
  color: #26364d;
  font-size: 0.78rem;
  font-weight: 650;
  cursor: pointer;
  box-shadow: none;
}
.codconto-dashboard-button:hover:not(:disabled),
.codconto-dashboard-button.active {
  border-color: rgba(35, 100, 170, 0.32);
  background: #eef4fb;
  color: #174f86;
}
.codconto-dashboard-button:disabled {
  cursor: not-allowed;
  color: #9aa6b4;
  background: #f4f6f8;
  box-shadow: none;
}
.codconto-dashboard-icon-button {
  width: 31px;
  padding: 0;
}

.codconto-dashboard-tools > .codconto-dashboard-icon-button:first-child {
  order: 99;
}

.codconto-dashboard-tools
  > .codconto-dashboard-button:not(.codconto-dashboard-icon-button):not(
    .codconto-dashboard-save
  ):not(.codconto-dashboard-reset) {
  flex: 0 0 8.6rem;
  width: 8.6rem;
}
.codconto-dashboard-save:not(:disabled) {
  border-color: rgba(35, 100, 170, 0.34);
  background: #2367ad;
  color: #ffffff;
}
.codconto-dashboard-save:hover:not(:disabled),
.codconto-dashboard-save.active:not(:disabled) {
  border-color: rgba(35, 100, 170, 0.44);
  background: #1f5b9c;
  color: #ffffff;
}
.codconto-dashboard-reset:not(:disabled) {
  background: #ffffff;
  color: #5f6368;
}
.codconto-table-dashboard .pdc-code-view-controls,
.codconto-table-dashboard .pdc-client-view-controls {
  position: relative;
  top: auto;
  right: auto;
  z-index: 20;
}
.codconto-table-dashboard .pdc-client-view-controls {
  width: 160px;
}
.codconto-table-dashboard .btnPDCvisible {
  position: relative;
  top: auto;
  right: auto;
  width: 144px;
  height: 29px;
}
.fase2-results-body .cod_conto_table_div,
.fase2-results-body .cod_conto_table_divPDC {
  max-height: clamp(19.15rem, 45dvh, 32rem);
}
.fase2-results-body.pdc-client-table-mode .cod_conto_table_div,
.fase2-results-body.pdc-client-table-mode .cod_conto_table_divPDC {
  max-height: clamp(18.35rem, 43dvh, 31rem);
}
.pdc-client-context-note {
  display: flex;
  align-items: center;
  gap: 0.46rem;
  box-sizing: border-box;
  width: calc(100% - 1rem);
  margin: 0 auto;
  padding: 0.34rem 0.68rem;
  border: 1px solid rgba(43, 99, 157, 0.18);
  border-top: 0;
  border-radius: 0;
  background: #f4f8fc;
  color: #26364d;
  font-size: 0.76rem;
  line-height: 1.2;
}
.pdc-client-context-note > i {
  margin-top: 0;
  color: #2367ad;
  font-size: 0.78rem;
}
.pdc-client-context-note strong {
  display: inline;
  margin-right: 0.45rem;
  color: #17324a;
  font-size: 0.77rem;
  font-weight: 900;
}
.pdc-client-context-note span {
  display: inline;
  color: #526170;
  font-weight: 650;
}
.pdc-client-context-note b {
  color: #17324a;
  font-weight: 900;
}
.response-message > .phase-action-row {
  bottom: 16px;
}
.codconto-table-dashboard .pdc-code-view-menu {
  top: calc(100% + 6px);
  right: 0;
}
.dashboard-table-expanded .codconto-table-dashboard {
  position: sticky;
  top: 0;
  width: 100%;
  margin: 0;
}

.dashboard-table-expanded .pdc-client-context-note {
  width: 100%;
}
.dashboard-table-expanded .divPDCtable,
.dashboard-table-expanded .div-codici-conto {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  max-height: none;
  overflow: hidden;
}

.dashboard-table-expanded .divPDCtable.table-hidden {
  display: none;
}

.dashboard-table-expanded .cod_conto_table_div,
.dashboard-table-expanded .cod_conto_table_divPDC {
  position: relative;
  top: auto;
  left: auto;
  width: 100%;
  height: auto;
  max-height: none;
  min-height: 0;
  overflow: auto;
  z-index: 1;
  flex: 1 1 auto;
}
.fase2-results-body.dashboard-table-expanded.pdc-client-table-mode
  .cod_conto_table_div,
.fase2-results-body.dashboard-table-expanded.pdc-client-table-mode
  .cod_conto_table_divPDC {
  max-height: none;
  height: auto;
}
.fase2-results-body.dashboard-table-expanded > .phase-action-row {
  display: none;
}
.legacy-pdc-floating-control,
.fase2-results-body .expand-button,
.fase2-results-body .divPDCtable > .edit-buttonPDC,
.fase2-results-body .divPDCtable > .edit-session-actions,
.fase2-results-body .div-codici-conto > .edit-button,
.fase2-results-body .div-codici-conto > .edit-session-actions {
  display: none !important;
}
.cod-conto-individuati.extraction-settings-title {
  color: #41506a;
}
.fase2-topbar {
  position: relative;
  display: grid;
  grid-template-columns: 12rem minmax(0, 1fr) 13.4rem;
  align-items: center;
  gap: 0.75rem;
  width: calc(100% - 2rem);
  margin: 0 auto 1.1rem;
  min-height: 38px;
}
.fase2-topbar .numerofaseAttuale {
  position: static;
  margin: 0;
  justify-self: start;
}
.fase2-topbar .title-conv {
  margin: 0;
  justify-self: center;
}
.datev-config-toggle {
  position: relative;
  justify-self: end;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.32rem;
  height: 30px;
  padding: 0 0.45rem;
  border: 1px solid rgba(72, 84, 116, 0.12);
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.48);
  color: #526170;
  font-size: 0.66rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  box-shadow: none;
}
.datev-config-toggle i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 0.8rem;
  height: 0.8rem;
  font-size: 0.68rem;
  line-height: 1;
  transform: translateY(0.5px);
}
.datev-config-toggle span:not(.datev-config-pending-badge) {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  height: 1em;
  overflow: visible;
  text-overflow: clip;
  line-height: 1;
  white-space: nowrap;
}
.datev-config-toggle:hover {
  border-color: rgba(72, 84, 116, 0.22);
  background: #f4f5f8;
  color: #26364d;
}
.datev-config-toggle.active {
  border-color: rgba(35, 100, 170, 0.42);
  background: #edf4fb;
  color: #174f86;
  box-shadow: 0 0 0 3px rgba(35, 100, 170, 0.08);
}
.datev-config-toggle.active:hover {
  border-color: rgba(35, 100, 170, 0.55);
  background: #e5eff9;
}
.datev-config-toggle.dirty {
  border-color: rgba(35, 100, 170, 0.6);
  background: #e4eefb;
  color: #174f86;
}
.datev-config-toggle.dirty.active,
.datev-config-toggle.dirty:hover {
  background: #e4eefb;
}
.quality-datev-settings-callout {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0;
  padding: 0.62rem 1rem;
  background: #f3f7fc;
  border-bottom: 1px solid #d7e3f1;
}
.quality-datev-settings-copy {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  color: #344c63;
}
.quality-datev-settings-copy > i {
  margin-top: 0.16rem;
  color: #2d6595;
}
.quality-datev-settings-copy p {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.38;
}
.fase2 > .response-message > .fase2-results-body,
.fase2 > .response-message > .phase2-codes-action-row {
  animation: phase2-view-enter 0.18s ease both;
}
@keyframes phase2-view-enter {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 760px) {
  .quality-datev-settings-callout {
    padding: 0.58rem 0.75rem;
  }
}
.pdc-client-view-controls {
  display: block;
  position: absolute;
  top: 48px;
  right: 25px;
  width: 160px;
  z-index: 8;
  color: #173142;
}
.btnPDCvisible {
  top: 48px;
  right: 190px;
  z-index: 8;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 144px;
  min-width: 118px;
  height: 30px;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid rgba(72, 84, 116, 0.24);
  border-radius: 8px;
  background: #ffffff;
  color: #26364d;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1;
  box-shadow: 0 2px 8px rgba(8, 40, 64, 0.08);
}
.btnPDCvisible:hover {
  border-color: rgba(72, 84, 116, 0.42);
  background: #f4f5f8;
}
.btnPDCvisible.active,
.btnPDCvisible.active:hover {
  border-color: rgba(35, 100, 170, 0.32);
  background: #eef4fb;
  color: #174f86;
  box-shadow: 0 2px 8px rgba(8, 40, 64, 0.08);
}
.btnPDCvisible .iconbtnPDC,
.btnPDCvisible .toggle-icon {
  margin: 0;
  font-size: 0.8rem;
}
.btnPDCvisible .toggle-icon {
  margin-left: auto;
}
.pdc-code-view-menu {
  position: absolute;
  top: 84px;
  right: 190px;
  z-index: 12;
  width: 168px;
  max-height: 180px;
  overflow: auto;
  padding: 6px;
  border: 1px solid rgba(72, 84, 116, 0.18);
  border-radius: 9px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(8, 40, 64, 0.18);
}
.pdc-code-view-menu button {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 32px;
  gap: 8px;
  padding: 7px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #082840;
  font-size: 0.84rem;
  font-weight: 750;
  text-align: left;
  cursor: pointer;
}
.pdc-code-view-menu button:hover,
.pdc-code-view-menu button.active {
  background: #eef4fb;
  color: #174f86;
}
.pdc-code-view-menu i {
  width: 1rem;
  text-align: center;
}
.pdc-client-view-trigger {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 7px;
  width: 100%;
  min-width: 0;
  height: 30px;
  padding: 0 10px;
  border: 1px solid rgba(72, 84, 116, 0.24);
  border-radius: 8px;
  background: #ffffff;
  color: #26364d;
  font-size: 0.7rem;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(8, 40, 64, 0.08);
}
.pdc-client-view-trigger span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pdc-client-view-trigger i {
  flex: 0 0 auto;
}
.pdc-client-view-trigger i:last-child {
  margin-left: auto;
}
.pdc-client-view-trigger:hover:not(:disabled) {
  border-color: rgba(72, 84, 116, 0.42);
  background: #f4f5f8;
}
.pdc-client-view-trigger:disabled {
  cursor: not-allowed;
  color: #8a98a8;
  background: #f7f8fa;
  box-shadow: none;
}
.pdc-client-view-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  width: 220px;
  max-height: 250px;
  overflow: auto;
  padding: 6px;
  border: 1px solid rgba(72, 84, 116, 0.18);
  border-radius: 9px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(8, 40, 64, 0.18);
}
.pdc-client-view-menu button {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 34px;
  padding: 7px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #082840;
  font-size: 0.86rem;
  font-weight: 750;
  text-align: left;
  cursor: pointer;
}
.pdc-client-view-menu button:hover,
.pdc-client-view-menu button.active {
  background: #eef4fb;
  color: #174f86;
}
.pdc-client-view-menu-title {
  padding: 7px 10px 3px;
  color: #607178;
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
}
.result-container--datev-pending .datev-config-toggle,
.result-container--datev-pending .datev-config-toggle *,
.result-container--datev-pending .datev-config-panel,
.result-container--datev-pending .datev-config-panel * {
  pointer-events: auto;
}
.result-container--datev-pending .datev-config-toggle,
.result-container--datev-pending .datev-sections-apply,
.result-container--datev-pending .datev-sections-reset {
  opacity: 1;
}
.datev-config-pending-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border: 2px solid #ffffff;
  border-radius: 999px;
  background: #d92d20;
  color: #ffffff;
  font-size: 0.62rem;
  font-weight: 900;
  line-height: 1;
  pointer-events: none;
}
.datev-config-panel {
  position: relative;
  display: grid;
  flex: 1 1 0;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr) auto;
  width: min(1180px, 100%);
  height: auto;
  min-height: 0;
  max-height: none;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid rgba(38, 70, 83, 0.18);
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(26, 50, 67, 0.07);
}
.datev-config-tabs {
  position: relative;
  z-index: 140;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  min-width: 0;
  min-height: 3.45rem;
  padding: 0;
  border-bottom: 1px solid #dfe6ed;
  background: #f5f7f9;
}
.datev-config-tab {
  position: relative;
  display: flex;
  width: 100%;
  min-width: 0;
  min-height: 3.45rem;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 0.55rem 1rem;
  overflow: hidden;
  border: 0;
  border-right: 1px solid #dfe6ed;
  background: transparent;
  color: #40536d;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 750;
  text-align: center;
  cursor: pointer;
  transition: color 0.16s ease, background 0.16s ease;
}
.datev-client-tab-control:last-child .datev-config-tab {
  border-right: 0;
}
.datev-config-tab::after {
  position: absolute;
  right: 1rem;
  bottom: 0;
  left: 1rem;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: transparent;
  content: "";
}
.datev-config-tab:hover:not(:disabled) {
  background: #ffffff;
  color: #173c5a;
}
.datev-config-tab.active {
  background: #ffffff;
  color: #087a55;
}
.datev-config-tab.active::after {
  background: #0a9167;
}
.datev-config-tab:focus-visible {
  z-index: 1;
  outline: 3px solid rgba(10, 145, 103, 0.18);
  outline-offset: -3px;
}
.datev-config-tab:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
.datev-config-tab > i {
  flex: 0 0 auto;
  font-size: 0.9rem;
}
.datev-config-tab > span:not(.datev-client-tab-label) {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.datev-client-tab-control {
  position: relative;
  min-width: 0;
}
.datev-client-tab-label {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.1rem;
  overflow: hidden;
  text-align: left;
}
.datev-client-tab-label strong,
.datev-client-tab-label small {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.datev-client-tab-label strong {
  font: inherit;
}
.datev-client-tab-label small {
  color: #718298;
  font-size: 0.67rem;
  font-weight: 600;
}
.datev-client-menu {
  position: absolute;
  top: calc(100% + 0.45rem);
  right: 0.5rem;
  z-index: 220;
  width: clamp(20rem, 32vw, 29rem);
  max-width: calc(100vw - 3rem);
  overflow: hidden;
  border: 1px solid #d9e3ec;
  border-radius: 0.7rem;
  background: #ffffff;
  box-shadow: 0 18px 42px rgba(25, 47, 64, 0.18);
}
.datev-client-menu-search {
  display: flex;
  min-height: 2.55rem;
  align-items: center;
  gap: 0.6rem;
  margin: 0.65rem;
  padding: 0 0.75rem;
  border: 1px solid #d8e2eb;
  border-radius: 0.5rem;
  color: #6d8095;
  background: #fbfcfd;
}
.datev-client-menu-search input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #263e5a;
  font: inherit;
  font-size: 0.78rem;
}
.datev-client-menu-list {
  max-height: min(22rem, calc(100dvh - 18rem));
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0.35rem;
}
.datev-client-menu-list > button {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  width: 100%;
  min-width: 0;
  gap: 0.75rem;
  align-items: center;
  padding: 0.65rem 0.7rem;
  border: 0;
  border-radius: 0.5rem;
  background: transparent;
  color: #263e5a;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}
.datev-client-menu-list > button:hover,
.datev-client-menu-list > button.active {
  background: #edf7f2;
}
.datev-client-menu-list > button.active {
  box-shadow: inset 3px 0 0 #0a9167;
}
.datev-client-menu-copy {
  min-width: 0;
}
.datev-client-menu-copy strong,
.datev-client-menu-copy > small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.datev-client-menu-copy strong {
  font-size: 0.78rem;
  font-weight: 750;
}
.datev-client-menu-copy > small {
  margin-top: 0.2rem;
  color: #718298;
  font-size: 0.67rem;
}
.datev-client-menu-status {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 0.25rem;
}
.datev-client-menu-empty {
  margin: 0;
  padding: 1.25rem;
  color: #74869a;
  font-size: 0.78rem;
  text-align: center;
}
.datev-client-menu-status small,
.datev-client-menu-list .datev-client-custom-count,
.datev-client-menu-list .datev-client-problem-count {
  padding: 2px 6px;
  border-radius: 999px;
  font-size: 0.62rem;
  line-height: 1.2;
}
.datev-config-content {
  min-width: 0;
  height: 100%;
  overflow: auto;
  padding: 16px 18px 18px;
  box-sizing: border-box;
  background: #ffffff;
}
.datev-client-problem-count {
  padding: 2px 7px;
  border-radius: 999px;
  background: #fff0df;
  color: #96500e;
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
}
.datev-client-custom-count {
  padding: 2px 7px;
  border-radius: 999px;
  background: #fff1dc;
  color: #b45309;
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
}
.datev-config-header {
  position: sticky;
  top: -16px;
  z-index: 80;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin: -16px -18px 10px;
  min-height: 92px;
  padding: 18px 18px 28px;
  border-bottom: 1px solid rgba(38, 70, 83, 0.12);
  background: rgba(255, 255, 255, 0.96);
  box-sizing: border-box;
}
.datev-config-header h4 {
  margin: 0 0 3px;
  color: #142f35;
  font-size: 1.02rem;
  font-weight: 800;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.datev-config-title {
  min-width: 0;
  padding-top: 1px;
  text-align: left;
}
.datev-config-title > span,
.datev-client-heading span {
  display: block;
  width: 100%;
  color: #607178;
  font-size: 0.84rem;
  line-height: 1.35;
  text-align: left;
}
.datev-client-heading span {
  margin-top: 2px;
}
.datev-config-subtitle {
  display: flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  color: #607178;
  font-size: 0.84rem;
  line-height: 1.35;
  text-align: left;
}
.datev-config-subtitle-text {
  min-width: 0;
}
.datev-config-info {
  display: inline-flex;
  flex: 0 0 auto;
  position: relative;
  z-index: 120;
  width: auto;
  color: #1f79a8;
  font-size: 0.82rem;
  line-height: 1;
}
.datev-config-info-tooltip {
  left: 50%;
  right: auto;
  top: calc(100% + 10px);
  bottom: auto;
  z-index: 2147483000 !important;
  width: 18rem;
  transform: translateX(-50%);
  white-space: normal !important;
}
.datev-client-customization-note {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 7px;
  color: #b45309;
  font-size: 0.76rem;
  font-weight: 800;
  line-height: 1.25;
}
.datev-client-customization-note span {
  width: auto;
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}
.datev-client-customization-note button {
  padding: 4px 9px;
  border: 1px solid rgba(35, 100, 170, 0.28);
  border-radius: 999px;
  background: #eef5fc;
  color: #174f86;
  font-size: 0.72rem;
  font-weight: 800;
  cursor: pointer;
}
.datev-client-customization-note button:hover {
  border-color: rgba(35, 100, 170, 0.42);
  background: #e6f0fb;
}
.datev-client-heading strong {
  color: #142f35;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.25;
}
.datev-sections-apply {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 34px;
  padding: 0 13px;
  border: 1px solid #356fae;
  border-radius: 6px;
  background: #356fae;
  color: #fff;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.16s ease, border-color 0.16s ease;
}
.datev-sections-apply:hover:not(:disabled) {
  border-color: #2c6098;
  background: #2c6098;
  color: #ffffff;
}
.datev-sections-reset {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 34px;
  padding: 0 13px;
  border: 1px solid #d3dce5;
  border-radius: 6px;
  background: #fafbfc;
  color: #596b7e;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.16s ease, border-color 0.16s ease,
    color 0.16s ease;
}
.datev-sections-reset:hover:not(:disabled) {
  border-color: #bbc8d5;
  background: #f3f6f9;
  color: #34495e;
}
.datev-sections-reset:disabled {
  cursor: not-allowed;
  color: #8a98a8;
  background: #f7f8fa;
  opacity: 1;
}
.datev-sections-apply,
.datev-sections-apply span,
.datev-sections-apply i {
  color: #ffffff;
}
.datev-sections-apply:disabled {
  cursor: not-allowed;
  border-color: #d8e2eb;
  background: #e9eff5;
  color: #8797a8;
  opacity: 1;
}
.datev-sections-apply:disabled span,
.datev-sections-apply:disabled i {
  color: #8797a8;
}
.datev-config-footer {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 52px;
  padding: 8px 16px;
  border-top: 1px solid rgba(38, 70, 83, 0.12);
  background: #ffffff;
  box-sizing: border-box;
}
.datev-config-footer .datev-sections-apply {
  min-height: 34px;
  padding: 0 15px;
  font-size: 0.8rem;
}
.datev-config-footer .datev-sections-apply span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.datev-config-actions {
  position: absolute;
  right: 18px;
  bottom: 14px;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.datev-summary-introduction {
  display: grid;
  grid-template-columns: 3.2rem minmax(0, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 1rem 1.1rem;
  border: 1px solid #cfe4da;
  border-radius: 0.7rem;
  background: linear-gradient(135deg, #f3faf7 0%, #fbfdfc 100%);
  color: #29445a;
  text-align: left;
}
.datev-summary-introduction-icon {
  display: inline-flex;
  width: 3.2rem;
  height: 3.2rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  background: #dff3e9;
  color: #087a55;
  font-size: 1.25rem;
}
.datev-summary-introduction-copy,
.datev-summary-overview-heading > div {
  min-width: 0;
}
.datev-summary-eyebrow {
  display: block;
  margin-bottom: 0.22rem;
  color: #087a55;
  font-size: 0.64rem;
  font-weight: 800;
  letter-spacing: 0.055em;
  text-transform: uppercase;
}
.datev-summary-introduction h5,
.datev-summary-overview h5 {
  margin: 0;
  color: #17324a;
  font-size: 0.92rem;
  font-weight: 800;
  line-height: 1.3;
}
.datev-summary-introduction p {
  max-width: 65rem;
  margin: 0.45rem 0 0;
  color: #566d80;
  font-size: 0.76rem;
  line-height: 1.55;
}
.datev-summary-guidance {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.55rem;
  margin-top: 0.8rem;
}
.datev-summary-guidance span {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.48rem;
  padding: 0.5rem 0.6rem;
  border: 1px solid #dce9e3;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.8);
  color: #3f596d;
  font-size: 0.68rem;
  font-weight: 650;
  line-height: 1.3;
}
.datev-summary-guidance i {
  flex: 0 0 auto;
  color: #0a8a62;
}
.datev-summary-introduction .datev-summary-reprocess-note {
  margin-top: 0.7rem;
  padding-top: 0.65rem;
  border-top: 1px solid #dce9e3;
  color: #536879;
  font-size: 0.7rem;
}
.datev-summary-introduction .datev-summary-reprocess-note strong {
  color: #173f5f;
}
.datev-summary-overview {
  margin-bottom: 1rem;
  padding: 0.9rem 1rem 0;
  border: 1px solid #dfe7ee;
  border-radius: 0.7rem;
  background: #ffffff;
  text-align: left;
}
.datev-summary-overview-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.75rem;
}
.datev-summary-overview-heading > small {
  flex: 0 0 auto;
  padding: 0.25rem 0.55rem;
  border-radius: 999px;
  background: #f1f4f7;
  color: #718197;
  font-size: 0.64rem;
  font-weight: 700;
}
.datev-summary-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.65rem;
}
.datev-summary-metrics article {
  display: grid;
  grid-template-columns: 1.8rem minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-items: center;
  column-gap: 0.55rem;
  min-width: 0;
  padding: 0.65rem 0.7rem;
  border: 1px solid #dce6ed;
  border-radius: 0.55rem;
  background: #f8fafb;
}
.datev-summary-metrics article > i {
  grid-row: 1 / 3;
  display: inline-flex;
  width: 1.8rem;
  height: 1.8rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.45rem;
  background: #e3f3eb;
  color: #087a55;
  font-size: 0.78rem;
}
.datev-summary-metrics article > span {
  min-width: 0;
  overflow: hidden;
  color: #6a7c91;
  font-size: 0.64rem;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.datev-summary-metrics article > strong {
  color: #18344e;
  font-size: 0.9rem;
  font-weight: 800;
}
.datev-summary-metrics article.warning {
  border-color: #efd8b8;
  background: #fff9f0;
}
.datev-summary-metrics article.warning > i {
  background: #ffecd2;
  color: #ad5c12;
}
.datev-summary-detail-heading {
  display: flex;
  align-items: baseline;
  gap: 0.65rem;
  margin: 0.85rem -1rem 0;
  padding: 0.7rem 1rem;
  border-top: 1px solid #e3e9ef;
  background: #f6f8fa;
}
.datev-summary-detail-heading strong {
  color: #273f5a;
  font-size: 0.76rem;
}
.datev-summary-detail-heading span {
  color: #75869a;
  font-size: 0.66rem;
}
.datev-summary-overview + .datev-config-alert {
  margin-top: 0;
}
.datev-config-alert {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: -4px 0 14px;
  padding: 9px 11px;
  color: #6f420e;
  background: #fff7ec;
  border: 1px solid #f1d2aa;
  border-radius: 7px;
  font-size: 0.84rem;
  font-weight: 700;
  line-height: 1.35;
  text-align: left;
}
.datev-config-alert i {
  margin-top: 2px;
  color: #b45f12;
}
.datev-preference-save-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 220px;
  max-width: 250px;
  margin-top: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #27364d;
  font-size: 0.73rem;
  font-weight: 800;
  line-height: 1.25;
}
.datev-preference-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  justify-content: center;
  white-space: nowrap;
  cursor: pointer;
}
.datev-preference-toggle-disabled {
  cursor: not-allowed;
  opacity: 0.72;
}
.datev-preference-toggle-disabled input,
.datev-preference-toggle-disabled span {
  cursor: not-allowed;
}
.datev-preference-toggle input {
  width: 16px;
  height: 16px;
  margin: 0;
  flex: 0 0 auto;
  accent-color: #d97706;
}
.datev-client-group + .datev-client-group {
  margin-top: 18px;
  padding-top: 2px;
}
.datev-client-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  margin-bottom: 10px;
  color: #1f2933;
}
.datev-client-heading strong {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.datev-sections-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 9px;
}
.datev-section-row {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  grid-template-rows: auto auto;
  column-gap: 12px;
  align-items: center;
  min-height: 50px;
  padding: 10px 12px;
  border: 1px solid rgba(35, 100, 170, 0.16);
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease,
    box-shadow 0.15s ease;
}
.datev-section-row:hover {
  border-color: rgba(35, 100, 170, 0.32);
  box-shadow: 0 1px 5px rgba(22, 52, 44, 0.06);
}
.datev-section-row.readonly,
.datev-section-row.readonly:hover {
  cursor: default;
  border-color: rgba(35, 100, 170, 0.13);
  box-shadow: none;
}
.datev-section-row.readonly input:disabled {
  cursor: default;
  opacity: 1;
}
.datev-section-row input {
  align-self: center;
  margin: 0;
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
}
.datev-section-row.excluded {
  background: #f7f8fa;
}
.datev-section-row.problem {
  border-color: rgba(185, 92, 16, 0.42);
  background: #fff8ef;
}
.datev-section-row.problem.excluded {
  background: #fff3e7;
}
.datev-section-row.problem.accepted {
  border-color: rgba(30, 107, 90, 0.36);
  background: #f0faf6;
}
.datev-section-row.partial {
  border-color: rgba(176, 123, 0, 0.42);
  background: #fff8e6;
}
.datev-section-row.permanent-diff {
  border-color: rgba(217, 119, 6, 0.52);
  background: #fff8ed;
  box-shadow: inset 4px 0 0 #d97706, 0 1px 6px rgba(217, 119, 6, 0.1);
}
.datev-section-row.permanent-diff:hover {
  border-color: rgba(217, 119, 6, 0.72);
  background: #fff2dd;
}
.datev-section-row.permanent-diff input {
  accent-color: #d97706;
}
.datev-section-row.permanent-diff-excluded input {
  border-radius: 4px;
  box-shadow: 0 0 0 4px rgba(217, 119, 6, 0.14);
}
.datev-section-row.permanent-diff-included input {
  box-shadow: 0 0 0 4px rgba(217, 119, 6, 0.16);
}
.datev-section-row.changed {
  border-color: rgba(214, 158, 46, 0.72);
  background: #fff9e8;
  box-shadow: inset 4px 0 0 #f2b705, 0 1px 6px rgba(180, 127, 0, 0.08);
}
.datev-section-row.changed:hover {
  border-color: rgba(214, 158, 46, 0.9);
  box-shadow: inset 4px 0 0 #f2b705, 0 2px 8px rgba(180, 127, 0, 0.12);
}
.datev-section-row.changed input {
  accent-color: #e8a900;
}
.datev-section-row.changed-excluded input {
  border-radius: 4px;
  box-shadow: 0 0 0 4px rgba(242, 183, 5, 0.16);
}
.datev-section-row.changed-included input {
  box-shadow: 0 0 0 4px rgba(242, 183, 5, 0.18);
}
.datev-section-name {
  align-self: center;
  min-width: 0;
  color: #09283d;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.012em;
  line-height: 1.22;
  overflow-wrap: anywhere;
  text-align: left;
  text-transform: uppercase;
  white-space: normal;
}
.datev-section-problem-badge {
  grid-column: 2;
  justify-self: start;
  margin-top: 5px;
  padding: 2px 7px;
  border-radius: 999px;
  background: rgba(185, 92, 16, 0.11);
  color: #9a4d0f;
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1.25;
}
.datev-section-row.accepted .datev-section-problem-badge {
  background: rgba(30, 107, 90, 0.11);
  color: #1e6b5a;
}
@media (max-width: 1000px) {
  .datev-summary-guidance {
    grid-template-columns: 1fr;
  }
  .datev-summary-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .datev-config-panel {
    grid-template-columns: 1fr;
    max-height: none;
  }
  .datev-config-tab {
    gap: 0.4rem;
    padding: 0.45rem 0.5rem;
    font-size: 0.68rem;
  }
  .datev-config-tab > i {
    font-size: 0.75rem;
  }
  .datev-client-tab-label small {
    display: none;
  }
  .datev-client-menu {
    right: 0;
    width: min(26rem, calc(100vw - 2rem));
  }
  .datev-config-header {
    align-items: stretch;
    flex-direction: column;
  }
  .datev-summary-introduction {
    grid-template-columns: 1fr;
  }
  .datev-summary-metrics {
    grid-template-columns: 1fr;
  }
  .datev-summary-overview-heading,
  .datev-summary-detail-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .datev-sections-apply {
    width: 100%;
  }
}
.ai-converter-badge {
  position: absolute;
  top: 14px;
  right: 18px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: 1px solid rgba(79, 119, 105, 0.24);
  border-radius: 999px;
  background: #eef7f3;
  color: #3f6658;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.2px;
  line-height: 1;
  text-transform: uppercase;
  box-shadow: 0 8px 18px rgba(79, 119, 105, 0.12);
  user-select: none;
}
.ai-converter-badge i {
  font-size: 12px;
  color: #4f7769;
}
.response-message > .phase-action-row {
  position: absolute;
  bottom: 16px;
  left: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transform: translateX(-50%);
}
.phase-action-row .btnfase2 {
  position: static;
  transform: none;
}
.scarica-file .phase-action-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.diagnostics-reopen-button {
  position: relative;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c9d6e8;
  border-radius: 999px;
  background: #ffffff;
  color: #2d5dab;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(38, 54, 77, 0.1);
  transition: background-color 0.2s ease, border-color 0.2s ease,
    transform 0.2s ease;
}
.diagnostics-reopen-button:hover {
  background: #eef4ff;
  border-color: #8fb0dc;
  transform: translateY(-1px);
}
.diagnostics-reopen-button.is-warning,
.diagnostics-reopen-button.is-degraded {
  color: #946200;
  border-color: #e7c368;
  background: #fff8df;
}
.diagnostics-reopen-button.is-warning:hover,
.diagnostics-reopen-button.is-degraded:hover {
  background: #fff1bd;
  border-color: #d6a72a;
}
.diagnostics-reopen-button.is-failed {
  color: #b42333;
  border-color: #f1b9bf;
  background: #fff7f8;
}
.diagnostics-reopen-button.is-failed:hover {
  background: #ffecef;
  border-color: #e58b96;
}
.diagnostics-reopen-count {
  position: absolute;
  top: -6px;
  right: -7px;
  min-width: 15px;
  height: 15px;
  padding: 0 4px;
  border-radius: 999px;
  background: #1f55a8;
  color: #ffffff;
  font-size: 9px;
  font-weight: 900;
  line-height: 15px;
}
.diagnostics-reopen-button.is-failed .diagnostics-reopen-count {
  background: #b42333;
}
.diagnostics-reopen-button.is-warning .diagnostics-reopen-count,
.diagnostics-reopen-button.is-degraded .diagnostics-reopen-count {
  background: #b77900;
}
.contenitore-prospetti .action-button {
  background: linear-gradient(135deg, #5f8476, #49695f);
  box-shadow: 0 10px 22px rgba(95, 132, 118, 0.18);
}
.contenitore-prospetti .action-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #668f80, #4c7065);
  box-shadow: 0 12px 26px rgba(95, 132, 118, 0.24);
}

.btnfase2.blocked-by-datev-sections:disabled,
.btnfase2.blocked-by-datev-sections:disabled * {
  cursor: not-allowed !important;
}
.contenitore,
.headersButtonsprospetti {
  background-color: rgb(243 243 243 / 99%);
  border: 2px solid rgba(223, 223, 223, 0.82);
}
.headersButtonsprospetti .tool-button i,
.headersButtonsprospetti i {
  color: #5b7068 !important;
}
.headersButtonsprospetti .tool-button i:hover,
.headersButtonsprospetti i:hover {
  color: #465951 !important;
}
.checkcodicicontoIcon {
  color: rgb(96, 186, 102);
}
.skeleton-loader {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}

.skeleton {
  background-color: #e0e0e0;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shimmer 1.5s infinite;
}

.skeleton-title {
  width: 70%;
  height: 24px;
}

.skeleton-text {
  width: 100%;
  height: 16px;
}

.skeleton-button {
  width: 30%;
  height: 36px;
  border-radius: 8px;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.header-with-icon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  position: relative;
}

.header-icon-wrapper {
  position: relative;
  z-index: 30;
  font-size: 0.85em;
  margin-left: 4px;
}
.header-info-tooltip {
  right: -8px;
  left: auto;
  top: calc(100% + 10px);
  bottom: auto;
  z-index: 10050 !important;
  width: 18rem;
  transform: none;
  white-space: pre-line !important;
}
.codcontotable thead,
.codcontotabledatev thead {
  z-index: 5;
}
.lock-icon-table {
  color: #666 !important;
  cursor: pointer;
}

.lock-icon-header {
  color: #a5a5a5;
  cursor: pointer;
}

.info-icon-header {
  color: #979797;
  cursor: pointer;
}
.prospetti-cell-input,
.prospetti-cell-display {
  position: relative;
  width: 100%;
  text-align: left;
}

.prospetti-cell-input--description,
.prospetti-cell-display--description,
.prospetti-cell-input--pdc-custom,
.prospetti-cell-display--pdc-custom {
  display: block;
  box-sizing: border-box;
  padding-right: 1.45rem;
}

.prospetti-cell-input--description .editable-input {
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding-right: 1.45rem;
}

.prospetti-cell-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.description-alias-marker {
  position: absolute;
  top: 50%;
  right: 0.2rem;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 1.1rem;
  height: 1.1rem;
  color: #2874a6;
  cursor: help;
  transform: translateY(-50%);
}

.description-alias-marker i {
  font-size: 0.82rem;
  line-height: 1;
}

.description-alias-marker:hover,
.description-alias-marker:focus-within {
  color: #155f92;
}

.pdc-client-custom-cell {
  position: relative;
  z-index: 0;
  background: rgba(217, 119, 6, 0.09) !important;
}

.pdc-client-custom-marker {
  position: absolute;
  top: 50%;
  right: 0.2rem;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 999px;
  background: rgba(217, 119, 6, 0.14);
  color: #b45309;
  cursor: help;
  transform: translateY(-50%);
}

.pdc-client-custom-marker i {
  font-size: 0.75rem;
  line-height: 1;
}

.pdc-client-custom-marker--pending {
  background: rgba(107, 114, 128, 0.14);
  color: #6b7280;
}

.description-alias-floating-tooltip {
  position: fixed;
  z-index: 10000;
  width: max-content;
  max-width: 18rem;
  padding: 0.55rem 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  background: #102a43;
  box-shadow: 0 8px 22px rgba(16, 42, 67, 0.28);
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 500;
  line-height: 1.35;
  pointer-events: none;
  text-align: left;
  white-space: normal;
}

.description-alias-floating-tooltip--below {
  transform: translateX(-50%);
}

.description-alias-floating-tooltip--above {
  transform: translate(-50%, -100%);
}

.desc-originale {
  display: block;
  margin-top: 0.2rem;
  font-weight: 700;
}
.input-editable {
  width: 90%;
  min-height: 1.65rem;
  padding: 0.24rem 0.46rem;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  background: #ffffff;
  font-size: 0.9em;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.input-editable:focus {
  border-color: #7aa7d9;
  outline: none;
  box-shadow: 0 0 0 2px rgba(35, 103, 173, 0.14);
}

.client-table td {
  padding: 8px 10px;
}
.filled-input {
  background-color: #f8f9fa;
  border: 1px solid #6c757d;
  color: #212529;
}

.filled-input:focus {
  outline: 2px solid #0d6efd;
  background-color: white;
}
.invalid-input {
  border-color: #e74c3c !important;
  background-color: #fff5f5;
}

.error-text {
  color: #e74c3c;
  font-size: 0.75rem;
  display: block;
  margin-top: 4px;
}

@media (max-width: 520px) {
  .ai-converter-badge {
    top: 42px;
    right: 14px;
    padding: 5px 8px;
  }
}
</style>
